import { ClientError } from 'graphql-request';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sdk } from '../client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: unknown;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: Record<string, unknown>;
  /** The `Upload` scalar type represents a file upload. */
  Upload: File;
};

export type AcceptComplianceTermsResult =
  | ComplianceTermsAccepted
  | UserNotInTeam;

export type AccessDeniedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type AcsUrlNotFoundError = {
  acsUrl: Scalars['String'];
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type ActionExecution = {
  actionsEndpointId: Scalars['ID'];
  attemptCount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  failOpen: Scalars['Boolean'];
  id: Scalars['ID'];
  requestBody: Scalars['JSON'];
  requestDurationMs: Scalars['Float'];
  responseBody?: Maybe<Scalars['JSON']>;
  responseSignature?: Maybe<Scalars['String']>;
  responseStatusCode?: Maybe<Scalars['Float']>;
  status: ActionsExecutionStatus;
  statusReason?: Maybe<Scalars['String']>;
  type: ActionsEndpointType;
  updatedAt: Scalars['DateTime'];
  verdict: ActionsExecutionVerdict;
};

export type ActionExecutionsList = {
  data: Array<ActionExecution>;
  listMetadata: ListMetadata;
};

export type ActionsEndpoint = {
  createdAt: Scalars['DateTime'];
  endpointUrl: Scalars['String'];
  failOpen: Scalars['Boolean'];
  id: Scalars['ID'];
  state: ActionsEndpointState;
  type: ActionsEndpointType;
  updatedAt: Scalars['DateTime'];
};

export type ActionsEndpointDeleted = {
  actionsEndpointId: Scalars['String'];
};

/** The state of an actions endpoint. */
export enum ActionsEndpointState {
  Active = 'Active',
  Inactive = 'Inactive',
}

/** The type of an actions endpoint. */
export enum ActionsEndpointType {
  Authentication = 'Authentication',
  UserRegistration = 'UserRegistration',
}

export type ActionsEndpointUpserted = {
  actionsEndpoint: ActionsEndpoint;
};

/** Enum represents the status of an actions execution. */
export enum ActionsExecutionStatus {
  ConnectionFailed = 'ConnectionFailed',
  DnsResolutionFailed = 'DnsResolutionFailed',
  EndpointResponseInvalid = 'EndpointResponseInvalid',
  EndpointResponseTooLarge = 'EndpointResponseTooLarge',
  EndpointReturnedNon2xx = 'EndpointReturnedNon2xx',
  SignatureInvalid = 'SignatureInvalid',
  Succeeded = 'Succeeded',
  TimedOut = 'TimedOut',
}

/** Enum represents the Verdict of an actions execution. */
export enum ActionsExecutionVerdict {
  Allow = 'Allow',
  Deny = 'Deny',
}

export type ActivateUserManagementResult =
  | TeamNotFound
  | UserManagementActivated;

export type ActivationMilestone = {
  createdAt: Scalars['DateTime'];
  environmentId: Scalars['String'];
  id: Scalars['ID'];
  name: ActivationMilestoneName;
  updatedAt: Scalars['DateTime'];
};

/** The names of the achieved activation milestones. */
export enum ActivationMilestoneName {
  FirstApiCall = 'FirstApiCall',
}

export type ActiveAutoMappedCustomAttributes = {
  data: Array<AutoMappedCustomAttribute>;
};

export type ActiveUserAnalytics = {
  byOrg: OrgActiveUsersSummaryResult;
  summary: ActiveUsersSummary;
  timeseries: ActiveUsersTimeseriesResult;
  total: ActiveUsersTotal;
};

export type ActiveUserAnalyticsByOrgArgs = {
  afterId?: InputMaybe<Scalars['String']>;
  kind: OrgSelectionKind;
  orgIds?: InputMaybe<Array<Scalars['String']>>;
  sortBy?: InputMaybe<AnalyticsOrgSort>;
  sortDir?: InputMaybe<AnalyticsSortDirection>;
  top?: InputMaybe<TopN>;
};

export type ActiveUserAnalyticsTimeseriesArgs = {
  granularity: AnalyticsInterval;
};

export type ActiveUserAnalyticsTotalArgs = {
  granularity: AnalyticsInterval;
};

export type ActiveUsersSummary = {
  new: MetricSummary;
  returning: MetricSummary;
  total: MetricSummary;
  updatedAt: Scalars['DateTime'];
};

export type ActiveUsersTimeseries = {
  new: Scalars['Float'];
  returning: Scalars['Float'];
  timestamp: Scalars['DateTime'];
  total: Scalars['Float'];
};

export type ActiveUsersTimeseriesResult = {
  list: Array<ActiveUsersTimeseries>;
  updatedAt: Scalars['DateTime'];
};

export type ActiveUsersTotal = {
  timeseries: Array<ActiveUsersTotalTimeseries>;
  total: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type ActiveUsersTotalTimeseries = {
  timestamp: Scalars['DateTime'];
  total: Scalars['Float'];
};

export type AddAdpConnectionSslCertificateInput = {
  connectionId: Scalars['String'];
  privateKey: Scalars['String'];
  value: Scalars['String'];
};

export type AddAdpConnectionSslCertificateResult =
  | AdpConnectionSslCertificateAdded
  | ConnectionNotFound
  | InvalidAdpConnectionSslCertificate;

export type AddBillingAddressInput = {
  billingAddress: BillingAddressInput;
};

export type AddBillingAddressResult = BillingAddressAdded;

export type AddDomainsResult =
  | ConsumerDomainForbidden
  | DomainsAdded
  | ExistingNonVerifiedDomain
  | OrganizationDomainAlreadyInUse;

export type AddOrganizationAdminInput = {
  email: Scalars['String'];
  organizationId: Scalars['String'];
};

export type AddOrganizationAdminResult =
  | InvalidEmail
  | OrganizationAdminAdded
  | OrganizationAlreadyHasAdmin
  | OrganizationNotFound;

export type AddOrganizationAdminsInput = {
  emails: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};

export type AddOrganizationAdminsResult =
  | InvalidEmail
  | OrganizationAdminsResult
  | OrganizationNotFound
  | TooManyOrganizationAdmins;

export type AddOrganizationDomainsInput = {
  domains: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};

export type AddPaymentMethodInput = {
  billingEmail: Scalars['String'];
  stripePaymentMethodId: Scalars['String'];
};

export type AddPaymentMethodResult =
  | PaymentMethodAdded
  | SetupIntentRequiresAction
  | StripeCardError;

export type AddRadarListEntryInput = {
  action: RadarListAction;
  environmentId?: InputMaybe<Scalars['String']>;
  type: RadarBlocklistType;
  value: Scalars['String'];
};

export type AddRadarListEntryResult = RadarListEntryOperationSuccess;

export type AddTaxIdResult = TaxIdAdded | TaxIdInvalid;

export type AddTaxIdToTeamInput = {
  countryCode: TaxIdCountryCode;
  teamId: Scalars['String'];
  type: TaxIdType;
  value: Scalars['String'];
};

export type AddUserlandUserToOrganizationInput = {
  organizationId: Scalars['String'];
  roleId?: InputMaybe<Scalars['String']>;
  userlandUserId: Scalars['String'];
};

export type AddUserlandUserToOrganizationResult =
  | OrganizationNotFound
  | UserlandUserAddedToOrganization
  | UserlandUserAlreadyInvited
  | UserlandUserNotFound;

export type AddUsersToTeamInput = {
  users: Array<UserInviteInput>;
};

export type AddUsersToTeamPayload = {
  /** The list of memberships of the users that were just invited to the team. */
  invitedMembers?: Maybe<Array<UsersTeam>>;
};

export type AdminPortalCustomBrandingAssetUploadUrlRetrieved = {
  fields: CreatePresignedPostResponseFields;
  url: Scalars['String'];
};

export type AdpConnectionSslCertificate = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type AdpConnectionSslCertificateAdded = {
  adpConnectionSslCertificate: AdpConnectionSslCertificate;
};

export type AdpConnectionSslCertificateDeleted = {
  certificateId: Scalars['String'];
};

export type AdpConnectionSslCertificateNotFound = {
  certificateId: Scalars['String'];
};

export type AggregateRadarDetectionIdentifiers = {
  countries: Array<AggregateRadarDetectionsByIdentifier>;
  domains: Array<AggregateRadarDetectionsByIdentifier>;
  ipAddresses: Array<AggregateRadarDetectionsByIdentifier>;
  locations: Array<AggregateRadarDetectionsByIdentifier>;
  users: Array<AggregateRadarDetectionsByIdentifier>;
};

export type AggregateRadarDetections = {
  allowed: Scalars['Float'];
  allowedDelta?: Maybe<Scalars['Float']>;
  blocked: Scalars['Float'];
  blockedDelta?: Maybe<Scalars['Float']>;
  challenged: Scalars['Float'];
  challengedDelta?: Maybe<Scalars['Float']>;
  data: Array<AggregateRadarDetectionsData>;
  detectionTotalsByType: Array<AggregateRadarDetectionsByType>;
  totalDetections: Scalars['Float'];
  totalDetectionsDelta?: Maybe<Scalars['Float']>;
};

export type AggregateRadarDetectionsByIdentifier = {
  identifier: Scalars['String'];
  percentage: Scalars['Float'];
  totalDetections: Scalars['Float'];
};

export type AggregateRadarDetectionsByType = {
  allowed: Scalars['Float'];
  blocked: Scalars['Float'];
  challenged: Scalars['Float'];
  detection: Scalars['String'];
  total: Scalars['Float'];
};

export type AggregateRadarDetectionsData = {
  allowed: Scalars['Float'];
  blocked: Scalars['Float'];
  breakdownByDetection: Array<AggregateRadarDetectionsByType>;
  challenged: Scalars['Float'];
  timestamp: Scalars['String'];
  total: Scalars['Float'];
};

/** Enum represents the time range of the aggregated data. */
export enum AggregateRadarDetectionsTimeRange {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
}

/** Time granularity for analytics timeseries data. */
export enum AnalyticsInterval {
  Daily = 'Daily',
  Hourly = 'Hourly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export type AnalyticsOrg = {
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Sort by column for the organization analytics queries */
export enum AnalyticsOrgSort {
  NewUsers = 'NewUsers',
  ReturningUsers = 'ReturningUsers',
  TotalUsers = 'TotalUsers',
}

/** Sort by direction for analytics queries */
export enum AnalyticsSortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}

export type ApiKey = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  obfuscatedValue: Scalars['String'];
  permissionSlugs: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ApiKeyList = {
  data: Array<ApiKey>;
  listMetadata: ListMetadata;
};

export type AppBranding = {
  authkitLogoStyle?: Maybe<LogoStyle>;
  authkitShowLastUsedBadge: Scalars['Boolean'];
  authkitSignInContentPanelAlignment?: Maybe<AuthKitPageContentPanelAlignment>;
  authkitSignInContentPanelHiddenOnMobile?: Maybe<Scalars['Boolean']>;
  authkitSignInCustomCss?: Maybe<Scalars['String']>;
  authkitSignInCustomHtml?: Maybe<Scalars['String']>;
  authkitSignInHeadingLocalized?: Maybe<Scalars['JSON']>;
  authkitSignInHeadingText?: Maybe<Scalars['String']>;
  authkitSignInLayout?: Maybe<AuthKitPageLayout>;
  authkitSignInLegalText?: Maybe<Scalars['String']>;
  authkitSignInLinkTextLocalized?: Maybe<Scalars['JSON']>;
  authkitSignInPrivacyPolicyUrl?: Maybe<Scalars['String']>;
  authkitSignInTermsOfServiceUrl?: Maybe<Scalars['String']>;
  authkitSignUpActionLinkText?: Maybe<Scalars['String']>;
  authkitSignUpContentPanelAlignment?: Maybe<AuthKitPageContentPanelAlignment>;
  authkitSignUpContentPanelHiddenOnMobile?: Maybe<Scalars['Boolean']>;
  authkitSignUpCustomCss?: Maybe<Scalars['String']>;
  authkitSignUpCustomHtml?: Maybe<Scalars['String']>;
  authkitSignUpHeadingLocalized?: Maybe<Scalars['JSON']>;
  authkitSignUpHeadingText?: Maybe<Scalars['String']>;
  authkitSignUpLayout?: Maybe<AuthKitPageLayout>;
  authkitSignUpLegalText?: Maybe<Scalars['String']>;
  authkitSignUpLinkText?: Maybe<Scalars['String']>;
  authkitSignUpLinkTextLocalized?: Maybe<Scalars['JSON']>;
  authkitSignUpPrivacyPolicyUrl?: Maybe<Scalars['String']>;
  authkitSignUpShowNameFields?: Maybe<Scalars['Boolean']>;
  authkitSignUpTermsOfServiceUrl?: Maybe<Scalars['String']>;
  customCssElements?: Maybe<CustomCssElements>;
  darkButtonBackgroundColor?: Maybe<Scalars['String']>;
  darkButtonForegroundColor?: Maybe<Scalars['String']>;
  darkFaviconPath?: Maybe<Scalars['String']>;
  darkLinkColor?: Maybe<Scalars['String']>;
  darkLogoIconPath?: Maybe<Scalars['String']>;
  darkLogoPath?: Maybe<Scalars['String']>;
  darkPageBackgroundColor?: Maybe<Scalars['String']>;
  emailLogoStyle?: Maybe<LogoStyle>;
  font?: Maybe<Font>;
  id: Scalars['ID'];
  inviteAdminReplyToEmail?: Maybe<Scalars['String']>;
  lightButtonBackgroundColor?: Maybe<Scalars['String']>;
  lightButtonForegroundColor?: Maybe<Scalars['String']>;
  lightFaviconPath?: Maybe<Scalars['String']>;
  lightLinkColor?: Maybe<Scalars['String']>;
  lightLogoIconPath?: Maybe<Scalars['String']>;
  lightLogoPath?: Maybe<Scalars['String']>;
  lightPageBackgroundColor?: Maybe<Scalars['String']>;
  logoIconFit?: Maybe<LogoIconFit>;
  radius?: Maybe<Radius>;
  theme?: Maybe<Theme>;
};

export type AppBrandingNotFound = {
  appBrandingId: Scalars['String'];
};

export type AppBrandingUpdated = {
  appBranding: AppBranding;
};

export type AppBrandingUploadAssetsError = {
  errorMessage: Scalars['String'];
};

export type Application = {
  clientConfidentiality: ApplicationClientConfidentiality;
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credentials: Array<ApplicationCredential>;
  darkLogoPath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isClientIdMetadataDocument: Scalars['Boolean'];
  isFirstParty: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lightLogoPath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  redirectUris: Array<RedirectUri>;
  type: ApplicationType;
  updatedAt: Scalars['DateTime'];
};

export type ApplicationAssetUploadError = {
  message: Scalars['String'];
};

/** The confidentiality of an application client. */
export enum ApplicationClientConfidentiality {
  Confidential = 'Confidential',
  Public = 'Public',
}

export type ApplicationConfigs = {
  allowedLogoutUrls?: Maybe<Array<Scalars['String']>>;
  allowedOrigins?: Maybe<Array<Scalars['String']>>;
  callbacks?: Maybe<Array<Scalars['String']>>;
};

export type ApplicationCreated = {
  application: Application;
};

export type ApplicationCredential = {
  applicationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  secretHint: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ApplicationCredentialCreated = {
  applicationCredential: ApplicationCredential;
};

export type ApplicationCredentialDeleted = {
  id: Scalars['String'];
};

export type ApplicationCredentialNotFound = {
  applicationCredentialId: Scalars['String'];
};

export type ApplicationDeleted = {
  id: Scalars['String'];
};

/** The integration method for the application. */
export enum ApplicationIntegrationType {
  M2M = 'M2M',
  OAuth = 'OAuth',
}

export type ApplicationList = {
  data: Array<Application>;
  listMetadata: ListMetadata;
};

export type ApplicationNotFound = {
  applicationId: Scalars['String'];
};

/** The registration method of the application. */
export enum ApplicationRegistration {
  Authenticated = 'Authenticated',
  Dynamic = 'Dynamic',
}

/** The type of an application. */
export enum ApplicationType {
  M2M = 'M2M',
  OAuth = 'OAuth',
}

export type ApplicationUpdated = {
  application: Application;
};

export type ApproveWaitlistEntryInput = {
  id: Scalars['String'];
};

export type ApproveWaitlistEntryResult =
  | WaitlistEntryApproveError
  | WaitlistEntryApproved;

export type AssignRoleToInternalDirectoryGroup =
  | InternalDirectoryGroupNotFound
  | RoleAssignedToInternalDirectoryGroup;

export type AssignRoleToInternalDirectoryGroupInput = {
  internalDirectoryGroupId: Scalars['String'];
  role: UsersOrganizationsRole;
};

export type AttributeMap = {
  attributes: Attributes;
  id: Scalars['ID'];
};

export type AttributeSchema = {
  /** The attribute schema structure describing the types of user attributes in the directory. */
  schema: Scalars['JSON'];
};

export type Attributes = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  groups?: Maybe<Scalars['String']>;
  idpId: Scalars['String'];
  lastName: Scalars['String'];
};

export type AuditLogActionAlreadyExists = {
  action: Scalars['String'];
  message: Scalars['String'];
};

export type AuditLogEvent = {
  action: Scalars['String'];
  actor: AuditLogEventActor;
  createdAt: Scalars['DateTime'];
  data: Scalars['JSON'];
  id: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  targets: Array<AuditLogEventTarget>;
  updatedAt: Scalars['DateTime'];
};

export type AuditLogEventActor = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AuditLogEventList = {
  data: Array<AuditLogEvent>;
  listMetadata: ListMetadata;
};

export type AuditLogEventTarget = {
  type: Scalars['String'];
};

export type AuditLogExport = {
  id: Scalars['ID'];
  state: AuditLogExportState;
  url?: Maybe<Scalars['String']>;
};

export enum AuditLogExportState {
  Error = 'Error',
  Pending = 'Pending',
  Ready = 'Ready',
}

export type AuditLogSchemaPreview = {
  schema: Scalars['JSON'];
};

export type AuditLogStream = {
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  state: AuditLogStreamState;
  type: AuditLogStreamDestination;
};

export type AuditLogStreamConfigured = {
  auditLogStream: AuditLogStream;
};

export type AuditLogStreamDeleted = {
  auditLogStream: AuditLogStream;
};

export type AuditLogStreamDestination =
  | AzureSentinelLogStream
  | DatadogLogStream
  | GenericHttpsLogStream
  | GoogleCloudStorageLogStream
  | S3LogStream
  | SplunkLogStream;

export type AuditLogStreamNotFound = {
  auditLogStreamId: Scalars['String'];
};

export enum AuditLogStreamState {
  Active = 'Active',
  Error = 'Error',
  Inactive = 'Inactive',
  Invalid = 'Invalid',
}

export enum AuditLogStreamType {
  AzureSentinel = 'AzureSentinel',
  Datadog = 'Datadog',
  GenericHttps = 'GenericHttps',
  GoogleCloudStorage = 'GoogleCloudStorage',
  S3 = 'S3',
  Splunk = 'Splunk',
}

export type AuditLogTarget = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  target: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AuditLogTargetList = {
  data: Array<AuditLogTarget>;
  listMetadata: ListMetadata;
};

export type AuditLogTrail = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  retentionPeriodInDays: Scalars['Int'];
  state: AuditLogTrailState;
  updatedAt: Scalars['DateTime'];
};

/** Enum represents the different Audit Log Trail states. */
export enum AuditLogTrailState {
  Active = 'Active',
  Disabled = 'Disabled',
  Inactive = 'Inactive',
}

export type AuditLogValidator = {
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  environmentId: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  versions: Array<AuditLogValidatorVersion>;
};

export type AuditLogValidatorCreated = {
  auditLogValidator: AuditLogValidator;
};

export type AuditLogValidatorDeleted = {
  auditLogValidator: AuditLogValidator;
};

export type AuditLogValidatorList = {
  data: Array<AuditLogValidator>;
  listMetadata: ListMetadata;
};

export type AuditLogValidatorNotFound = {
  auditLogValidatorId: Scalars['String'];
};

export type AuditLogValidatorVersion = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  schema: Scalars['JSON'];
  targets: Array<AuditLogTarget>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Float'];
};

export type AuditLogValidatorVersionCreated = {
  auditLogValidatorVersion: AuditLogValidatorVersion;
};

export type AuditLogValidatorVersionDeleted = {
  auditLogValidatorVersion: AuditLogValidatorVersion;
};

export type AuditLogValidatorVersionNotFound = {
  auditLogValidatorVersionId: Scalars['String'];
};

export type AuditTrailEvent = {
  action: EventAction;
  actor: AuditTrailEventActor;
  group: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  location: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  metadata?: Maybe<Scalars['JSON']>;
  occurredAt: Scalars['DateTime'];
  target: AuditTrailEventTarget;
  type?: Maybe<Scalars['String']>;
};

export type AuditTrailEventActor = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AuditTrailEventList = {
  data: Array<AuditTrailEvent>;
  listMetadata: ListMetadata;
};

export type AuditTrailEventTarget = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Auth0Connection = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Auth0Credential = {
  apiDomain: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  connection?: Maybe<Auth0Connection>;
  id: Scalars['ID'];
};

export type Auth0CredentialInvalid = {
  message: Scalars['String'];
};

export type Auth0CredentialUpdated = {
  auth0Credential: Auth0Credential;
};

export type Auth0ProviderConfig = {
  certificateType?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  hasClientSecret: Scalars['Boolean'];
  hasCnameApiKey: Scalars['Boolean'];
  originDomain?: Maybe<Scalars['String']>;
};

/** Enum represents the type of content panel alignment for AuthKit pages. */
export enum AuthKitPageContentPanelAlignment {
  Left = 'Left',
  Right = 'Right',
}

/** Enum represents the type of layout for AuthKit pages. */
export enum AuthKitPageLayout {
  OneColumn = 'OneColumn',
  TwoColumn = 'TwoColumn',
}

export type AuthenticationFactor = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  type: AuthenticationFactorType;
  updatedAt: Scalars['DateTime'];
};

export type AuthenticationFactorDeleted = {
  id: Scalars['ID'];
};

export type AuthenticationFactorList = {
  data: Array<AuthenticationFactor>;
  listMetadata: ListMetadata;
};

export type AuthenticationFactorNotFound = {
  id: Scalars['ID'];
};

export type AuthenticationFactorType =
  | GenericAuthenticationFactorType
  | SmsAuthenticationFactorType
  | TotpAuthenticationFactorType;

export type AuthkitAnalytics = {
  activeUsers: ActiveUserAnalytics;
};

export type AuthkitDomain = {
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type AuthkitOauthResource = {
  id: Scalars['String'];
  uri: Scalars['String'];
};

export type AuthkitOauthResourceNotFoundError = {
  id: Scalars['String'];
  message: Scalars['String'];
};

export type AuthkitOauthResourcesSet = {
  authkitOauthResources: Array<AuthkitOauthResource>;
};

export type AuthorizationResourceRoleAssignment = {
  createdAt: Scalars['DateTime'];
  resourceExternalId: Scalars['String'];
  resourceId: Scalars['String'];
  resourceTypeSlug: Scalars['String'];
  role: Role;
  roleId: Scalars['String'];
};

export type AuthorizationResourceRoleAssignmentList = {
  data: Array<AuthorizationResourceRoleAssignment>;
  listMetadata: ListMetadata;
};

export type AuthorizationResourceType = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type AuthorizationResourceTypeCreated = {
  resourceType: AuthorizationResourceType;
};

export type AuthorizationResourceTypeDeleted = {
  resourceTypeId: Scalars['ID'];
};

export type AuthorizationResourceTypeHasPermissions = {
  resourceTypeId: Scalars['ID'];
};

export type AuthorizationResourceTypeHasRoles = {
  resourceTypeId: Scalars['ID'];
};

export type AuthorizationResourceTypeList = {
  resourceTypes: Array<AuthorizationResourceTypeWithTopologies>;
};

export type AuthorizationResourceTypeNotFound = {
  resourceTypeId: Scalars['ID'];
};

export type AuthorizationResourceTypeNotInEnvironment = {
  resourceTypeId: Scalars['ID'];
};

export type AuthorizationResourceTypeSlugConflict = {
  slug: Scalars['String'];
};

export type AuthorizationResourceTypeUpdateNotValid = {
  message: Scalars['String'];
};

export type AuthorizationResourceTypeUpdated = {
  resourceType: AuthorizationResourceType;
};

export type AuthorizationResourceTypeWithTopologies = {
  childTypeIds?: Maybe<Array<Scalars['ID']>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentTypeIds?: Maybe<Array<Scalars['ID']>>;
  slug: Scalars['String'];
};

export type AuthorizeErrorWithTestIdpInput = {
  connectionId: Scalars['String'];
  relayState?: InputMaybe<Scalars['String']>;
};

export type AuthorizeWithTestIdpInput = {
  connectionId: Scalars['String'];
  customAttributes?: InputMaybe<Scalars['JSON']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  groups?: InputMaybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  relayState?: InputMaybe<Scalars['String']>;
};

export type AuthorizeWithTestIdpPayload = {
  callbackUrl: Scalars['String'];
};

export type AutoMappedCustomAttribute = {
  active: Scalars['Boolean'];
  attributeKey: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  name: AutoMappedCustomAttributeName;
};

/** Enum represents the name of auto-mapped custom attribute. */
export enum AutoMappedCustomAttributeName {
  Addresses = 'Addresses',
  CostCenterName = 'CostCenterName',
  DepartmentName = 'DepartmentName',
  DisplayName = 'DisplayName',
  DivisionName = 'DivisionName',
  Emails = 'Emails',
  EmployeeNumber = 'EmployeeNumber',
  EmployeeType = 'EmployeeType',
  EmploymentStartDate = 'EmploymentStartDate',
  JobTitle = 'JobTitle',
  ManagerEmail = 'ManagerEmail',
  ManagerId = 'ManagerId',
  ManagerName = 'ManagerName',
  Organization = 'Organization',
  PhoneNumbers = 'PhoneNumbers',
  Username = 'Username',
}

export type AwsSesCustomEmailProvider = CustomEmailProvider & {
  awsSesRegion: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type AzureSentinelLogStream = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  dataCollectionEndpointUrl?: Maybe<Scalars['String']>;
  dataCollectionRuleId?: Maybe<Scalars['String']>;
  streamName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type BambooHrDirectory = {
  apiKey?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Scalars['String']>>;
  subdomain?: Maybe<Scalars['String']>;
};

export type BillingAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type BillingAddressAdded = {
  team: Team;
};

export type BillingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

/** Enum represents the payment status for a detailed invoice. */
export enum BillingInvoicePaymentStatus {
  Failed = 'Failed',
  Paid = 'Paid',
  Pending = 'Pending',
}

export type BillingPaymentHistory = {
  items: Array<BillingPaymentHistoryItem>;
};

export type BillingPaymentHistoryItem = {
  additionalFeatureKeys: Array<Scalars['String']>;
  billingPeriodStart: Scalars['DateTime'];
  connectionCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  paymentStatus: BillingInvoicePaymentStatus;
  total: Scalars['Float'];
};

export type BindManagedListToEnvironmentInput = {
  action: RadarListAction;
  environmentId?: InputMaybe<Scalars['String']>;
  listId: Scalars['String'];
};

export type BindManagedListToEnvironmentResult =
  RadarListBindingOperationSuccess;

export type BotDetection = {
  decision: RadarDecision;
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
};

export type BreatheHrDirectory = {
  apiKey?: Maybe<Scalars['String']>;
};

export type BruteForceAttack = {
  decision: RadarDecision;
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
};

export type BuildTestSamlResponseInput = {
  connectionId: Scalars['String'];
  customAttributes?: InputMaybe<Scalars['JSON']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  groups?: InputMaybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
};

export type BuildTestSamlResponsePayload = {
  samlResponse: Scalars['String'];
};

export type CancelStripeConnectResult = CancelStripeConnectSuccess;

export type CancelStripeConnectSuccess = {
  environment: Environment;
};

export type CezanneHrDirectory = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<Scalars['String']>>;
};

export type CheckEmailSuppressionInput = {
  email: Scalars['String'];
  environmentId: Scalars['ID'];
};

export type ClaimOneShotEnvironmentInput = {
  /** The name for the claimed environment */
  environmentName: Scalars['String'];
  /** The nonce from the claim-nonces endpoint */
  nonce: Scalars['String'];
};

export type ClaimOneShotEnvironmentResult =
  | InvalidClaimNonce
  | OneShotEnvironmentAlreadyClaimed
  | OneShotEnvironmentClaimed
  | OneShotEnvironmentNameAlreadyInUse
  | OneShotEnvironmentNotFound;

export type CloudflareDomainConfigured = {
  customerMigration: CustomerMigration;
  verificationDetails: DomainVerificationDetails;
};

export type CompleteCustomerMigrationSetupError = {
  message: Scalars['String'];
};

export type CompleteCustomerMigrationSetupInput = {
  customerMigrationId: Scalars['ID'];
};

export type CompleteCustomerMigrationSetupResult =
  | CompleteCustomerMigrationSetupError
  | CompleteCustomerMigrationSetupSuccess
  | CustomerMigrationNotFoundForConnections;

export type CompleteCustomerMigrationSetupSuccess = {
  customerMigration: CustomerMigration;
};

export type CompleteOnboardingGuideInput = {
  guide: OnboardingGuide;
};

export type CompleteOnboardingResult = OnboardingGuideCompleted;

export type CompleteStripeConnectInput = {
  code?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  errorDescription?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CompleteStripeConnectResult =
  | CompleteStripeConnectSuccess
  | InvalidStripeConnectOAuthState
  | MissingCode
  | StripeConnectAuthorizationError
  | StripeError;

export type CompleteStripeConnectSuccess = {
  environment: Environment;
};

export type ComplianceExport = {
  type: ComplianceExportType;
  url: Scalars['String'];
};

export type ComplianceExportCreated = {
  complianceExport: ComplianceExport;
};

export type ComplianceExportNotFound = {
  type: ComplianceExportType;
};

/** The types of compliance reports that can be exported. */
export enum ComplianceExportType {
  PenTest = 'PenTest',
  SecurityQuestionnaire = 'SecurityQuestionnaire',
  Soc2 = 'Soc2',
  Soc2BridgeLetter = 'Soc2BridgeLetter',
  Soc3 = 'Soc3',
}

export type ComplianceTermsAccepted = {
  teamMembership: UsersTeam;
};

export type Configuration = {
  botDetection: BotDetection;
  bruteForceAttack: BruteForceAttack;
  credentialStuffing: CredentialStuffing;
  fasterThanPossibleTravel: FasterThanPossibleTravel;
  repeatSignUp: RepeatSignUp;
  staleAccount: StaleAccount;
  unrecognizedDevice: UnrecognizedDevice;
};

export type ConfigureAuditLogStreamResult =
  | AuditLogStreamConfigured
  | AuditLogStreamNotFound
  | InvalidAuditLogStreamCredentials;

export type ConfigureAzureSentinelLogStreamInput = {
  auditLogStreamId: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  dataCollectionEndpointUrl: Scalars['String'];
  dataCollectionRuleId: Scalars['String'];
  streamName: Scalars['String'];
  tenantId: Scalars['String'];
};

export type ConfigureCloudflareDomainError = {
  message: Scalars['String'];
};

export type ConfigureCloudflareDomainInput = {
  cnameApiKey?: InputMaybe<Scalars['String']>;
  customerMigrationId: Scalars['String'];
};

export type ConfigureCloudflareDomainResult =
  | CloudflareDomainConfigured
  | ConfigureCloudflareDomainError
  | CustomerMigrationNotFoundForDomain;

export type ConfigureDatadogLogStreamWithRegionInput = {
  apiKey: Scalars['String'];
  auditLogStreamId: Scalars['String'];
  region: DatadogRegion;
};

export type ConfigureGenericHttpsLogStreamInput = {
  auditLogStreamId: Scalars['String'];
  authHeaderName: Scalars['String'];
  authHeaderValue: Scalars['String'];
  requestBodyFormat: GenericHttpsLogStreamRequestBodyFormat;
  url: Scalars['String'];
};

export type ConfigureGoogleCloudStorageLogStreamInput = {
  accessKeyId?: InputMaybe<Scalars['String']>;
  auditLogStreamId: Scalars['String'];
  bucketName: Scalars['String'];
  bucketPath?: InputMaybe<Scalars['String']>;
  secretAccessKey?: InputMaybe<Scalars['String']>;
};

export type ConfigureS3LogStreamInput = {
  accountId: Scalars['String'];
  auditLogStreamId: Scalars['String'];
  bucketName: Scalars['String'];
  bucketPath?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  roleName: Scalars['String'];
};

export type ConfigureSplunkLogStreamInput = {
  auditLogStreamId: Scalars['String'];
  hecToken: Scalars['String'];
  url: Scalars['String'];
};

export type Connection = {
  adpConnectionSslCertificates: Array<AdpConnectionSslCertificate>;
  attributeMap?: Maybe<AttributeMap>;
  createdAt: Scalars['DateTime'];
  customAttributesWithMappings: SsoCustomAttributeWithMappingList;
  id: Scalars['ID'];
  importedId?: Maybe<Scalars['String']>;
  latestExpiredCertificate?: Maybe<SamlX509Certificate>;
  latestExpiringCertificate?: Maybe<SamlX509Certificate>;
  name: Scalars['String'];
  oauthCredential?: Maybe<OAuthCredential>;
  oauthSessions: OAuthSessionsList;
  oidcSessionEmails: Array<Scalars['String']>;
  oidcSessions: OidcSessionsList;
  oidc_client_id?: Maybe<Scalars['String']>;
  oidc_client_secret?: Maybe<Scalars['String']>;
  oidc_discovery_endpoint?: Maybe<Scalars['String']>;
  oidc_redirect_uri?: Maybe<Scalars['String']>;
  oidc_return_provider_tokens?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  profiles: ProfileList;
  saml: SamlConnection;
  samlRelyingPartyTrusts: Array<SamlRelyingPartyTrust>;
  samlSessionEmails: Array<Scalars['String']>;
  samlSessions: SamlSessionsList;
  samlX509Certificates: Array<SamlX509Certificate>;
  saml_acs_url: Scalars['String'];
  saml_entity_id?: Maybe<Scalars['String']>;
  saml_idp_metadata_url?: Maybe<Scalars['String']>;
  saml_idp_url?: Maybe<Scalars['String']>;
  saml_sp_metadata_url: Scalars['String'];
  state: ConnectionState;
  summary: ConnectionSummary;
  type: ConnectionType;
  updatedAt: Scalars['DateTime'];
};

export type ConnectionOauthSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OAuthSessionState>;
};

export type ConnectionOidcSessionEmailsArgs = {
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};

export type ConnectionOidcSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  initiator?: InputMaybe<OidcSessionInitiator>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OidcSessionState>;
  states?: InputMaybe<Array<OidcSessionState>>;
};

export type ConnectionProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type ConnectionSamlSessionEmailsArgs = {
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};

export type ConnectionSamlSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  initiator?: InputMaybe<SamlSessionInitiator>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<SamlSessionState>;
  states?: InputMaybe<Array<SamlSessionState>>;
};

/** Enum represents the state of the connection certificate. */
export enum ConnectionCertificateState {
  Expired = 'Expired',
  Expiring = 'Expiring',
}

export type ConnectionCreated = {
  connection: Connection;
};

export type ConnectionGroup = {
  connectionId: Scalars['String'];
  groupRoleMapping?: Maybe<GroupRoleMapping>;
  id: Scalars['String'];
  idpId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type ConnectionGroupAlreadyExists = {
  connectionId: Scalars['String'];
  idpId: Scalars['String'];
};

export type ConnectionGroupCreated = {
  connectionGroup: ConnectionGroup;
};

export type ConnectionGroupDeleted = {
  connectionGroupId: Scalars['String'];
};

export type ConnectionGroupNotFound = {
  connectionGroupId: Scalars['String'];
};

export type ConnectionGroupUpdated = {
  connectionGroup: ConnectionGroup;
};

export type ConnectionGroupWithRoleMappingCreated = {
  connectionGroup: ConnectionGroup;
  groupRoleMapping?: Maybe<GroupRoleMapping>;
};

export type ConnectionGroupsList = {
  data: Array<ConnectionGroup>;
  listMetadata: ListMetadata;
};

export type ConnectionList = {
  data: Array<Connection>;
  listMetadata: ListMetadata;
};

export type ConnectionNotFound = {
  connectionId: Scalars['String'];
};

export type ConnectionOrUntypedConnection = Connection | UntypedConnection;

export type ConnectionSession = OAuthSession | OidcSession | SamlSession;

export type ConnectionSessionError =
  | AccessDeniedError
  | AcsUrlNotFoundError
  | DecryptionFailedError
  | DecryptionMalformedEncryptedAssertionError
  | DecryptionMissingEncryptionKeyError
  | IdTokenInvalidError
  | IdpIdInvalidError
  | IdpInitiatedExpiredResponseError
  | IdpInitiatedWithBookmarkError
  | IdpInitiatedWithInResponseToError
  | IdpStatusCodeAuthenticationFailedError
  | IdpStatusCodeInvalidNameIdPolicyError
  | IdpStatusCodeInvalidSamlRequestSignatureError
  | IdpStatusCodeNotSuccessfulError
  | IdpStatusCodeRequestDeniedError
  | InvalidAssertionError
  | InvalidAttributesError
  | InvalidAudienceError
  | InvalidEmailError
  | InvalidIssueInstantAssertionError
  | InvalidIssuerError
  | InvalidRelayStateError
  | InvalidSamlSchemaError
  | InvalidSamlSignatureError
  | InvalidX509CertError
  | MalformedSamlResponseError
  | MissingSamlEntityIdError
  | MissingSamlIdpUrlError
  | MissingSamlRelyingPartyPrivateKeyError
  | OidcFailedError
  | ProfileNotAllowedOutsideOrganizationError
  | ResponseReplayedError
  | SamlAssertionMissingSignaturesError
  | SamlResponseMissingAssertionError
  | WorkOsAuthorizationCodeAlreadyExchangedError
  | WorkOsAuthorizationCodeExpiredError
  | WorkOsSigninConsentDeniedError;

/** Enum represents the error code of a Connection Session Error. */
export enum ConnectionSessionErrorCode {
  AccessDenied = 'AccessDenied',
  AcsUrlNotFound = 'AcsUrlNotFound',
  DecryptionFailed = 'DecryptionFailed',
  DecryptionMalformedEncryptedAssertion = 'DecryptionMalformedEncryptedAssertion',
  DecryptionMissingEncryptionKey = 'DecryptionMissingEncryptionKey',
  IdTokenInvalid = 'IdTokenInvalid',
  IdpIdInvalid = 'IdpIdInvalid',
  IdpInitiatedExpiredResponse = 'IdpInitiatedExpiredResponse',
  IdpInitiatedWithBookmark = 'IdpInitiatedWithBookmark',
  IdpInitiatedWithInResponseTo = 'IdpInitiatedWithInResponseTo',
  IdpStatusCodeAuthenticationFailed = 'IdpStatusCodeAuthenticationFailed',
  IdpStatusCodeInvalidNameIdPolicy = 'IdpStatusCodeInvalidNameIdPolicy',
  IdpStatusCodeInvalidSamlRequestSignature = 'IdpStatusCodeInvalidSamlRequestSignature',
  IdpStatusCodeNotSuccessful = 'IdpStatusCodeNotSuccessful',
  IdpStatusCodeRequestDenied = 'IdpStatusCodeRequestDenied',
  InvalidAssertion = 'InvalidAssertion',
  InvalidAttributes = 'InvalidAttributes',
  InvalidAudience = 'InvalidAudience',
  InvalidEmail = 'InvalidEmail',
  InvalidIssueInstantAssertion = 'InvalidIssueInstantAssertion',
  InvalidIssuer = 'InvalidIssuer',
  InvalidRelayState = 'InvalidRelayState',
  InvalidSamlSchema = 'InvalidSamlSchema',
  InvalidSamlSignature = 'InvalidSamlSignature',
  InvalidX509Cert = 'InvalidX509Cert',
  MalformedSamlResponse = 'MalformedSamlResponse',
  MissingSamlEntityId = 'MissingSamlEntityId',
  MissingSamlIdpUrl = 'MissingSamlIdpUrl',
  MissingSamlRelyingPartyPrivateKey = 'MissingSamlRelyingPartyPrivateKey',
  OidcFailed = 'OidcFailed',
  ProfileNotAllowedOutsideOrganization = 'ProfileNotAllowedOutsideOrganization',
  ResponseReplayed = 'ResponseReplayed',
  SamlAssertionMissingSignatures = 'SamlAssertionMissingSignatures',
  SamlResponseMissingAssertion = 'SamlResponseMissingAssertion',
  WorkOsAuthorizationCodeAlreadyExchanged = 'WorkOsAuthorizationCodeAlreadyExchanged',
  WorkOsAuthorizationCodeExpired = 'WorkOsAuthorizationCodeExpired',
  WorkOsSigninConsentDenied = 'WorkOsSigninConsentDenied',
}

/** Enum represents the state of the connection. */
export enum ConnectionState {
  Active = 'Active',
  Deleting = 'Deleting',
  Inactive = 'Inactive',
  Validating = 'Validating',
}

export type ConnectionSummary = {
  groupRoleMappingCount: Scalars['Int'];
};

/** Enum represents the type of connection. */
export enum ConnectionType {
  Adfssaml = 'ADFSSAML',
  AdpOidc = 'AdpOidc',
  AppleOAuth = 'AppleOAuth',
  Auth0Migration = 'Auth0Migration',
  Auth0Saml = 'Auth0SAML',
  AzureSaml = 'AzureSAML',
  BitbucketOAuth = 'BitbucketOAuth',
  CasSaml = 'CasSAML',
  ClassLinkSaml = 'ClassLinkSAML',
  CleverOidc = 'CleverOIDC',
  CloudflareSaml = 'CloudflareSAML',
  CyberArkSaml = 'CyberArkSAML',
  DiscordOAuth = 'DiscordOAuth',
  DuoSaml = 'DuoSAML',
  EntraIdOidc = 'EntraIdOIDC',
  GenericOidc = 'GenericOIDC',
  GenericSaml = 'GenericSAML',
  GitLabOAuth = 'GitLabOAuth',
  GithubOAuth = 'GithubOAuth',
  GoogleOAuth = 'GoogleOAuth',
  GoogleOidc = 'GoogleOIDC',
  GoogleSaml = 'GoogleSAML',
  IntuitOAuth = 'IntuitOAuth',
  JumpCloudSaml = 'JumpCloudSAML',
  KeycloakSaml = 'KeycloakSAML',
  LastPassSaml = 'LastPassSAML',
  LinkedInOAuth = 'LinkedInOAuth',
  LoginGovOidc = 'LoginGovOidc',
  MagicLink = 'MagicLink',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MiniOrangeSaml = 'MiniOrangeSAML',
  NetIqSaml = 'NetIqSAML',
  OktaOidc = 'OktaOIDC',
  OktaSaml = 'OktaSAML',
  OneLoginSaml = 'OneLoginSAML',
  OracleSaml = 'OracleSAML',
  PingFederateSaml = 'PingFederateSAML',
  PingOneSaml = 'PingOneSAML',
  RipplingSaml = 'RipplingSAML',
  SalesforceOAuth = 'SalesforceOAuth',
  SalesforceSaml = 'SalesforceSAML',
  ShibbolethGenericSaml = 'ShibbolethGenericSAML',
  ShibbolethSaml = 'ShibbolethSAML',
  SimpleSamlPhpSaml = 'SimpleSamlPhpSAML',
  SlackOAuth = 'SlackOAuth',
  TestIdp = 'TestIdp',
  VMwareSaml = 'VMwareSAML',
  VercelMarketplaceOAuth = 'VercelMarketplaceOAuth',
  VercelOAuth = 'VercelOAuth',
  XeroOAuth = 'XeroOAuth',
}

export type ConnectionUpdated = {
  connection: Connection;
};

export type ConnectionUpdatedFromDiscoveryEndpoint = {
  connection: Connection;
};

export type ConnectionUpdatedFromMetadataUrl = {
  connection: Connection;
};

export type ConnectionUpdatedFromMetadataXml = {
  connection: Connection;
};

export type ConsumerDomainForbidden = {
  domain: Scalars['String'];
};

export type ContextSchemaResult = {
  result: Scalars['JSON'];
};

export type CreateApplicationCredentialInput = {
  applicationId: Scalars['ID'];
};

export type CreateApplicationCredentialResult =
  | ApplicationCredentialCreated
  | ApplicationNotFound;

export type CreateApplicationInput = {
  clientConfidentiality?: InputMaybe<ApplicationClientConfidentiality>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['ID']>;
  type: ApplicationType;
};

export type CreateApplicationResult = ApplicationCreated | OrganizationNotFound;

export type CreateAuditLogExportInput = {
  actions?: InputMaybe<Array<Scalars['String']>>;
  actorIds?: InputMaybe<Array<Scalars['String']>>;
  actors?: InputMaybe<Array<Scalars['String']>>;
  organizationId: Scalars['String'];
  rangeEnd: Scalars['DateTime'];
  rangeStart: Scalars['DateTime'];
  targetIds?: InputMaybe<Array<Scalars['String']>>;
  targets?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateAuditLogExportResult =
  | AuditLogExport
  | InvalidExportDateRange
  | NoAuditLogEventsFound;

export type CreateAuditLogStreamInput = {
  organizationId: Scalars['String'];
  type: AuditLogStreamType;
};

export type CreateAuditLogStreamResult = AuditLogStream;

export type CreateAuditLogValidatorInput = {
  action: Scalars['String'];
  environmentId: Scalars['String'];
  schema?: InputMaybe<Scalars['JSON']>;
  targets: Array<Scalars['String']>;
};

export type CreateAuditLogValidatorResult =
  | AuditLogActionAlreadyExists
  | AuditLogValidatorCreated
  | InvalidAuditLogAction
  | InvalidAuditLogSchema
  | InvalidAuditLogTargets;

export type CreateAuditLogValidatorVersionInput = {
  auditLogValidatorId: Scalars['String'];
  schema?: InputMaybe<Scalars['JSON']>;
  targets: Array<Scalars['String']>;
};

export type CreateAuditLogValidatorVersionResult =
  | AuditLogValidatorNotFound
  | AuditLogValidatorVersionCreated
  | InvalidAuditLogSchema
  | InvalidAuditLogTargets;

export type CreateAuthorizationResourceTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentTypeIds: Array<Scalars['String']>;
  slug: Scalars['String'];
};

export type CreateAuthorizationResourceTypeResult =
  | AuthorizationResourceTypeCreated
  | AuthorizationResourceTypeSlugConflict
  | EnvironmentNotFound;

export type CreateComplianceExportInput = {
  type: ComplianceExportType;
};

export type CreateComplianceExportResult =
  | ComplianceExportCreated
  | ComplianceExportNotFound
  | UnauthorizedComplianceExport;

export type CreateConnectionGroupInput = {
  connectionId: Scalars['String'];
  idpId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type CreateConnectionGroupResult =
  | ConnectionGroupAlreadyExists
  | ConnectionGroupCreated
  | ConnectionNotFound;

export type CreateConnectionGroupWithRoleMappingInput = {
  connectionId: Scalars['String'];
  idpId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type CreateConnectionGroupWithRoleMappingResult =
  | ConnectionGroupAlreadyExists
  | ConnectionGroupWithRoleMappingCreated
  | ConnectionNotFound
  | RoleNotFound;

export type CreateConnectionInput = {
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  type: ConnectionType;
};

export type CreateConnectionResult =
  | ConnectionCreated
  | OauthConnectionMissingCredentials
  | OrganizationNotFound;

export type CreateCustomDomainInput = {
  domain: Scalars['String'];
  environmentId: Scalars['String'];
  type: CustomDomainType;
};

export type CreateCustomDomainResult =
  | CustomDomainCreated
  | DomainTypeAlreadyExists
  | DomainUnavailable
  | EnvironmentNotFound
  | InvalidCustomDomain;

export type CreateCustomEmailDomainInput = {
  domain: Scalars['String'];
};

export type CreateCustomEmailDomainResult =
  | CustomEmailDomainAlreadyExistForProject
  | CustomEmailDomainCreated
  | InvalidCustomEmailDomain;

export type CreateCustomEmailProviderInput = {
  awsSesRegion?: InputMaybe<Scalars['String']>;
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  mailgunDomain?: InputMaybe<Scalars['String']>;
  mailgunRegion?: InputMaybe<MailgunCustomEmailProviderRegion>;
  providerType: CustomEmailProviderType;
  unencryptedAwsAccessKeyId?: InputMaybe<Scalars['String']>;
  unencryptedAwsSecretAccessKey?: InputMaybe<Scalars['String']>;
  unencryptedMailgunApiKey?: InputMaybe<Scalars['String']>;
  unencryptedPostmarkAccountToken?: InputMaybe<Scalars['String']>;
  unencryptedPostmarkServerToken?: InputMaybe<Scalars['String']>;
  unencryptedResendApiKey?: InputMaybe<Scalars['String']>;
  unencryptedSendGridApiKey?: InputMaybe<Scalars['String']>;
};

export type CreateCustomEmailProviderResult =
  | CustomEmailProviderCreated
  | CustomEmailProviderEmailAddressDomainNotVerifiedErrorList
  | CustomEmailProviderInputError
  | CustomEmailProviderSenderDomainNotVerifiedError
  | MailgunCustomEmailProviderDomainNotVerifiedError;

export type CreateCustomMappedCustomAttributeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateCustomMappedCustomAttributeResult =
  | CustomAttributeInvalid
  | CustomMappedCustomAttributeCreated;

export type CreateCustomerMigrationInput = {
  environmentId: Scalars['String'];
  provider: CustomerMigrationProvider;
};

export type CreateCustomerMigrationResult =
  | CustomerMigrationAlreadyExists
  | CustomerMigrationCreated
  | EnvironmentNotFound;

export type CreateDirectoryConfigDashboardResult =
  | DirectoryConfigAlreadyExistsDashboard
  | DirectoryConfigCreatedDashboard;

export type CreateDirectoryConfigInput = {
  directoryId: Scalars['String'];
  groupsSync: DirectoryConfigGroupsSync;
};

export type CreateEnvironmentInput = {
  isSandbox: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateEnvironmentResponse = {
  environment: Environment;
};

export type CreateFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  slug: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};

export type CreateFlagResult =
  | FlagAlreadyExists
  | FlagCreated
  | FlagSlugInvalid
  | ProjectNotFound;

export type CreateKeyInput = {
  applicationId?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  expireAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type CreateKeyResult = KeyCreated;

export type CreateOauthCredentialsInput = {
  environmentId: Scalars['String'];
  provider: ConnectionType;
};

export type CreateOauthCredentialsPayload = {
  oauthCredentials?: Maybe<OAuthCredential>;
};

export type CreateOrganizationIdpAttributesConfigInput = {
  dsyncCustomAttributeMappingEnabled?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  ssoCustomAttributeMappingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationIdpAttributesConfigResult =
  OrganizationIdpAttributesConfigCreated;

export type CreateOrganizationInput = {
  allowProfilesOutsideOrganization?: InputMaybe<Scalars['Boolean']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  domainsDeveloperVerified?: InputMaybe<Scalars['Boolean']>;
  environmentId: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateOrganizationResult =
  | ConsumerDomainForbidden
  | EnvironmentNotFound
  | ExternalIdAlreadyUsed
  | OrganizationCreated
  | OrganizationDomainAlreadyInUse;

export type CreateOrganizationRoleConfigInput = {
  defaultRole?: InputMaybe<Scalars['String']>;
  dsyncRoleAssignmentEnabled?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  rolePriorityOrder?: InputMaybe<Array<Scalars['String']>>;
  ssoRoleAssignmentEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationRoleConfigResult = OrganizationRoleConfigCreated;

export type CreatePermissionInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  resourceTypeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CreatePermissionResult =
  | AuthorizationResourceTypeNotFound
  | EnvironmentNotFound
  | PermissionAlreadyExists
  | PermissionCreated
  | PermissionSlugInvalid;

export type CreatePresignedPostResponseFields = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  policy: Scalars['String'];
  xAmzAlgorithm: Scalars['String'];
  xAmzCredential: Scalars['String'];
  xAmzDate: Scalars['String'];
  xAmzSignature: Scalars['String'];
};

export type CreateRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  resourceTypeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CreateRoleResult =
  | AuthorizationResourceTypeNotFound
  | AuthorizationResourceTypeNotInEnvironment
  | EnvironmentNotFound
  | OrganizationNotFound
  | PermissionSlugNotFound
  | RoleAlreadyExists
  | RoleCreated;

export type CreateUserlandApplicationInput = {
  appHomepageUrl?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  initiateLoginUri?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  passwordResetUrl?: InputMaybe<Scalars['String']>;
  signUpUrl?: InputMaybe<Scalars['String']>;
  userInvitationUrl?: InputMaybe<Scalars['String']>;
};

export type CreateUserlandApplicationKeyInput = {
  applicationId: Scalars['String'];
  expireAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type CreateUserlandApplicationKeyResult =
  | UserlandApplicationKeyCreated
  | UserlandApplicationNotFound;

export type CreateUserlandApplicationResult =
  | EnvironmentNotFound
  | UserlandApplicationCreated
  | UserlandApplicationValidationFailed;

export type CreateUserlandUserInput = {
  email: Scalars['String'];
  environmentId: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type CreateUserlandUserInviteEmailAlreadyInvitedToEnvironment = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteEmailAlreadyInvitedToOrganization = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteExpiresInDaysTooLong = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteExpiresInDaysTooShort = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteInput = {
  environmentId: Scalars['String'];
  expiresInDays: Scalars['Float'];
  inviteeEmail: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type CreateUserlandUserInviteInvalidInviteeEmail = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteInvalidRole = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteResult =
  | CreateUserlandUserInviteEmailAlreadyInvitedToEnvironment
  | CreateUserlandUserInviteEmailAlreadyInvitedToOrganization
  | CreateUserlandUserInviteExpiresInDaysTooLong
  | CreateUserlandUserInviteExpiresInDaysTooShort
  | CreateUserlandUserInviteInvalidInviteeEmail
  | CreateUserlandUserInviteInvalidRole
  | CreateUserlandUserInviteUserAlreadyExists
  | CreateUserlandUserInviteUserAlreadyOrganizationMember
  | EnvironmentNotFound
  | OrganizationNotFound
  | UserlandUserInviteCreated
  | UserlandUserNotFound;

export type CreateUserlandUserInviteUserAlreadyExists = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserInviteUserAlreadyOrganizationMember = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type CreateUserlandUserResult =
  | EnvironmentNotFound
  | ExternalIdAlreadyUsed
  | PasswordAuthDisabled
  | UserlandUserCreated
  | UserlandUserValidationFailed;

export type CredentialStuffing = {
  decision: RadarDecision;
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
};

export type CustomAdminPortalDomain = {
  domain: Scalars['String'];
  /** Indicates whether this domain was created via self-serve in the dashboard (and therefore supports self-serve deletion, etc.). */
  selfServe: Scalars['Boolean'];
};

export type CustomAttributeInvalid = {
  reason: Scalars['String'];
};

export type CustomAttributeNotFound = {
  customAttributeId: Scalars['String'];
};

/** Enum represents the type of Custom Attribute. */
export enum CustomAttributeType {
  AutoMapped = 'AutoMapped',
  CustomMapped = 'CustomMapped',
}

export type CustomAuthDomain = {
  domain: Scalars['String'];
  /** Indicates whether this domain was created via self-serve in the dashboard (and therefore supports self-serve deletion, etc.). */
  selfServe: Scalars['Boolean'];
};

export type CustomCssElement = {
  css: Scalars['String'];
  resetCss: Scalars['Boolean'];
};

export type CustomCssElementInput = {
  css: Scalars['String'];
  resetCss?: InputMaybe<Scalars['Boolean']>;
};

export type CustomCssElements = {
  authkitBackground?: Maybe<CustomCssElement>;
  authkitButton?: Maybe<CustomCssElement>;
  authkitCallout?: Maybe<CustomCssElement>;
  authkitCard?: Maybe<CustomCssElement>;
  authkitFooter?: Maybe<CustomCssElement>;
  authkitGlobal?: Maybe<CustomCssElement>;
  authkitHeader?: Maybe<CustomCssElement>;
  authkitInput?: Maybe<CustomCssElement>;
  authkitLabel?: Maybe<CustomCssElement>;
  authkitOAuthButton?: Maybe<CustomCssElement>;
  authkitOrgSelection?: Maybe<CustomCssElement>;
  authkitVariables?: Maybe<CustomCssElement>;
};

export type CustomCssElementsInput = {
  authkitBackground?: InputMaybe<CustomCssElementInput>;
  authkitButton?: InputMaybe<CustomCssElementInput>;
  authkitCallout?: InputMaybe<CustomCssElementInput>;
  authkitCard?: InputMaybe<CustomCssElementInput>;
  authkitFooter?: InputMaybe<CustomCssElementInput>;
  authkitGlobal?: InputMaybe<CustomCssElementInput>;
  authkitHeader?: InputMaybe<CustomCssElementInput>;
  authkitInput?: InputMaybe<CustomCssElementInput>;
  authkitLabel?: InputMaybe<CustomCssElementInput>;
  authkitOAuthButton?: InputMaybe<CustomCssElementInput>;
  authkitOrgSelection?: InputMaybe<CustomCssElementInput>;
  authkitVariables?: InputMaybe<CustomCssElementInput>;
};

export type CustomDataIntegrationRequested = {
  success: Scalars['Boolean'];
};

export type CustomDomain = {
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  environmentId: Scalars['String'];
  errors?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  status: CustomDomainStatus;
  type: CustomDomainType;
  updatedAt: Scalars['DateTime'];
};

export type CustomDomainCreated = {
  customDomain: CustomDomain;
};

export type CustomDomainNotFound = {
  customDomainId: Scalars['String'];
};

export type CustomDomainRefreshed = {
  customDomain: CustomDomain;
};

export type CustomDomainRegistered = {
  /** The custom domain that was registered. */
  customDomain: Scalars['String'];
};

/** Indicates whether the custom domain applies to all environments in the project or just a single environment. */
export enum CustomDomainScope {
  Environment = 'Environment',
  Project = 'Project',
}

/** Enum represents the type of the status of the custom email domain. */
export enum CustomDomainStatus {
  AwaitingVerification = 'AwaitingVerification',
  VerificationFailed = 'VerificationFailed',
  Verified = 'Verified',
}

/** Enum represents the type of the custom domain. */
export enum CustomDomainType {
  AdminPortal = 'AdminPortal',
  AuthApi = 'AuthAPI',
  HostedAuthkit = 'HostedAuthkit',
  OAuthRedirect = 'OAuthRedirect',
}

export type CustomEmailDomain = {
  createdAt: Scalars['DateTime'];
  dkim1: Scalars['String'];
  dkim1Cname: Scalars['String'];
  dkim1Verified?: Maybe<Scalars['Boolean']>;
  dkim2: Scalars['String'];
  dkim2Cname: Scalars['String'];
  dkim2Verified?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  id: Scalars['ID'];
  projectId: Scalars['String'];
  spf: Scalars['String'];
  spfCname: Scalars['String'];
  spfVerified?: Maybe<Scalars['Boolean']>;
  status: CustomDomainStatus;
  updatedAt: Scalars['DateTime'];
};

export type CustomEmailDomainAlreadyExistForProject = {
  projectId: Scalars['String'];
};

export type CustomEmailDomainCreated = {
  customEmailDomain: CustomEmailDomain;
};

export type CustomEmailDomainQueryResult = {
  customEmailDomain?: Maybe<CustomEmailDomain>;
  defaultAdminPortalEmailDomain: Scalars['String'];
  defaultProductionEmailDomain: Scalars['String'];
  /** @deprecated Please use `defaultProductionEmailDomain` instead */
  defaultProductionUserlandEmailDomain: Scalars['String'];
  defaultSandboxEmailDomain: Scalars['String'];
  /** @deprecated Please use `defaultSandboxEmailDomain` instead. */
  sandboxUserlandEmailDomainEmailDomain: Scalars['String'];
};

export type CustomEmailProvider = {
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type CustomEmailProviderCreated = {
  customEmailProvider: CustomEmailProvider;
};

export type CustomEmailProviderDeleted = {
  customEmailProviderId: Scalars['String'];
};

/** Represents the domain fields that are verified. */
export enum CustomEmailProviderDomainField {
  ReplyTo = 'REPLY_TO',
  Sender = 'SENDER',
}

export type CustomEmailProviderEmailAddressDomainNotVerifiedError = {
  domain: Scalars['String'];
  emailAddressField: CustomEmailProviderDomainField;
};

export type CustomEmailProviderEmailAddressDomainNotVerifiedErrorList = {
  failedVerificationErrors: Array<CustomEmailProviderEmailAddressDomainNotVerifiedError>;
};

export type CustomEmailProviderInputError = {
  message: Scalars['String'];
  type: CustomEmailProviderInputErrorType;
};

/** Represents the input error types for custom email providers. */
export enum CustomEmailProviderInputErrorType {
  ApiError = 'API_ERROR',
  AuthenticationError = 'AUTHENTICATION_ERROR',
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  MissingRequiredFields = 'MISSING_REQUIRED_FIELDS',
}

export type CustomEmailProviderNotFound = {
  customEmailProviderId: Scalars['String'];
};

export type CustomEmailProviderSenderDomainNotVerifiedError = {
  domain: Scalars['String'];
};

/** The status of custom email provider. */
export enum CustomEmailProviderStatus {
  Active = 'ACTIVE',
  Quarantined = 'QUARANTINED',
}

/** The type of custom email provider. */
export enum CustomEmailProviderType {
  AmazonSes = 'AMAZON_SES',
  Mailgun = 'MAILGUN',
  Postmark = 'POSTMARK',
  Resend = 'RESEND',
  Sendgrid = 'SENDGRID',
}

export type CustomEmailProviderUpdated = {
  customEmailProvider: CustomEmailProvider;
};

export type CustomFontUploadError = {
  message: Scalars['String'];
};

export type CustomFontUploadResult = {
  cssPath: Scalars['String'];
  fontFamily: Scalars['String'];
  fontPaths: Array<Scalars['String']>;
};

export type CustomMappedCustomAttribute = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CustomMappedCustomAttributeCreated = {
  customAttribute: CustomMappedCustomAttribute;
};

export type CustomMappedCustomAttributeDeleted = {
  customAttribute: CustomMappedCustomAttribute;
};

export type CustomMappedCustomAttributeList = {
  data: Array<CustomMappedCustomAttribute>;
};

export type CustomMappedCustomAttributeUpdated = {
  customAttribute: CustomMappedCustomAttribute;
};

export type CustomProviderConfig = {
  /** @deprecated Placeholder for union type */
  _empty?: Maybe<Scalars['String']>;
};

export type CustomerMigration = {
  createdAt: Scalars['DateTime'];
  domain?: Maybe<Scalars['String']>;
  environmentId: Scalars['ID'];
  id: Scalars['ID'];
  provider: CustomerMigrationProvider;
  providerConfig?: Maybe<CustomerMigrationProviderConfig>;
  proxyStatus: CustomerMigrationProxyStatus;
  redirectUri?: Maybe<Scalars['String']>;
  state: CustomerMigrationState;
  updatedAt: Scalars['DateTime'];
  verificationDetails?: Maybe<DomainVerificationDetails>;
};

export type CustomerMigrationAlreadyExists = {
  existingMigrationId: Scalars['String'];
};

export type CustomerMigrationApplication = {
  applicationConfigs?: Maybe<ApplicationConfigs>;
  applicationId?: Maybe<Scalars['ID']>;
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customerMigrationId: Scalars['ID'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated Deprecated: application status is ignored for routing. Use CustomerMigration proxy status and CustomerMigrationConnection status. */
  status: CustomerMigrationApplicationStatus;
  targetApi?: Maybe<Scalars['String']>;
  type: CustomerMigrationApplicationType;
  updatedAt: Scalars['DateTime'];
};

export enum CustomerMigrationApplicationStatus {
  FallingBack = 'FALLING_BACK',
  Proxying = 'PROXYING',
}

export enum CustomerMigrationApplicationType {
  M2M = 'M2M',
  Native = 'NATIVE',
  RegularWeb = 'REGULAR_WEB',
  Spa = 'SPA',
}

export enum CustomerMigrationConnectionStatus {
  FallingBack = 'FALLING_BACK',
  Proxying = 'PROXYING',
  Testing = 'TESTING',
}

export type CustomerMigrationCreated = {
  customerMigration: CustomerMigration;
};

export type CustomerMigrationDeleted = {
  deletedCustomerMigrationId: Scalars['String'];
};

export type CustomerMigrationLog = {
  auth0ClientId?: Maybe<Scalars['String']>;
  connectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerMigrationsConnectionExternalId?: Maybe<Scalars['String']>;
  durationMs?: Maybe<Scalars['Int']>;
  endpointType: CustomerMigrationLogEndpointType;
  errorMessage?: Maybe<Scalars['String']>;
  fallbackReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  requestHeaders?: Maybe<Scalars['JSON']>;
  requestMethod?: Maybe<Scalars['String']>;
  requestPath?: Maybe<Scalars['String']>;
  requestPayload?: Maybe<Scalars['JSON']>;
  requestQuery?: Maybe<Scalars['JSON']>;
  responsePayload?: Maybe<Scalars['JSON']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  routingDecision: CustomerMigrationLogRoutingDecision;
  samlRequest?: Maybe<Scalars['String']>;
  samlResponse?: Maybe<Scalars['String']>;
};

export enum CustomerMigrationLogEndpointType {
  Authorize = 'AUTHORIZE',
  Callback = 'CALLBACK',
  Jwks = 'JWKS',
  Other = 'OTHER',
  Token = 'TOKEN',
  Userinfo = 'USERINFO',
}

export type CustomerMigrationLogList = {
  data: Array<CustomerMigrationLog>;
  listMetadata: ListMetadata;
};

export enum CustomerMigrationLogRoutingDecision {
  FallbackAuth0 = 'FALLBACK_AUTH0',
  Workos = 'WORKOS',
}

export enum CustomerMigrationLogStatus {
  Error = 'ERROR',
  Other = 'OTHER',
  Success = 'SUCCESS',
}

export type CustomerMigrationNotFound = {
  customerMigrationId: Scalars['String'];
};

export type CustomerMigrationNotFoundForApplications = {
  message: Scalars['String'];
};

export type CustomerMigrationNotFoundForConnections = {
  message: Scalars['String'];
};

export type CustomerMigrationNotFoundForDomain = {
  customerMigrationId: Scalars['String'];
};

/** The identity provider being migrated from. */
export enum CustomerMigrationProvider {
  Auth0 = 'Auth0',
  Custom = 'Custom',
}

export type CustomerMigrationProviderConfig =
  | Auth0ProviderConfig
  | CustomProviderConfig;

/** The current proxy target for the migration. */
export enum CustomerMigrationProxyStatus {
  FallingBack = 'FALLING_BACK',
  Proxying = 'PROXYING',
}

/** The current state of the customer migration. */
export enum CustomerMigrationState {
  ApplicationsImported = 'ApplicationsImported',
  ConnectionsImported = 'ConnectionsImported',
  CustomHostnameCreated = 'CustomHostnameCreated',
  CustomHostnameVerificationFailed = 'CustomHostnameVerificationFailed',
  CustomHostnameVerified = 'CustomHostnameVerified',
  ProviderConfigured = 'ProviderConfigured',
  ProviderSelected = 'ProviderSelected',
  Ready = 'Ready',
}

export type DashboardInviteNotExpired = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type DashboardInviteNotFound = {
  teamMembershipId: Scalars['String'];
};

export type DashboardInviteResent = {
  resentInvitation: Scalars['Boolean'];
};

export type DataInstallation = {
  createdAt: Scalars['DateTime'];
  dataIntegration: DataIntegration;
  dataIntegrationId: Scalars['ID'];
  dataProviderIntegration: DataProviderIntegration;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  scopes: Array<Scalars['String']>;
  state: DataInstallationState;
  updatedAt: Scalars['DateTime'];
  userlandUserId?: Maybe<Scalars['ID']>;
};

export type DataInstallationDeleted = {
  id: Scalars['String'];
};

export type DataInstallationNotFound = {
  dataInstallationId: Scalars['String'];
};

/** The state of a data installation. */
export enum DataInstallationState {
  Connected = 'Connected',
  NeedsReauthorization = 'NeedsReauthorization',
}

export type DataIntegration = {
  clientId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials: DataIntegrationCredentials;
  credentialsType: DataIntegrationCredentialsType;
  customRedirectUri: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizations: OrganizationList;
  organizationsCount: Scalars['Int'];
  redirectUri: Scalars['String'];
  scopes?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  state: DataIntegrationState;
  type: DataIntegrationType;
  updatedAt: Scalars['DateTime'];
  usersCount: Scalars['Int'];
};

export type DataIntegrationOrganizationsArgs = {
  limit: Scalars['Int'];
};

export type DataIntegrationCredentials = {
  clientId?: Maybe<Scalars['String']>;
  redactedClientSecret?: Maybe<Scalars['String']>;
  type: DataIntegrationCredentialsType;
};

export type DataIntegrationCredentialsInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  type: DataIntegrationCredentialsType;
};

/** The type of credentials used for the DataIntegration. */
export enum DataIntegrationCredentialsType {
  Custom = 'Custom',
  Shared = 'Shared',
}

export type DataIntegrationDeleted = {
  id: Scalars['String'];
};

export type DataIntegrationList = {
  data: Array<DataIntegration>;
  listMetadata: ListMetadata;
};

export type DataIntegrationNotFound = {
  dataIntegrationId: Scalars['String'];
};

export type DataIntegrationRequested = {
  dataIntegration: DataIntegration;
};

/** The state of a data integration. */
export enum DataIntegrationState {
  Invalid = 'Invalid',
  Requested = 'Requested',
  Valid = 'Valid',
}

/** The type (provider) of data integration. */
export enum DataIntegrationType {
  Asana = 'Asana',
  Attio = 'Attio',
  Box = 'Box',
  CalDotCom = 'CalDotCom',
  Calendly = 'Calendly',
  Confluence = 'Confluence',
  Dropbox = 'Dropbox',
  FrameIo = 'FrameIO',
  Front = 'Front',
  GitHub = 'GitHub',
  GitLab = 'GitLab',
  Gmail = 'Gmail',
  Gong = 'Gong',
  Google = 'Google',
  GoogleCalendar = 'GoogleCalendar',
  GoogleDrive = 'GoogleDrive',
  Helpscout = 'Helpscout',
  HubSpot = 'HubSpot',
  Intercom = 'Intercom',
  Intralinks = 'Intralinks',
  Jira = 'Jira',
  Linear = 'Linear',
  Microsoft = 'Microsoft',
  MicrosoftOneDrive = 'MicrosoftOneDrive',
  MicrosoftOneNote = 'MicrosoftOneNote',
  MicrosoftOutlook = 'MicrosoftOutlook',
  MicrosoftOutlookCalendar = 'MicrosoftOutlookCalendar',
  MicrosoftSharePoint = 'MicrosoftSharePoint',
  MicrosoftTeams = 'MicrosoftTeams',
  MicrosoftToDo = 'MicrosoftToDo',
  Notion = 'Notion',
  Prefect = 'Prefect',
  PydanticLogfire = 'PydanticLogfire',
  Quickbooks = 'Quickbooks',
  Salesforce = 'Salesforce',
  Sentry = 'Sentry',
  Slack = 'Slack',
  Snowflake = 'Snowflake',
  Stripe = 'Stripe',
  StripeConnect = 'StripeConnect',
  Xero = 'Xero',
  Zendesk = 'Zendesk',
  Zoom = 'Zoom',
}

export type DataIntegrationUpdated = {
  dataIntegration: DataIntegration;
};

export type DataProviderConfig = {
  description?: Maybe<Scalars['String']>;
  iconDarkUrl?: Maybe<Scalars['String']>;
  iconSlug: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationType: Scalars['String'];
  name: Scalars['String'];
  oauthDocsExternalLink?: Maybe<Scalars['String']>;
  scopes: Array<DataProviderScopeConfig>;
  scopesDocsExternalLink?: Maybe<Scalars['String']>;
  sharedCredentialsAvailable: Scalars['Boolean'];
  sharedScopesDescription?: Maybe<Scalars['String']>;
  showScopes: Scalars['Boolean'];
  slug: Scalars['String'];
  state: Scalars['String'];
};

export type DataProviderIntegration = {
  clientId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentialsType: DataIntegrationCredentialsType;
  customRedirectUri: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizations: OrganizationList;
  organizationsCount: Scalars['Int'];
  provider?: Maybe<DataProviderConfig>;
  providerSlug: Scalars['String'];
  redactedClientSecret?: Maybe<Scalars['String']>;
  redirectUri: Scalars['String'];
  scopes?: Maybe<Array<Scalars['String']>>;
  state: DataIntegrationState;
  updatedAt: Scalars['DateTime'];
  usersCount: Scalars['Int'];
};

export type DataProviderIntegrationOrganizationsArgs = {
  limit: Scalars['Int'];
};

export type DataProviderIntegrationList = {
  data: Array<DataProviderIntegration>;
  listMetadata: ListMetadata;
};

export type DataProviderIntegrationResult =
  | DataProviderIntegration
  | DataProviderNotFound;

export type DataProviderIntegrationUpdated = {
  dataProviderIntegration: DataProviderIntegration;
};

export type DataProviderNotFound = {
  providerSlug: Scalars['String'];
};

export type DataProviderRequested = {
  dataProviderIntegration: DataProviderIntegration;
};

export type DataProviderScopeConfig = {
  shared: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type DatadogLogStream = {
  apiKey?: Maybe<Scalars['String']>;
  region?: Maybe<DatadogRegion>;
};

export enum DatadogRegion {
  Ap1 = 'AP1',
  Eu1 = 'EU1',
  Us1 = 'US1',
  Us1Fed = 'US1FED',
  Us3 = 'US3',
  Us5 = 'US5',
}

export type DatadogWebhookEndpoint = {
  apiKey: Scalars['String'];
  healthy: Scalars['Boolean'];
  id: Scalars['ID'];
  region: Scalars['String'];
};

export type DatadogWebhookEndpointResult =
  | InvalidDatadogCredentials
  | WebhookEndpoint;

export type DeactivateUserlandUserOrganizationMembershipInput = {
  userlandUserOrganizationMembershipId: Scalars['String'];
};

export type DeactivateUserlandUserOrganizationMembershipResult =
  | UserlandUserOrganizationMembershipDeactivated
  | UserlandUserOrganizationMembershipNotFound;

export type DeauthorizeStripeResult = DeauthorizeStripeSuccess | StripeError;

export type DeauthorizeStripeSuccess = {
  environment: Environment;
};

export type DecryptionFailedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type DecryptionMalformedEncryptedAssertionError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type DecryptionMissingEncryptionKeyError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type DefaultDynamicRegistrationOAuthScopesSet = {
  environment: Environment;
};

export type DefaultPaymentMethod = {
  brand?: Maybe<Scalars['String']>;
  expirationMonth?: Maybe<Scalars['String']>;
  expirationYear?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type DefaultRedirectUriNotFound = {
  message: Scalars['String'];
};

export type DeleteActionsEndpointInput = {
  actionsEndpointId: Scalars['String'];
};

export type DeleteActionsEndpointResult = ActionsEndpointDeleted;

export type DeleteAdpConnectionSslCertificateInput = {
  certificateId: Scalars['String'];
};

export type DeleteAdpConnectionSslCertificateResult =
  | AdpConnectionSslCertificateDeleted
  | AdpConnectionSslCertificateNotFound;

export type DeleteApiKeyInput = {
  apiKeyId: Scalars['String'];
};

export type DeleteApiKeyPayload = {
  apiKey?: Maybe<ApiKey>;
};

export type DeleteApplicationCredentialInput = {
  applicationCredentialId: Scalars['ID'];
};

export type DeleteApplicationCredentialResult =
  | ApplicationCredentialDeleted
  | ApplicationCredentialNotFound;

export type DeleteApplicationInput = {
  applicationId: Scalars['String'];
};

export type DeleteApplicationResult = ApplicationDeleted | ApplicationNotFound;

export type DeleteAuditLogStreamInput = {
  id: Scalars['String'];
};

export type DeleteAuditLogStreamResult =
  | AuditLogStreamDeleted
  | AuditLogStreamNotFound;

export type DeleteAuditLogValidatorInput = {
  id: Scalars['String'];
};

export type DeleteAuditLogValidatorResult =
  | AuditLogValidatorDeleted
  | AuditLogValidatorNotFound;

export type DeleteAuditLogValidatorVersionInput = {
  auditLogValidatorVersionId: Scalars['String'];
};

export type DeleteAuditLogValidatorVersionResult =
  | AuditLogValidatorVersionDeleted
  | AuditLogValidatorVersionNotFound;

export type DeleteAuthenticationFactorResult =
  | AuthenticationFactorDeleted
  | AuthenticationFactorNotFound;

export type DeleteAuthorizationResourceTypeInput = {
  resourceTypeId: Scalars['String'];
};

export type DeleteAuthorizationResourceTypeResult =
  | AuthorizationResourceTypeDeleted
  | AuthorizationResourceTypeHasPermissions
  | AuthorizationResourceTypeHasRoles
  | AuthorizationResourceTypeNotFound;

export type DeleteConnectionGroupInput = {
  connectionGroupId: Scalars['String'];
};

export type DeleteConnectionGroupResult =
  | ConnectionGroupDeleted
  | ConnectionGroupNotFound;

export type DeleteCustomEmailDomainResult = DomainDeletionSuccess;

export type DeleteCustomEmailProviderInput = {
  customEmailProviderId: Scalars['ID'];
};

export type DeleteCustomEmailProviderResult =
  | CustomEmailProviderDeleted
  | CustomEmailProviderNotFound;

export type DeleteCustomMappedCustomAttributeInput = {
  customAttributeId: Scalars['ID'];
};

export type DeleteCustomMappedCustomAttributeResult =
  | CustomAttributeNotFound
  | CustomMappedCustomAttributeDeleted;

export type DeleteCustomerMigrationInput = {
  customerMigrationId: Scalars['String'];
};

export type DeleteCustomerMigrationResult =
  | CustomerMigrationDeleted
  | CustomerMigrationNotFound;

export type DeleteDataInstallationInput = {
  dataInstallationId: Scalars['String'];
};

export type DeleteDataInstallationResult =
  | DataInstallationDeleted
  | DataInstallationNotFound;

export type DeleteDataIntegrationInput = {
  dataIntegrationId: Scalars['String'];
};

export type DeleteDataIntegrationResult =
  | DataIntegrationDeleted
  | DataIntegrationNotFound;

export type DeleteDirectoryInput = {
  directoryId: Scalars['String'];
};

export type DeleteDirectoryPayload = {
  directory?: Maybe<Directory>;
};

export type DeleteFlagInput = {
  flagId: Scalars['String'];
  projectId: Scalars['String'];
};

export type DeleteFlagResult = FlagDeleted | FlagNotFound | ProjectNotFound;

export type DeleteGroupRoleMappingsInput = {
  groupRoleMappingIds: Array<Scalars['String']>;
};

export type DeleteGroupRoleMappingsResult =
  | EnvironmentNotFound
  | GroupRoleMappingsDeleted;

export type DeleteJwtTemplateInput = {
  jwtTemplateId: Scalars['String'];
};

export type DeleteJwtTemplateResult = JwtTemplateDeleted;

export type DeleteMigrationApplicationResult =
  | DeleteMigrationApplicationSuccess
  | MigrationApplicationNotFound;

export type DeleteMigrationApplicationSuccess = {
  id: Scalars['String'];
};

export type DeleteMigrationConnectionResult =
  | DeleteMigrationConnectionSuccess
  | MigrationConnectionNotFound;

export type DeleteMigrationConnectionSuccess = {
  externalId: Scalars['String'];
};

export type DeleteOrganizationAdminMembershipInput = {
  organizationAdminId: Scalars['String'];
  organizationId: Scalars['String'];
};

export type DeleteOrganizationAdminMembershipResult =
  | OrganizationAdminMembershipDeleted
  | OrganizationAdminNotFound
  | OrganizationNotFound;

export type DeleteOrganizationInput = {
  organizationId: Scalars['String'];
};

export type DeleteOrganizationPayload = {
  organization?: Maybe<Organization>;
};

export type DeletePermissionInput = {
  permissionId: Scalars['String'];
};

export type DeletePermissionResult =
  | EnvironmentNotFound
  | PermissionDeleted
  | PermissionNotFound;

export type DeleteRoleInput = {
  replacementDefaultRoleId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
};

export type DeleteRoleResult = EnvironmentNotFound | RoleDeleted | RoleNotFound;

export type DeleteSamlX509CertificateInput = {
  samlX509CertificateId: Scalars['String'];
};

export type DeleteSamlX509CertificateResult =
  | SamlX509CertificateDeleted
  | SamlX509CertificateNotFound;

export type DeleteTeamInput = {
  additionalFeedback?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type DeleteTeamResult =
  | TeamCannotBeDeleted
  | TeamDeletionQueued
  | TeamNotFound;

export type DeleteUserlandApplicationInput = {
  applicationId: Scalars['String'];
};

export type DeleteUserlandApplicationResult =
  | UserlandApplicationCannotDeleteDefault
  | UserlandApplicationDeleted
  | UserlandApplicationNotFound;

export type DeleteUserlandUserInput = {
  userlandUserId: Scalars['String'];
};

export type DeleteUserlandUserResult =
  | UserlandUserDeleted
  | UserlandUserNotFound;

export type DeleteWaitlistEntryInput = {
  id: Scalars['String'];
};

export type DeprovisionPlatformInput = {
  platform: Scalars['String'];
};

export type DeprovisionPlatformResult =
  | PlatformDeprovisioned
  | TeamPlatformNotFound;

export type DetailedBillingInvoice = {
  appliedBalance?: Maybe<Scalars['Float']>;
  billingPeriodStart: Scalars['DateTime'];
  connectionsCount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  finalizedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  items: Array<DetailedBillingInvoiceItem>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentStatus: BillingInvoicePaymentStatus;
  pdfUrl?: Maybe<Scalars['String']>;
  planKey: Scalars['String'];
  receiptPdfUrl?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalDiscount?: Maybe<Scalars['Float']>;
};

export type DetailedBillingInvoiceItem = {
  count: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  featureKey?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  total: Scalars['Float'];
  unitPrice?: Maybe<Scalars['Float']>;
};

export type DetailedBillingInvoiceResult =
  | DetailedBillingInvoice
  | InvoiceNotFound
  | LegacyBillingInvoice
  | TeamMissingStripeData;

export type Directory = {
  attributeMap?: Maybe<DirectoryAttributeMap>;
  attributeSchema?: Maybe<AttributeSchema>;
  bamboo_hr_api_key?: Maybe<Scalars['String']>;
  bamboo_hr_custom_fields?: Maybe<Array<Scalars['String']>>;
  bamboo_hr_subdomain?: Maybe<Scalars['String']>;
  bearerToken?: Maybe<Scalars['String']>;
  breatheHrApiKey?: Maybe<Scalars['String']>;
  cezanneHrClientId?: Maybe<Scalars['String']>;
  cezanneHrClientSecret?: Maybe<Scalars['String']>;
  cezanne_custom_fields?: Maybe<Array<Scalars['String']>>;
  client_channel_token?: Maybe<Scalars['String']>;
  client_refresh_token?: Maybe<Scalars['String']>;
  config?: Maybe<DirectoryConfig>;
  createdAt: Scalars['DateTime'];
  directoryGroups: DirectoryGroupsList;
  directorySyncRun: DirectorySyncRun;
  directorySyncRuns: DirectorySyncRunsList;
  directoryUser: DirectoryUser;
  directoryUsers: DirectoryUsersList;
  endpoint?: Maybe<Scalars['String']>;
  events: EventList;
  fourthHrOrganizationId?: Maybe<Scalars['String']>;
  fourthHrPassword?: Maybe<Scalars['String']>;
  fourthHrUsername?: Maybe<Scalars['String']>;
  hibobApiToken?: Maybe<Scalars['String']>;
  hibobServiceUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastFinalizedDirectorySyncRun?: Maybe<DirectorySyncRun>;
  name: Scalars['String'];
  orderedDirectoryGroupConfigs: OrderedDirectoryGroupConfigsResult;
  organization?: Maybe<Organization>;
  peopleHrApiKey?: Maybe<Scalars['String']>;
  personioClientId?: Maybe<Scalars['String']>;
  personioClientSecret?: Maybe<Scalars['String']>;
  primaryDomain?: Maybe<OrganizationDomain>;
  provider?: Maybe<DirectoryProvider>;
  rippling_api_key?: Maybe<Scalars['String']>;
  setup_url?: Maybe<Scalars['String']>;
  sftpPublicKey?: Maybe<Scalars['String']>;
  sftpSourceProvider?: Maybe<SftpSourceProvider>;
  sftpUsername?: Maybe<Scalars['String']>;
  state: DirectoryState;
  summary: DirectorySummary;
  type: DirectoryType;
  updatedAt: Scalars['DateTime'];
  workday_raas_endpoint?: Maybe<Scalars['String']>;
  workday_raas_group_endpoint?: Maybe<Scalars['String']>;
  workday_raas_password?: Maybe<Scalars['String']>;
  workday_raas_username?: Maybe<Scalars['String']>;
};

export type DirectoryDirectoryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberCountMaximum?: InputMaybe<Scalars['Int']>;
  memberCountMinimum?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  roleId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type DirectoryDirectorySyncRunArgs = {
  id: Scalars['String'];
};

export type DirectoryDirectorySyncRunsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  state?: InputMaybe<DirectorySyncRunState>;
};

export type DirectoryDirectoryUserArgs = {
  id: Scalars['String'];
};

export type DirectoryDirectoryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  role?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<DirectoryUserState>;
};

export type DirectoryEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  directoryGroupId?: InputMaybe<Scalars['String']>;
  directoryUserId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<PaginationOrder>;
  rangeEnd?: InputMaybe<Scalars['DateTime']>;
  rangeStart?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
};

export type DirectoryOrderedDirectoryGroupConfigsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterGroupsWithMembers?: InputMaybe<Scalars['Boolean']>;
  filterSynced?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type DirectoryAttributeMap = {
  attributes: DirectoryAttributes;
  id: Scalars['ID'];
};

export type DirectoryAttributes = {
  emails?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type DirectoryConfig = {
  directoryId: Scalars['String'];
  groupsSync: DirectoryConfigGroupsSync;
  id: Scalars['String'];
};

export type DirectoryConfigAlreadyExistsDashboard = {
  directoryConfigId: Scalars['String'];
};

export type DirectoryConfigCreatedDashboard = {
  directoryConfig: DirectoryConfig;
};

/** Enum represents the strategy for syncing groups of the Directory. */
export enum DirectoryConfigGroupsSync {
  AllowList = 'AllowList',
  SyncAll = 'SyncAll',
}

export type DirectoryCustomAttribute = {
  createdAt: Scalars['DateTime'];
  environment: Environment;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  name: Scalars['String'];
  type: DirectoryCustomAttributeType;
  updatedAt: Scalars['DateTime'];
};

export type DirectoryCustomAttributeList = {
  data: Array<DirectoryCustomAttribute>;
};

export type DirectoryCustomAttributeMapping = {
  attribute: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customAttribute: DirectoryCustomAttribute;
  directory: Directory;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type DirectoryCustomAttributeMappingInput = {
  attribute: Scalars['String'];
  customAttributeId: Scalars['ID'];
};

export type DirectoryCustomAttributeMappingList = {
  data: Array<DirectoryCustomAttributeMapping>;
};

export type DirectoryCustomAttributeMappingsSet = {
  mappings: Array<DirectoryCustomAttributeMapping>;
};

export type DirectoryCustomAttributeNotFound = {
  directoryCustomAttributeId: Scalars['String'];
};

/** Enum represents the type of Custom Attribute. */
export enum DirectoryCustomAttributeType {
  AutoMapped = 'AutoMapped',
  CustomMapped = 'CustomMapped',
}

export type DirectoryGroup = {
  directoryId: Scalars['String'];
  groupRoleMapping?: Maybe<GroupRoleMapping>;
  id: Scalars['String'];
  idpId: Scalars['String'];
  name: Scalars['String'];
  summary: DirectoryGroupSummary;
};

export type DirectoryGroupConfig = {
  createdAt: Scalars['DateTime'];
  directoryId: Scalars['String'];
  groupRoleMapping?: Maybe<GroupRoleMapping>;
  id: Scalars['ID'];
  idpId: Scalars['String'];
  name: Scalars['String'];
  numberOfMemberships: Scalars['Int'];
  shouldSync: Scalars['Boolean'];
};

export type DirectoryGroupConfigSummary = {
  numberOfGroupsInDirectory: Scalars['Int'];
  numberOfSyncingGroupsInDirectory: Scalars['Int'];
};

export type DirectoryGroupSummary = {
  memberCount: Scalars['Int'];
};

export type DirectoryGroupsList = {
  data: Array<DirectoryGroup>;
  listMetadata: ListMetadata;
};

export type DirectoryNotFound = {
  directoryId: Scalars['String'];
};

export type DirectoryOrUntypedDirectory = Directory | UntypedDirectory;

export type DirectoryOrUntypedDirectoryList = {
  data: Array<DirectoryOrUntypedDirectory>;
  listMetadata: ListMetadata;
};

export type DirectoryProvider =
  | BambooHrDirectory
  | BreatheHrDirectory
  | CezanneHrDirectory
  | FourthHrDirectory
  | GoogleWorkspaceDirectory
  | GustoDirectory
  | HibobDirectory
  | PeopleHrDirectory
  | PersonioDirectory
  | RipplingDirectory
  | SftpDirectory
  | WorkdayDirectory;

/** An error pertaining to the directory provider. */
export type DirectoryProviderError = {
  message: Scalars['String'];
};

export type DirectoryProviderErrors = {
  errors: Array<DirectoryProviderError>;
};

/** Enum represents the state of the Directory. */
export enum DirectoryState {
  Deleting = 'Deleting',
  InvalidCredentials = 'InvalidCredentials',
  Linked = 'Linked',
  Unlinked = 'Unlinked',
  Validating = 'Validating',
}

export type DirectorySummary = {
  groupCount: Scalars['Int'];
  groupRoleMappingCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export type DirectorySyncRun = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  directoryId: Scalars['String'];
  errors: Array<DirectorySyncRunError>;
  groupCounts: DirectorySyncRunResourceCounts;
  id: Scalars['String'];
  internalErrors: Array<DirectorySyncRunInternalError>;
  state: DirectorySyncRunState;
  updatedAt: Scalars['DateTime'];
  userCounts: DirectorySyncRunResourceCounts;
};

export type DirectorySyncRunError =
  | MalformedDirectoryGroupError
  | MalformedDirectoryUserError;

/** Enum represents the error code of a Directory Sync Run. */
export enum DirectorySyncRunErrorCode {
  MalformedDirectoryGroup = 'MalformedDirectoryGroup',
  MalformedDirectoryUser = 'MalformedDirectoryUser',
}

export type DirectorySyncRunInternalError =
  | EmptyFileError
  | MalformedFileError
  | MissingFileError;

/** Enum represents the error code of a Directory Sync Run. */
export enum DirectorySyncRunInternalErrorCode {
  EmptyFileError = 'EmptyFileError',
  MalformedFileError = 'MalformedFileError',
  MissingFileError = 'MissingFileError',
}

export type DirectorySyncRunResourceCounts = {
  created: Scalars['Float'];
  deleted: Scalars['Float'];
  processed: Scalars['Float'];
  updated: Scalars['Float'];
};

/** Enum represents the state of the directory sync run. */
export enum DirectorySyncRunState {
  Completed = 'Completed',
  Error = 'Error',
  Running = 'Running',
}

export type DirectorySyncRunsList = {
  data: Array<DirectorySyncRun>;
  listMetadata: ListMetadata;
};

/** Enum represents the type of Directory. */
export enum DirectoryType {
  AzureScimv2_0 = 'AzureSCIMV2_0',
  BambooHr = 'BambooHR',
  BreatheHr = 'BreatheHr',
  CezanneHr = 'CezanneHr',
  CyberArkScimV2_0 = 'CyberArkScimV2_0',
  FourthHr = 'FourthHr',
  GenericScimv2_0 = 'GenericSCIMV2_0',
  GoogleWorkspace = 'GoogleWorkspace',
  Gusto = 'Gusto',
  Hibob = 'Hibob',
  JumpCloudScimV2_0 = 'JumpCloudScimV2_0',
  OktaScimv2_0 = 'OktaSCIMV2_0',
  OneLoginScimV2_0 = 'OneLoginScimV2_0',
  PeopleHr = 'PeopleHr',
  Personio = 'Personio',
  PingFederateScimV2_0 = 'PingFederateScimV2_0',
  Rippling = 'Rippling',
  RipplingScimV2_0 = 'RipplingScimV2_0',
  S3 = 'S3',
  SailPointScimv2_0 = 'SailPointSCIMV2_0',
  Sftp = 'Sftp',
  SftpWorkday = 'SftpWorkday',
  Workday = 'Workday',
}

export type DirectoryUpdated = {
  directory: Directory;
};

export type DirectoryUser = {
  customAttributes: Scalars['JSONObject'];
  directory: Directory;
  directoryGroups: Array<DirectoryGroup>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idpId: Scalars['String'];
  /** The JSON representation of the Directory User, as returned by the REST API. */
  json: Scalars['JSON'];
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Role>>;
  state: DirectoryUserState;
  userRoleId?: Maybe<Scalars['String']>;
};

/** Enum represents the state of the directory user. */
export enum DirectoryUserState {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
  Validating = 'Validating',
}

export type DirectoryUsersList = {
  data: Array<DirectoryUser>;
  listMetadata: ListMetadata;
};

export type DisconnectSlackResult = {
  success: Scalars['Boolean'];
};

export type DomainDeletionSuccess = {
  id: Scalars['String'];
};

export type DomainStatusChecked = {
  success: Scalars['Boolean'];
};

export type DomainTypeAlreadyExists = {
  domain: Scalars['String'];
  type: CustomDomainType;
};

export type DomainUnavailable = {
  domain: Scalars['String'];
};

export type DomainVerificationDetails = {
  cname?: Maybe<Scalars['String']>;
  httpBody?: Maybe<Scalars['String']>;
  httpUrl?: Maybe<Scalars['String']>;
};

export type DomainsAdded = {
  domains: Array<OrganizationDomain>;
};

export type DynamicallyRegisteredApplication = Application & {
  clientConfidentiality: ApplicationClientConfidentiality;
  clientId: Scalars['String'];
  clientMetadata?: Maybe<DynamicallyRegisteredApplicationMetadata>;
  createdAt: Scalars['DateTime'];
  credentials: Array<ApplicationCredential>;
  darkLogoPath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isClientIdMetadataDocument: Scalars['Boolean'];
  isFirstParty: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lightLogoPath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  redirectUris: Array<RedirectUri>;
  type: ApplicationType;
  updatedAt: Scalars['DateTime'];
};

export type DynamicallyRegisteredApplicationMetadata = {
  logoUri?: Maybe<Scalars['String']>;
};

/** Represents the email categories that can be unsubscribed from. */
export enum EmailNotificationCategory {
  Connection = 'Connection',
  Error = 'Error',
}

export type EmailNotificationPreference = {
  category: EmailNotificationCategory;
  preference: EmailNotificationPreferenceConfiguration;
};

/** Represents the possible configurations for email notification preferences. */
export enum EmailNotificationPreferenceConfiguration {
  Subscribed = 'Subscribed',
  Unsubscribed = 'Unsubscribed',
}

export type EmailNotificationPreferences = {
  preferences: Array<EmailNotificationPreference>;
};

export type EmailSuppression = {
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  reason: Scalars['String'];
  type: EmailSuppressionType;
};

export type EmailSuppressionCheckResult = {
  email: Scalars['String'];
  isSuppressed: Scalars['Boolean'];
  suppressions: Array<EmailSuppression>;
};

export type EmailSuppressionRemovalSuccess = {
  email: Scalars['String'];
};

/** The type of email suppression. */
export enum EmailSuppressionType {
  Block = 'BLOCK',
  Bounce = 'BOUNCE',
  Invalid = 'INVALID',
  SpamComplaint = 'SPAM_COMPLAINT',
}

export type EmptyFileError = {
  code: DirectorySyncRunInternalErrorCode;
  file: Scalars['String'];
  reason: Scalars['String'];
};

export type EnrollTotpUserAuthenticationFactorResult =
  TotpUserAuthenticationFactorEnrolled;

export type EnterTeamDetailsPayload = {
  team?: Maybe<Team>;
  user?: Maybe<User>;
};

export type Entitlement = {
  endedAt?: Maybe<Scalars['DateTime']>;
  featureId: Scalars['String'];
  id: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  teamId: Scalars['String'];
};

export type EntitlementUserClickedUpgradeButtonInput = {
  billingFeatureKey: Scalars['String'];
};

export type Environment = {
  activationMilestones: Array<ActivationMilestone>;
  aggregateRadarDetectionIdentifiers: AggregateRadarDetectionIdentifiers;
  aggregateRadarDetections: AggregateRadarDetections;
  allowProfilesOutsideOrganization?: Maybe<Scalars['Boolean']>;
  applications: ApplicationList;
  auth0Credential?: Maybe<Auth0Credential>;
  authkitAnalytics?: Maybe<AuthkitAnalytics>;
  authkitDomains?: Maybe<Array<AuthkitDomain>>;
  authkitOauthResources: Array<AuthkitOauthResource>;
  clientId: Scalars['String'];
  customAdminPortalDomain?: Maybe<CustomAdminPortalDomain>;
  customAdminPortalDomainScope: CustomDomainScope;
  customAuthDomain?: Maybe<CustomAuthDomain>;
  customAuthDomainScope: CustomDomainScope;
  dataIntegrations: DataIntegrationList;
  dataProviderIntegrations: DataProviderIntegrationList;
  defaultLocale: Scalars['String'];
  event: Event;
  events: EventList;
  expiredConnectionCertificates?: Maybe<
    Array<EnvironmentConnectionCertificate>
  >;
  expiringConnectionCertificates?: Maybe<
    Array<EnvironmentConnectionCertificate>
  >;
  googleAnalyticsConfig?: Maybe<GoogleAnalyticsConfig>;
  hasUnreadNotifications: Scalars['Boolean'];
  hasUsedAllowProfilesOutsideOrganization: Scalars['Boolean'];
  id: Scalars['ID'];
  initiateLoginUrl?: Maybe<Scalars['String']>;
  localizationEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notifications: NotificationList;
  onboardingTasks: EnvironmentOnboardingTasks;
  organizationAdminCollectionEnabled: Scalars['Boolean'];
  organizationCount: Scalars['Int'];
  platform?: Maybe<Scalars['String']>;
  portalSettings: PortalSettings;
  preferredAuthkitDomain?: Maybe<AuthkitDomain>;
  projectV2: ProjectV2;
  quickStartDismissed: Scalars['Boolean'];
  radarDetection?: Maybe<RadarDetection>;
  radarDetections: RadarDetectionList;
  radarSettings: RadarSettings;
  resourceTypeCount?: Maybe<Scalars['Int']>;
  sandbox: Scalars['Boolean'];
  seededTestIdpConnection?: Maybe<Connection>;
  segmentConfig?: Maybe<SegmentConfig>;
  sentEmails: SentEmailList;
  ssoSignInConsentEnabled: Scalars['Boolean'];
  standaloneSsoDomainPolicy?: Maybe<StandaloneSsoDomainPolicy>;
  stripeAccountId?: Maybe<Scalars['String']>;
  stripeConnectState?: Maybe<StripeConnectState>;
  stripeConnectStateUpdatedAt?: Maybe<Scalars['String']>;
  stripeEntitlementsEnabled: Scalars['Boolean'];
  stripeSeatSyncEnabled: Scalars['Boolean'];
  userlandEmailSettings: UserlandEmailSettings;
  userlandPasswordAuthenticationConfig: UserlandPasswordAuthenticationConfig;
  userlandSettings: UserlandSettings;
  usersCount: Scalars['Int'];
  vaultKeySettingsByEnvironment: VaultKeySettingsList;
  webOrigins: WebOriginsList;
};

export type EnvironmentAggregateRadarDetectionIdentifiersArgs = {
  timeRange?: InputMaybe<AggregateRadarDetectionsTimeRange>;
};

export type EnvironmentAggregateRadarDetectionsArgs = {
  timeRange?: InputMaybe<AggregateRadarDetectionsTimeRange>;
};

export type EnvironmentApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  registration?: InputMaybe<ApplicationRegistration>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ApplicationIntegrationType>;
};

export type EnvironmentAuthkitAnalyticsArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
  timezone: Scalars['String'];
};

export type EnvironmentDataIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  credentialsType?: InputMaybe<DataIntegrationCredentialsType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  excludeRequested?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};

export type EnvironmentDataProviderIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  credentialsType?: InputMaybe<DataIntegrationCredentialsType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  excludeRequested?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};

export type EnvironmentEventArgs = {
  id: Scalars['String'];
};

export type EnvironmentEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  directoryGroupId?: InputMaybe<Scalars['String']>;
  directoryId?: InputMaybe<Scalars['String']>;
  directoryUserId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['String']>;
  rangeEnd?: InputMaybe<Scalars['DateTime']>;
  rangeStart?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type EnvironmentNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  state?: InputMaybe<NotificationState>;
  type?: InputMaybe<NotificationType>;
};

export type EnvironmentRadarDetectionArgs = {
  id: Scalars['String'];
};

export type EnvironmentRadarDetectionsArgs = {
  actions?: InputMaybe<Array<RadarDetectionAction>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  controls?: InputMaybe<Array<RadarDetectionControl>>;
  ipAddress?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  locationCity?: InputMaybe<Scalars['String']>;
  locationCountry?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<PaginationOrder>;
  rangeEnd?: InputMaybe<Scalars['DateTime']>;
  rangeStart?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<Scalars['String']>;
};

export type EnvironmentSentEmailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  recipient?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type EnvironmentVaultKeySettingsByEnvironmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  keyProviders?: InputMaybe<Array<VaultKeyProvider>>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<VaultKeyStatus>>;
};

export type EnvironmentWebOriginsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type EnvironmentConnectionCertificate = {
  connectionId: Scalars['String'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
};

export type EnvironmentIdpAttributesConfig = {
  dsyncCustomAttributeMappingEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  ssoCustomAttributeMappingEnabled: Scalars['Boolean'];
  type: Scalars['String'];
};

export type EnvironmentNotFound = {
  environmentId: Scalars['String'];
};

export type EnvironmentNotFoundForSuppression = {
  environmentId: Scalars['String'];
};

export type EnvironmentOnboardingTasks = {
  addValidCustomEmailDomain: Scalars['Boolean'];
};

export type EnvironmentRoleConfig = {
  defaultRole: Scalars['String'];
  dsyncRoleAssignmentEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  multipleRolesEnabled: Scalars['Boolean'];
  rolePriorityOrder: Array<Scalars['String']>;
  ssoRoleAssignmentEnabled: Scalars['Boolean'];
  type: Scalars['String'];
};

/** The type of an environment. */
export enum EnvironmentType {
  Production = 'Production',
  Sandbox = 'Sandbox',
}

export type Event = {
  context?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  webhooks?: Maybe<WebhookList>;
};

export type EventWebhooksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type EventAction = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EventList = {
  data: Array<Event>;
  listMetadata: ListMetadata;
};

export type ExistingNonVerifiedDomain = {
  nonVerifiedDomain: OrganizationDomain;
};

export type ExpectedAttributes = {
  email_attribute: Scalars['String'];
  first_name_attribute: Scalars['String'];
  idp_id_attribute: Scalars['String'];
  last_name_attribute: Scalars['String'];
};

export type ExpireKeyInput = {
  expiredAt?: InputMaybe<Scalars['DateTime']>;
  keyId: Scalars['String'];
};

export type ExpireKeyResult = KeyAlreadyExpired | KeyExpired | KeyNotFound;

export type ExpirePortalSetupLinkInput = {
  intent: PortalSetupLinkIntent;
  organizationId: Scalars['String'];
};

export type ExpirePortalSetupLinkResult =
  | OrganizationNotFound
  | PortalSetupLinkExpired;

export type ExpirePortalSetupLinksInput = {
  expireIntents?: InputMaybe<Array<PortalSetupLinkIntent>>;
  organizationId: Scalars['String'];
};

export type ExpirePortalSetupLinksResult =
  | OrganizationNotFound
  | PortalSetupLinksExpired;

export type ExpireUserlandApplicationKeyInput = {
  expiredAt?: InputMaybe<Scalars['DateTime']>;
  keyId: Scalars['String'];
};

export type ExpireUserlandApplicationKeyResult =
  | KeyAlreadyExpired
  | KeyNotFound
  | UserlandApplicationKeyExpired;

export type ExternalIdAlreadyUsed = {
  externalId: Scalars['String'];
};

export type ExternalLoginUriNotAllowed = {
  reason: Scalars['String'];
};

export type FasterThanPossibleTravel = {
  decision: RadarDecision;
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
  notifyUser: Scalars['Boolean'];
};

export type FinalizePaymentMethodInput = {
  stripePaymentMethodId: Scalars['String'];
};

export type FinalizePaymentMethodResult = PaymentMethodAdded | StripeCardError;

export type FirstPartyApplication = Application & {
  clientConfidentiality: ApplicationClientConfidentiality;
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credentials: Array<ApplicationCredential>;
  darkLogoPath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isClientIdMetadataDocument: Scalars['Boolean'];
  isFirstParty: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lightLogoPath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions: Array<Permission>;
  redirectUris: Array<RedirectUri>;
  type: ApplicationType;
  updatedAt: Scalars['DateTime'];
};

export type Flag = {
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  flagEnvironments?: Maybe<Array<FlagEnvironment>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  owner?: Maybe<User>;
  projectId: Scalars['String'];
  slug: Scalars['String'];
  tags: Array<Tag>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type FlagAlreadyExists = {
  slug: Scalars['String'];
};

export type FlagCreated = {
  flag: Flag;
};

export type FlagDeleted = {
  flagId: Scalars['String'];
};

export type FlagEnvironment = {
  accessType: FlagEnvironmentAccessType;
  createdAt: Scalars['DateTime'];
  defaultEnabled: Scalars['Boolean'];
  environmentId: Scalars['String'];
  flagEnabled: Scalars['Boolean'];
  flagId: Scalars['String'];
  id: Scalars['ID'];
  organizations?: Maybe<Array<Organization>>;
  uniqueUsersCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<UserlandUser>>;
};

/** The access type for a flag environment. */
export enum FlagEnvironmentAccessType {
  All = 'ALL',
  None = 'NONE',
  Some = 'SOME',
}

export type FlagEnvironmentNotFound = {
  flagEnvironmentId: Scalars['String'];
};

export type FlagEnvironmentUpdated = {
  flagEnvironment: FlagEnvironment;
};

export type FlagList = {
  data: Array<Flag>;
  listMetadata: ListMetadata;
};

export type FlagNotFound = {
  flagId: Scalars['String'];
};

export type FlagSlugInvalid = {
  slug: Scalars['String'];
};

export type FlagUpdated = {
  flag: Flag;
};

export type Font = {
  family: Scalars['String'];
  src?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type FontInput = {
  family: Scalars['String'];
  src?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type FourthHrDirectory = {
  organizationId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type GeneratePortalLinkInput = {
  intent: GeneratePortalLinkIntent;
};

/** Enum represents the intent of the Admin Portal link request. */
export enum GeneratePortalLinkIntent {
  AuditLogs = 'AuditLogs',
  DSync = 'DSync',
  DomainVerification = 'DomainVerification',
  LogStreams = 'LogStreams',
  Sso = 'SSO',
}

export type GeneratePortalLinkResult =
  | OrganizationNotFound
  | PortalLinkGenerated
  | SsoAlreadyConnectedForDomain
  | UserNotAuthorized;

export type GeneratePortalSetupLinkInput = {
  expireIntents?: InputMaybe<Array<PortalSetupLinkIntent>>;
  intents: Array<PortalSetupLinkIntent>;
  organizationId: Scalars['String'];
};

export type GeneratePortalSetupLinkResult =
  | OrganizationNotFound
  | PortalSetupLinkGenerated;

export type GenerateSharedSlackChannelResult = SharedSlackChannelGenerated;

export type GenerateStripeConnectAuthorizeUrlResult =
  GenerateStripeConnectAuthorizeUrlSuccess;

export type GenerateStripeConnectAuthorizeUrlSuccess = {
  url: Scalars['String'];
};

export type GenericAuthenticationFactorType = {
  /** Placeholder field to allow empty @ObjectType for GenericAuthenticationFactor. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type GenericHttpsLogStream = {
  authHeaderName?: Maybe<Scalars['String']>;
  authHeaderValue?: Maybe<Scalars['String']>;
  requestBodyFormat?: Maybe<GenericHttpsLogStreamRequestBodyFormat>;
  url?: Maybe<Scalars['String']>;
};

export enum GenericHttpsLogStreamRequestBodyFormat {
  Json = 'JSON',
  Ndjson = 'NDJSON',
}

export type GetAdminPortalCustomBrandingAssetUploadUrlInput = {
  contentType: S3ContentType;
};

export type GetAdminPortalCustomBrandingAssetUploadUrlResult =
  AdminPortalCustomBrandingAssetUploadUrlRetrieved;

export type GetMigrationApplicationsResult = {
  applications: Array<ProviderApplicationWithStatus>;
};

export type GetMigrationConnectionsResult = {
  connections: Array<ProviderConnectionWithStatus>;
};

export type GoogleAnalyticsApiSecretInvalid = {
  validationError: Scalars['String'];
};

export type GoogleAnalyticsConfig = {
  apiSecret: Scalars['String'];
  enabled: Scalars['Boolean'];
  measurementId: Scalars['String'];
};

export type GoogleAnalyticsConfigUpserted = {
  googleAnalyticsConfig: GoogleAnalyticsConfig;
};

export type GoogleAnalyticsMeasurementIdInvalid = {
  validationError: Scalars['String'];
};

export type GoogleCloudStorageLogStream = {
  accessKeyId?: Maybe<Scalars['String']>;
  bucketName?: Maybe<Scalars['String']>;
  bucketPath?: Maybe<Scalars['String']>;
  secretAccessKey?: Maybe<Scalars['String']>;
};

export type GoogleWorkspaceDirectory = {
  clientChannelToken?: Maybe<Scalars['String']>;
  clientRefreshToken?: Maybe<Scalars['String']>;
  syncDerivedGroupMembers: Scalars['Boolean'];
};

export type GroupRoleMapping = {
  createdAt: Scalars['DateTime'];
  entityId: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['ID'];
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['String']>;
  stableGroupId: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GroupRoleMappingCountForRole = {
  count: Scalars['Float'];
  roleId: Scalars['String'];
};

export type GroupRoleMappingCountForRoleList = {
  data: Array<GroupRoleMappingCountForRole>;
};

export type GroupRoleMappingDefinitionInput = {
  roleId: Scalars['String'];
  stableGroupId: Scalars['String'];
};

export type GroupRoleMappingsDeleted = {
  groupRoleMappingIds: Array<Scalars['String']>;
};

export type GroupRoleMappingsList = {
  data: Array<GroupRoleMapping>;
};

export type GroupRoleMappingsUpserted = {
  groupRoleMappings: GroupRoleMappingsList;
};

export type GustoDirectory = {
  companyId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type HibobDirectory = {
  apiToken?: Maybe<Scalars['String']>;
  serviceUserId?: Maybe<Scalars['String']>;
};

export type HintedApplicationCredential = ApplicationCredential & {
  applicationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  secretHint: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type IdTokenInvalidError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type IdpAttributesConfigNotFound = {
  idpAttributesConfigId: Scalars['String'];
};

export type IdpAttributesConfigUpdated = {
  idpAttributesConfigId: Scalars['String'];
};

export type IdpIdInvalidError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type IdpInitiatedExpiredResponseError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type IdpInitiatedWithBookmarkError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type IdpInitiatedWithInResponseToError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type IdpStatusCodeAuthenticationFailedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
  statusMessage: Scalars['String'];
};

export type IdpStatusCodeInvalidNameIdPolicyError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
  statusMessage: Scalars['String'];
};

export type IdpStatusCodeInvalidSamlRequestSignatureError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
  statusMessage: Scalars['String'];
};

export type IdpStatusCodeNotSuccessfulError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
  statusMessage: Scalars['String'];
};

export type IdpStatusCodeRequestDeniedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
  statusMessage: Scalars['String'];
};

export type ImpersonateUserlandUserInput = {
  impersonationReason?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  userlandUserId: Scalars['String'];
};

export type ImpersonateUserlandUserResult =
  | DefaultRedirectUriNotFound
  | ImpersonationDisabled
  | ImpersonationOrganizationSelectionRequired
  | ImpersonationReasonRequired
  | ImpersonationSessionCreated
  | OrganizationNotFound
  | UserlandUserNotFound;

export type ImpersonationDisabled = {
  message: Scalars['String'];
};

export type ImpersonationOrganizationSelectionRequired = {
  message: Scalars['String'];
};

export type ImpersonationReasonRequired = {
  message: Scalars['String'];
};

export type ImpersonationSessionCreated = {
  url: Scalars['String'];
};

export type ImportMigrationApplicationsError = {
  message: Scalars['String'];
};

export type ImportMigrationApplicationsInput = {
  customerMigrationId: Scalars['ID'];
  externalIds: Array<Scalars['String']>;
  targetApi: Scalars['String'];
};

export type ImportMigrationApplicationsResult =
  | CustomerMigrationNotFoundForApplications
  | ImportMigrationApplicationsError
  | ImportMigrationApplicationsSuccess;

export type ImportMigrationApplicationsSuccess = {
  applications: Array<CustomerMigrationApplication>;
};

export type ImportMigrationConnectionsError = {
  message: Scalars['String'];
};

export type ImportMigrationConnectionsInput = {
  customerMigrationId: Scalars['ID'];
  externalIds: Array<Scalars['String']>;
};

export type ImportMigrationConnectionsResult =
  | CustomerMigrationNotFoundForConnections
  | ImportMigrationConnectionsError
  | ImportMigrationConnectionsSuccess;

export type ImportMigrationConnectionsSuccess = {
  accepted: Scalars['Boolean'];
};

export type InitiateLoginUrlUpdated = {
  url: Scalars['String'];
};

export type InternalDirectory = {
  createdAt: Scalars['DateTime'];
  groups: InternalDirectoryGroupList;
  id: Scalars['ID'];
  isSyncing: Scalars['Boolean'];
  name: Scalars['String'];
  state: DirectoryState;
  type: DirectoryType;
};

export type InternalDirectoryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type InternalDirectoryGroup = {
  id: Scalars['ID'];
  name: Scalars['String'];
  role?: Maybe<UsersOrganizationsRole>;
};

export type InternalDirectoryGroupList = {
  data: Array<InternalDirectoryGroup>;
  listMetadata: ListMetadata;
};

export type InternalDirectoryGroupNotFound = {
  internalDirectoryGroupId: Scalars['String'];
};

export type InvalidAdpConnectionSslCertificate = {
  privateKey: Scalars['String'];
  value: Scalars['String'];
};

export type InvalidAssertionError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidAttributesError = {
  code: ConnectionSessionErrorCode;
  expected_attributes: ExpectedAttributes;
  reason: Scalars['String'];
  received_attributes: Array<ReceivedAttribute>;
};

export type InvalidAudienceError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidAuditLogAction = {
  action: Scalars['String'];
  message: Scalars['String'];
};

export type InvalidAuditLogSchema = {
  message: Scalars['String'];
};

export type InvalidAuditLogStreamCredentials = {
  message: Scalars['String'];
};

export type InvalidAuditLogTargets = {
  message: Scalars['String'];
  targets: Array<Scalars['String']>;
};

export type InvalidAuthkitOauthResourceError = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidClaimNonce = {
  message: Scalars['String'];
};

export type InvalidContext = {
  error: Scalars['String'];
};

export type InvalidCustomDomain = {
  domain: Scalars['String'];
};

export type InvalidCustomEmailDomain = {
  domain: Scalars['String'];
};

export type InvalidDataIntegrationCredentialsType = {
  message: Scalars['String'];
};

export type InvalidDatadogCredentials = {
  message: Scalars['String'];
};

export type InvalidDirectoryGroupConfigCursor = {
  cursor?: Maybe<Scalars['String']>;
};

export type InvalidDomain = {
  domain: Scalars['String'];
};

export type InvalidEmail = {
  email: Scalars['String'];
};

export type InvalidEmailError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidExportDateRange = {
  message: Scalars['String'];
};

export type InvalidExternalLoginUri = {
  externalLoginUri: Scalars['String'];
};

export type InvalidExternalLoginUriProtocol = {
  protocol: Scalars['String'];
};

export type InvalidIssueInstantAssertionError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidIssuerError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidJwtTemplateContextError = {
  error: Scalars['String'];
};

export type InvalidLogoutUriError = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidOauthCredentials = {
  errors: Array<OauthCredentialsError>;
};

export type InvalidRedirectUri = {
  invalidFields: Scalars['JSON'];
  validationError: Scalars['String'];
};

export type InvalidRedirectUriError = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidRelayStateError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidSamlSchemaError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidSamlSignatureError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InvalidSamlX509Certificate = {
  validationError: SamlX509CertificateValidationErrorCode;
};

export type InvalidSshKey = {
  message: Scalars['String'];
};

export type InvalidStripeConnectOAuthState = {
  errorMessage: Scalars['String'];
};

export type InvalidTeamName = {
  team: Team;
};

export type InvalidWebOriginProtocol = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidWildcardLogoutUri = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidWildcardRedirectUri = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidWildcardWebOrigin = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type InvalidX509CertError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type InviteToSharedSlackChannelResult =
  | SlackChannelForTeamNotFound
  | SlackChannelInviteSent
  | SlackChannelNotReadyForInvites;

export type InviteUserToTeamInput = {
  user: UserInviteInput;
};

export type InviteUserToTeamResult =
  | UserAlreadyBelongsToAnotherTeam
  | UserAlreadyBelongsToCurrentTeam
  | UserInvitedToTeam;

export type InvoiceLineItem = {
  name: Scalars['String'];
  quantity: Scalars['Float'];
  tiers?: Maybe<Array<InvoiceLineItemTier>>;
  total: Scalars['Float'];
  type: InvoiceLineItemType;
  unitAmount?: Maybe<Scalars['Float']>;
};

export type InvoiceLineItemTier = {
  from: Scalars['Float'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  to?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  unitAmount: Scalars['Float'];
};

export enum InvoiceLineItemType {
  Tiered = 'Tiered',
  Unit = 'Unit',
}

export type InvoiceNotFound = {
  invoiceId: Scalars['String'];
};

export type JwtTemplate = {
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type JwtTemplateDeleted = {
  jwtTemplateId: Scalars['String'];
};

export type JwtTemplateRenderingError = {
  error: Scalars['String'];
};

export type JwtTemplateRenderingResult = {
  renderedTemplate: Scalars['JSON'];
};

export type JwtTemplateUpserted = {
  jwtTemplate: JwtTemplate;
};

export type JwtTemplateValidationError = {
  error: Scalars['String'];
};

export type JwtTemplateValidationResult = {
  error?: Maybe<Scalars['String']>;
};

export type Key = {
  applicationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayValue: Scalars['String'];
  expiredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform?: Maybe<Scalars['String']>;
  type: KeyType;
  updatedAt: Scalars['DateTime'];
};

export type KeyAlreadyExpired = {
  key: Key;
};

export type KeyCreated = {
  key: NewlyCreatedKey;
};

export type KeyExpired = {
  expiredKey: Key;
  newKey?: Maybe<NewlyCreatedKey>;
};

export type KeyList = {
  data: Array<Key>;
  listMetadata: ListMetadata;
};

export type KeyNotFound = {
  keyId: Scalars['String'];
};

/** Enum represents a scope of API keys that can be returned. */
export enum KeyScope {
  Active = 'Active',
  All = 'All',
  PlatformManaged = 'PlatformManaged',
  RecentlyExpired = 'RecentlyExpired',
  UserManaged = 'UserManaged',
}

/** Enum representing a type of key. */
export enum KeyType {
  Secret = 'SECRET',
}

export type LastInvoiceSummary = {
  id: Scalars['String'];
  pdfUrl?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
};

export type LegacyBillingInvoice = {
  appliedBalance?: Maybe<Scalars['Float']>;
  billingPeriodStart: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  finalizedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentStatus: BillingInvoicePaymentStatus;
  pdfUrl?: Maybe<Scalars['String']>;
  planKey: Scalars['String'];
  receiptPdfUrl?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalDiscount?: Maybe<Scalars['Float']>;
};

export type ListMetadata = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};

/** Enum represents the type of a LogoIconFit. */
export enum LogoIconFit {
  Contain = 'Contain',
  Cover = 'Cover',
}

/** Enum represents the type of a LogoStyle. */
export enum LogoStyle {
  Icon = 'Icon',
  Logo = 'Logo',
  None = 'None',
}

export type LogoutUri = {
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  uri: Scalars['String'];
};

export type LogoutUriList = {
  data: Array<LogoutUri>;
  listMetadata: ListMetadata;
};

export type LogoutUrisSet = {
  logoutUris: Array<LogoutUri>;
};

export type MailgunCustomEmailProvider = CustomEmailProvider & {
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  mailgunDomain: Scalars['String'];
  mailgunRegion: MailgunCustomEmailProviderRegion;
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type MailgunCustomEmailProviderDomainNotVerifiedError = {
  domain: Scalars['String'];
};

/** The region of the Mailgun custom email provider. */
export enum MailgunCustomEmailProviderRegion {
  Eu = 'EU',
  Us = 'US',
}

export type MalformedDirectoryGroupError = {
  code: DirectorySyncRunErrorCode;
  reason: Scalars['String'];
};

export type MalformedDirectoryUserError = {
  code: DirectorySyncRunErrorCode;
  reason: Scalars['String'];
};

export type MalformedFileError = {
  code: DirectorySyncRunInternalErrorCode;
  fields: Array<Scalars['String']>;
  file: Scalars['String'];
  reason: Scalars['String'];
};

export type MalformedSamlResponseError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type MalformedWebOrigin = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type ManagedListBinding = {
  action: RadarListAction;
};

export type MembershipCountForRole = {
  membershipCount: Scalars['Int'];
};

export type MembershipCountForRoleResult =
  | MembershipCountForRole
  | RoleNotFound;

export type MetadataFetchFailed = {
  reason: Scalars['String'];
};

export type MetadataParseFailed = {
  reason: Scalars['String'];
};

export type MetricSummary = {
  current: Scalars['Float'];
  pctChange?: Maybe<Scalars['Float']>;
  previous: Scalars['Float'];
};

export type MigrationApplicationNotFound = {
  message: Scalars['String'];
};

export type MigrationConnectionNotFound = {
  message: Scalars['String'];
};

export type MissingCode = {
  errorMessage: Scalars['String'];
};

export type MissingDirectoryGroupsConfigsToUpdate = {
  directoryId: Scalars['String'];
};

export type MissingFileError = {
  code: DirectorySyncRunInternalErrorCode;
  file: Scalars['String'];
  reason: Scalars['String'];
};

export type MissingIntent = {
  intents: Array<PortalSetupLinkIntent>;
};

export type MissingSamlEntityIdError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type MissingSamlIdpUrlError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type MissingSamlRelyingPartyPrivateKeyError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type MultipleDefaultUrisError = {
  message: Scalars['String'];
};

export type Mutation = {
  acceptComplianceTerms: AcceptComplianceTermsResult;
  activateUserManagement: ActivateUserManagementResult;
  addAdpConnectionSslCertificate: AddAdpConnectionSslCertificateResult;
  addBillingAddress: AddBillingAddressResult;
  addDomains: AddDomainsResult;
  /** @deprecated Use addOrganizationAdmins instead. */
  addOrganizationAdmin: AddOrganizationAdminResult;
  addOrganizationAdmins: AddOrganizationAdminsResult;
  addPaymentMethod: AddPaymentMethodResult;
  addRadarListEntry: AddRadarListEntryResult;
  addTaxId: AddTaxIdResult;
  addUserlandUserToOrganization: AddUserlandUserToOrganizationResult;
  addUsersToTeam: AddUsersToTeamPayload;
  approveWaitlistEntry: ApproveWaitlistEntryResult;
  assignRoleToInternalDirectoryGroup: AssignRoleToInternalDirectoryGroup;
  authorizeErrorWithTestIdp: AuthorizeWithTestIdpPayload;
  authorizeWithTestIdp: AuthorizeWithTestIdpPayload;
  bindManagedListToEnvironment: BindManagedListToEnvironmentResult;
  buildTestSamlResponse: BuildTestSamlResponsePayload;
  cancelStripeConnect: CancelStripeConnectResult;
  changeRole: UsersTeam;
  claimOneShotEnvironment: ClaimOneShotEnvironmentResult;
  completeCustomerMigrationSetup: CompleteCustomerMigrationSetupResult;
  completeOnboardingGuide: CompleteOnboardingResult;
  completeStripeConnect: CompleteStripeConnectResult;
  configureAzureSentinelLogStream: ConfigureAuditLogStreamResult;
  configureCloudflareDomain: ConfigureCloudflareDomainResult;
  configureDatadogLogStreamWithRegion: ConfigureAuditLogStreamResult;
  configureDatadogWebhookEndpoint: DatadogWebhookEndpointResult;
  configureGenericHttpsLogStream: ConfigureAuditLogStreamResult;
  configureGoogleCloudStorageLogStream: ConfigureAuditLogStreamResult;
  configureS3LogStream: ConfigureAuditLogStreamResult;
  configureSplunkLogStream: ConfigureAuditLogStreamResult;
  createApplication: CreateApplicationResult;
  createApplicationCredential: CreateApplicationCredentialResult;
  createAuditLogExport: CreateAuditLogExportResult;
  createAuditLogStream: CreateAuditLogStreamResult;
  createAuditLogValidator: CreateAuditLogValidatorResult;
  createAuditLogValidatorVersion: CreateAuditLogValidatorVersionResult;
  createComplianceExport: CreateComplianceExportResult;
  createConnection: CreateConnectionResult;
  createConnectionGroup: CreateConnectionGroupResult;
  createConnectionGroupWithRoleMapping: CreateConnectionGroupWithRoleMappingResult;
  createCustomDomain: CreateCustomDomainResult;
  createCustomEmailDomain: CreateCustomEmailDomainResult;
  createCustomEmailProvider: CreateCustomEmailProviderResult;
  createCustomMappedCustomAttribute: CreateCustomMappedCustomAttributeResult;
  createCustomerMigration: CreateCustomerMigrationResult;
  createDatadogWebhookEndpoint: DatadogWebhookEndpointResult;
  createDirectory: Directory;
  createDirectoryConfigDashboard: CreateDirectoryConfigDashboardResult;
  createEnvironment: CreateEnvironmentResponse;
  createFlag: CreateFlagResult;
  createKey: CreateKeyResult;
  createOauthCredentials: CreateOauthCredentialsPayload;
  createOrganization: CreateOrganizationResult;
  createOrganizationIdpAttributesConfig: CreateOrganizationIdpAttributesConfigResult;
  createOrganizationRoleConfig: CreateOrganizationRoleConfigResult;
  createPermission: CreatePermissionResult;
  createResourceType: CreateAuthorizationResourceTypeResult;
  createRole: CreateRoleResult;
  createUserlandApplication: CreateUserlandApplicationResult;
  createUserlandApplicationKey: CreateUserlandApplicationKeyResult;
  createUserlandUser: CreateUserlandUserResult;
  createUserlandUserInvite: CreateUserlandUserInviteResult;
  createWebhookEndpoint: WebhookEndpoint;
  deactivateUserlandUserOrganizationMembership: DeactivateUserlandUserOrganizationMembershipResult;
  deauthorizeStripe: DeauthorizeStripeResult;
  deleteActionsEndpoint: DeleteActionsEndpointResult;
  deleteAdpConnectionSslCertificate: DeleteAdpConnectionSslCertificateResult;
  deleteApiKey: DeleteApiKeyPayload;
  deleteApplication: DeleteApplicationResult;
  deleteApplicationCredential: DeleteApplicationCredentialResult;
  deleteAuditLogStream: DeleteAuditLogStreamResult;
  deleteAuditLogValidator: DeleteAuditLogValidatorResult;
  deleteAuditLogValidatorVersion: DeleteAuditLogValidatorVersionResult;
  deleteAuthenticationFactor: DeleteAuthenticationFactorResult;
  deleteConnection: Scalars['String'];
  deleteConnectionGroup: DeleteConnectionGroupResult;
  deleteCustomEmailDomain: DeleteCustomEmailDomainResult;
  deleteCustomEmailProvider: DeleteCustomEmailProviderResult;
  deleteCustomMappedCustomAttribute: DeleteCustomMappedCustomAttributeResult;
  deleteCustomerMigration: DeleteCustomerMigrationResult;
  deleteDataInstallation: DeleteDataInstallationResult;
  deleteDataIntegration: DeleteDataIntegrationResult;
  deleteDirectory: DeleteDirectoryPayload;
  deleteFlag: DeleteFlagResult;
  deleteGroupRoleMappings: DeleteGroupRoleMappingsResult;
  deleteJwtTemplate: DeleteJwtTemplateResult;
  deleteMigrationApplication: DeleteMigrationApplicationResult;
  deleteMigrationConnection: DeleteMigrationConnectionResult;
  deleteOrganization: DeleteOrganizationPayload;
  deleteOrganizationAdminMembership: DeleteOrganizationAdminMembershipResult;
  deleteOrganizationDomain: OrganizationDomain;
  deletePermission: DeletePermissionResult;
  deleteRedirectUri: Scalars['String'];
  deleteResourceType: DeleteAuthorizationResourceTypeResult;
  deleteRole: DeleteRoleResult;
  deleteSamlX509Certificate: DeleteSamlX509CertificateResult;
  deleteTeam: DeleteTeamResult;
  deleteUserlandApplication: DeleteUserlandApplicationResult;
  deleteUserlandUser: DeleteUserlandUserResult;
  deleteWaitlistEntry: Scalars['Boolean'];
  deleteWebhookEndpoint: Scalars['String'];
  deprovisionPlatform: DeprovisionPlatformResult;
  disconnectSlack: DisconnectSlackResult;
  dismissQuickStart: Environment;
  enrollTotpAuthenticationFactor: EnrollTotpUserAuthenticationFactorResult;
  entitlementsUserClickedUpgradeButton: SuccessResponse;
  expireKey: ExpireKeyResult;
  expirePortalSetupLink: ExpirePortalSetupLinkResult;
  expirePortalSetupLinks: ExpirePortalSetupLinksResult;
  expireUserlandApplicationKey: ExpireUserlandApplicationKeyResult;
  finalizePaymentMethod: FinalizePaymentMethodResult;
  generateAuditTrailEventsCSV: Scalars['String'];
  generatePortalLink: GeneratePortalLinkResult;
  generatePortalSetupLink: GeneratePortalSetupLinkResult;
  generateSharedSlackChannel: GenerateSharedSlackChannelResult;
  generateSlackInstallUrl: SlackInstallUrl;
  generateStripeConnectAuthorizeUrl: GenerateStripeConnectAuthorizeUrlResult;
  getAdminPortalCustomBrandingAssetUploadUrl: GetAdminPortalCustomBrandingAssetUploadUrlResult;
  impersonateUserlandUser: ImpersonateUserlandUserResult;
  importMigrationApplications: ImportMigrationApplicationsResult;
  importMigrationConnections: ImportMigrationConnectionsResult;
  inviteToSharedSlackChannel: InviteToSharedSlackChannelResult;
  inviteUserToTeam: InviteUserToTeamResult;
  manuallyVerifyOrganizationDomain: OrganizationDomain;
  onboarding_completeStep: OnboardingCompleteStepPayload;
  onboarding_enterTeamDetails: EnterTeamDetailsPayload;
  previewJwtTemplate: PreviewJwtTemplateResult;
  reactivateUserlandUserOrganizationMembership: ReactivateUserlandUserOrganizationMembershipResult;
  refreshCustomDomain: RefreshCustomDomainResult;
  registerCustomDomain: RegisterCustomDomainResult;
  removeCustomDomain: RemoveCustomDomainResult;
  removeEmailSuppression: RemoveEmailSuppressionResult;
  removeRadarListEntry: RemoveRadarListEntryResult;
  removeUserFromTeam: Scalars['String'];
  removeUserlandUserFromOrganization: RemoveUserlandUserFromOrganizationResult;
  requestCustomDataIntegration: RequestCustomDataIntegrationResult;
  requestDataIntegration: RequestDataIntegrationResult;
  requestDataProvider: RequestDataProviderResult;
  resendDashboardInvite: ResendDashboardInviteResult;
  resendUserlandUserInvite: ResendUserlandUserInviteResult;
  resendWebhookEvent: ResendWebhookEventResult;
  resetOauthCredentials: ResetOauthCredentialsPayload;
  resetOrganizationIdpAttributesConfig: ResetOrganizationIdpAttributesConfigResult;
  resetOrganizationRoleConfig: ResetOrganizationRoleConfigResult;
  resetUserMfaSettings: ResetUserMfaSettingsResult;
  /** @deprecated Please use `resetUserlandUserSecondFactors` instead. */
  resetUserlandUserAuthenticationFactors: ResetUserlandUserAuthenticationFactorsResult;
  resetUserlandUserSecondFactors: ResetUserlandUserAuthenticationFactorsResult;
  restartOrganizationDomainVerification: OrganizationDomain;
  revokeUserlandSession: RevokeUserlandSessionResult;
  revokeUserlandUserInvite: RevokeUserlandUserInviteResult;
  sendSetupLinkEmails: SendSetupLinkEmailsResult;
  sendTestEmail: SendTestEmailResult;
  setApplicationPermissions: SetApplicationPermissionsResult;
  setAuthkitOauthResources: SetAuthkitOauthResourcesResult;
  setAutoMappedCustomAttributes: SetAutoMappedCustomAttributesResult;
  setDefaultDynamicRegistrationOAuthScopes: SetDefaultDynamicRegistrationOAuthScopesResult;
  setDirectoryCustomAttributeMappings: SetDirectoryCustomAttributeMappingsResult;
  /** @deprecated Please use `updateOrganization` instead. */
  setDomainsForOrganization: SetDomainsForOrganizationPayload;
  setEmailNotificationPreferences: SetEmailNotificationPreferencesResult;
  setLogoutUris: SetLogoutUrisResult;
  setPermissionsEnabledForApiKeys: SetPermissionsEnabledForApiKeysResult;
  setRedirectUris: SetRedirectUrisResult;
  setSsoCustomAttributeMappings: SetSsoAttributeMappingsResult;
  setTeamDefaultRole: SetTeamDefaultRoleResult;
  setUserlandApplicationLogoutUris: SetUserlandApplicationLogoutUrisResult;
  setUserlandApplicationRedirectUris: SetUserlandApplicationRedirectUrisResult;
  setUserlandApplicationWebOrigins: SetUserlandApplicationWebOriginsResult;
  setWebOrigins: SetWebOriginsResult;
  startSyncingInternalDirectory: StartSyncingInternalDirectoryResult;
  testActionEndpoint: TestActionEndpointResult;
  testJwtTemplate: TestJwtTemplateResult;
  testWebhookEndpoint: Webhook;
  unassignRoleFromInternalDirectoryGroup: UnassignRoleFromInternalDirectoryGroupResult;
  unbindManagedListFromEnvironment: UnbindManagedListFromEnvironmentResult;
  updateAppBranding: UpdateAppBrandingResult;
  updateApplication: UpdateApplicationResult;
  updateAttributeMapV2: AttributeMap;
  updateAuth0MigrationCredentials: UpdateAuth0MigrationCredentialsResult;
  updateConnection: UpdateConnectionResult;
  updateConnectionFromDiscoveryEndpoint: UpdateConnectionFromDiscoveryEndpointResult;
  updateConnectionFromMetadataUrl: UpdateConnectionFromMetadataUrlResult;
  updateConnectionFromMetadataXml: UpdateConnectionFromMetadataXmlResult;
  updateConnectionGroup: UpdateConnectionGroupResult;
  updateCustomEmailProvider: UpdateCustomEmailProviderResult;
  updateCustomMappedCustomAttribute: UpdateCustomMappedCustomAttributeResult;
  updateDataIntegration: UpdateDataIntegrationResult;
  updateDataProviderIntegration: UpdateDataProviderIntegrationResult;
  updateDirectory: UpdateDirectoryResult;
  updateDirectoryAttributeMap?: Maybe<DirectoryAttributeMap>;
  updateDirectoryConfigDashboard: DirectoryConfig;
  updateDirectoryGroupConfigsAllowList: UpdateDirectoryGroupConfigsAllowListResult;
  updateEnvironmentLocalization: UpdateEnvironmentLocalizationPayload;
  updateEnvironmentOrganizationAdminCollectionEnabled: UpdateEnvironmentOrganizationAdminCollectionEnabledPayload;
  updateEnvironmentSsoSigninConsent: UpdateEnvironmentSsoSigninConsentPayload;
  updateFlag: UpdateFlagResult;
  updateFlagEnvironment: UpdateFlagEnvironmentResult;
  updateIdpAttributesConfig: UpdateIdpAttributesConfigResult;
  updateInitiateLoginUrl: UpdateInitiateLoginUrlResult;
  updateMigrationApplicationStatus: UpdateMigrationApplicationStatusResult;
  updateMigrationConnectionStatus: UpdateMigrationConnectionStatusResult;
  updateMigrationProxyStatus: UpdateMigrationProxyStatusResult;
  updateMyself: UpdateMyselfResult;
  updateNotification: Notification;
  updateOauthCredentials: UpdateOauthCredentialsResult;
  updateOrganization: UpdateOrganizationResult;
  updatePermission: UpdatePermissionResult;
  updatePortalSettings: PortalSettings;
  updatePortalSettingsV2: UpdatePortalSettingsResult;
  updateRadarSettings: UpdateRadarSettingsResult;
  updateRadarSettingsMode: UpdateRadarSettingsResult;
  updateRedirectUri: RedirectUri;
  updateResourceType: UpdateAuthorizationResourceTypeResult;
  updateRole: UpdateRoleResult;
  updateRoleConfig: UpdateRoleConfigResult;
  updateRoleOnOrganizationMembership: UpdateRoleOnOrganizationMembershipResult;
  updateSession?: Maybe<Session>;
  updateStripeConfiguration: UpdateStripeConfigurationSuccess;
  updateTeamDetails: UpdateTeamDetailsResult;
  updateTeamMfaRequirement: UpdateTeamMfaRequirementResult;
  updateUserManagementActivated: ActivateUserManagementResult;
  updateUserlandApplication: UpdateUserlandApplicationResult;
  updateUserlandEmailSettings: UpdateUserlandEmailSettingsResult;
  updateUserlandExternalLoginUri: UpdateUserlandExternalLoginUriResult;
  updateUserlandImpersonationSettings: UpdateUserlandImpersonationSettingsResult;
  updateUserlandPasswordAuthenticationConfig: UpdateUserlandPasswordAuthenticationConfigResult;
  updateUserlandSettings: UpdateUserlandSettingsResult;
  updateUserlandUser: UpdateUserlandUserResult;
  updateWebhookEndpoint: WebhookEndpoint;
  uploadCustomFonts: UploadCustomFontsResult;
  upsertActionsEndpoint: UpsertActionsEndpointResult;
  upsertAuth0Credential: UpsertAuth0CredentialResult;
  upsertGoogleAnalyticsConfig: UpsertGoogleAnalyticsConfigResult;
  upsertGroupRoleMappings: UpsertDirectoryGroupRoleMappingsResult;
  upsertGroupRoleMappingsForConnection: UpsertConnectionGroupRoleMappingsResult;
  upsertJwtTemplate: UpsertJwtTemplateResult;
  upsertSamlX509Certificate: UpsertSamlX509CertificateResult;
  upsertSegmentConfig: UpsertSegmentConfigResult;
  validateJwtTemplate: ValidateJwtTemplateResult;
  verifyAuthenticationFactorEnrollment: VerifyAuthenticationFactorEnrollmentResult;
  verifyCustomEmailDomain: VerifyCustomEmailDomainResult;
  verifyDomainStatus: VerifyDomainStatusResult;
  verifyRedirectUri: VerifyRedirectUriResult;
};

export type MutationAddAdpConnectionSslCertificateArgs = {
  input: AddAdpConnectionSslCertificateInput;
};

export type MutationAddBillingAddressArgs = {
  input: AddBillingAddressInput;
};

export type MutationAddDomainsArgs = {
  input: AddOrganizationDomainsInput;
};

export type MutationAddOrganizationAdminArgs = {
  input: AddOrganizationAdminInput;
};

export type MutationAddOrganizationAdminsArgs = {
  input: AddOrganizationAdminsInput;
};

export type MutationAddPaymentMethodArgs = {
  input: AddPaymentMethodInput;
};

export type MutationAddRadarListEntryArgs = {
  input: AddRadarListEntryInput;
};

export type MutationAddTaxIdArgs = {
  input: AddTaxIdToTeamInput;
};

export type MutationAddUserlandUserToOrganizationArgs = {
  input: AddUserlandUserToOrganizationInput;
};

export type MutationAddUsersToTeamArgs = {
  input: AddUsersToTeamInput;
};

export type MutationApproveWaitlistEntryArgs = {
  input: ApproveWaitlistEntryInput;
};

export type MutationAssignRoleToInternalDirectoryGroupArgs = {
  input: AssignRoleToInternalDirectoryGroupInput;
};

export type MutationAuthorizeErrorWithTestIdpArgs = {
  input: AuthorizeErrorWithTestIdpInput;
};

export type MutationAuthorizeWithTestIdpArgs = {
  input: AuthorizeWithTestIdpInput;
};

export type MutationBindManagedListToEnvironmentArgs = {
  input: BindManagedListToEnvironmentInput;
};

export type MutationBuildTestSamlResponseArgs = {
  input: BuildTestSamlResponseInput;
};

export type MutationCancelStripeConnectArgs = {
  environmentId: Scalars['String'];
};

export type MutationChangeRoleArgs = {
  role: UsersOrganizationsRole;
  usersOrganizationsId: Scalars['String'];
};

export type MutationClaimOneShotEnvironmentArgs = {
  input: ClaimOneShotEnvironmentInput;
};

export type MutationCompleteCustomerMigrationSetupArgs = {
  input: CompleteCustomerMigrationSetupInput;
};

export type MutationCompleteOnboardingGuideArgs = {
  input: CompleteOnboardingGuideInput;
};

export type MutationCompleteStripeConnectArgs = {
  input: CompleteStripeConnectInput;
};

export type MutationConfigureAzureSentinelLogStreamArgs = {
  input: ConfigureAzureSentinelLogStreamInput;
};

export type MutationConfigureCloudflareDomainArgs = {
  input: ConfigureCloudflareDomainInput;
};

export type MutationConfigureDatadogLogStreamWithRegionArgs = {
  input: ConfigureDatadogLogStreamWithRegionInput;
};

export type MutationConfigureDatadogWebhookEndpointArgs = {
  apiKey: Scalars['String'];
  id: Scalars['String'];
  region: Scalars['String'];
};

export type MutationConfigureGenericHttpsLogStreamArgs = {
  input: ConfigureGenericHttpsLogStreamInput;
};

export type MutationConfigureGoogleCloudStorageLogStreamArgs = {
  input: ConfigureGoogleCloudStorageLogStreamInput;
};

export type MutationConfigureS3LogStreamArgs = {
  input: ConfigureS3LogStreamInput;
};

export type MutationConfigureSplunkLogStreamArgs = {
  input: ConfigureSplunkLogStreamInput;
};

export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};

export type MutationCreateApplicationCredentialArgs = {
  input: CreateApplicationCredentialInput;
};

export type MutationCreateAuditLogExportArgs = {
  input: CreateAuditLogExportInput;
};

export type MutationCreateAuditLogStreamArgs = {
  input: CreateAuditLogStreamInput;
};

export type MutationCreateAuditLogValidatorArgs = {
  input: CreateAuditLogValidatorInput;
};

export type MutationCreateAuditLogValidatorVersionArgs = {
  input: CreateAuditLogValidatorVersionInput;
};

export type MutationCreateComplianceExportArgs = {
  input: CreateComplianceExportInput;
};

export type MutationCreateConnectionArgs = {
  input: CreateConnectionInput;
};

export type MutationCreateConnectionGroupArgs = {
  input: CreateConnectionGroupInput;
};

export type MutationCreateConnectionGroupWithRoleMappingArgs = {
  input: CreateConnectionGroupWithRoleMappingInput;
};

export type MutationCreateCustomDomainArgs = {
  input: CreateCustomDomainInput;
};

export type MutationCreateCustomEmailDomainArgs = {
  input: CreateCustomEmailDomainInput;
};

export type MutationCreateCustomEmailProviderArgs = {
  input: CreateCustomEmailProviderInput;
};

export type MutationCreateCustomMappedCustomAttributeArgs = {
  input: CreateCustomMappedCustomAttributeInput;
};

export type MutationCreateCustomerMigrationArgs = {
  input: CreateCustomerMigrationInput;
};

export type MutationCreateDatadogWebhookEndpointArgs = {
  apiKey: Scalars['String'];
  environmentId: Scalars['String'];
  region: Scalars['String'];
};

export type MutationCreateDirectoryArgs = {
  domain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id: Scalars['String'];
  type: DirectoryType;
};

export type MutationCreateDirectoryConfigDashboardArgs = {
  input: CreateDirectoryConfigInput;
};

export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};

export type MutationCreateFlagArgs = {
  input: CreateFlagInput;
};

export type MutationCreateKeyArgs = {
  input: CreateKeyInput;
};

export type MutationCreateOauthCredentialsArgs = {
  input: CreateOauthCredentialsInput;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationIdpAttributesConfigArgs = {
  input: CreateOrganizationIdpAttributesConfigInput;
};

export type MutationCreateOrganizationRoleConfigArgs = {
  input: CreateOrganizationRoleConfigInput;
};

export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput;
};

export type MutationCreateResourceTypeArgs = {
  input: CreateAuthorizationResourceTypeInput;
};

export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

export type MutationCreateUserlandApplicationArgs = {
  input: CreateUserlandApplicationInput;
};

export type MutationCreateUserlandApplicationKeyArgs = {
  input: CreateUserlandApplicationKeyInput;
};

export type MutationCreateUserlandUserArgs = {
  input: CreateUserlandUserInput;
};

export type MutationCreateUserlandUserInviteArgs = {
  input: CreateUserlandUserInviteInput;
};

export type MutationCreateWebhookEndpointArgs = {
  endpointUrl: Scalars['String'];
  environmentId: Scalars['String'];
  events: Array<Scalars['String']>;
};

export type MutationDeactivateUserlandUserOrganizationMembershipArgs = {
  input: DeactivateUserlandUserOrganizationMembershipInput;
};

export type MutationDeauthorizeStripeArgs = {
  environmentId: Scalars['String'];
};

export type MutationDeleteActionsEndpointArgs = {
  input: DeleteActionsEndpointInput;
};

export type MutationDeleteAdpConnectionSslCertificateArgs = {
  input: DeleteAdpConnectionSslCertificateInput;
};

export type MutationDeleteApiKeyArgs = {
  input: DeleteApiKeyInput;
};

export type MutationDeleteApplicationArgs = {
  input: DeleteApplicationInput;
};

export type MutationDeleteApplicationCredentialArgs = {
  input: DeleteApplicationCredentialInput;
};

export type MutationDeleteAuditLogStreamArgs = {
  input: DeleteAuditLogStreamInput;
};

export type MutationDeleteAuditLogValidatorArgs = {
  input: DeleteAuditLogValidatorInput;
};

export type MutationDeleteAuditLogValidatorVersionArgs = {
  input: DeleteAuditLogValidatorVersionInput;
};

export type MutationDeleteAuthenticationFactorArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteConnectionArgs = {
  id: Scalars['String'];
};

export type MutationDeleteConnectionGroupArgs = {
  input: DeleteConnectionGroupInput;
};

export type MutationDeleteCustomEmailProviderArgs = {
  input: DeleteCustomEmailProviderInput;
};

export type MutationDeleteCustomMappedCustomAttributeArgs = {
  input: DeleteCustomMappedCustomAttributeInput;
};

export type MutationDeleteCustomerMigrationArgs = {
  input: DeleteCustomerMigrationInput;
};

export type MutationDeleteDataInstallationArgs = {
  input: DeleteDataInstallationInput;
};

export type MutationDeleteDataIntegrationArgs = {
  input: DeleteDataIntegrationInput;
};

export type MutationDeleteDirectoryArgs = {
  input: DeleteDirectoryInput;
};

export type MutationDeleteFlagArgs = {
  input: DeleteFlagInput;
};

export type MutationDeleteGroupRoleMappingsArgs = {
  input: DeleteGroupRoleMappingsInput;
};

export type MutationDeleteJwtTemplateArgs = {
  input: DeleteJwtTemplateInput;
};

export type MutationDeleteMigrationApplicationArgs = {
  id: Scalars['String'];
};

export type MutationDeleteMigrationConnectionArgs = {
  customerMigrationId: Scalars['String'];
  externalId: Scalars['String'];
};

export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};

export type MutationDeleteOrganizationAdminMembershipArgs = {
  input: DeleteOrganizationAdminMembershipInput;
};

export type MutationDeleteOrganizationDomainArgs = {
  id: Scalars['String'];
};

export type MutationDeletePermissionArgs = {
  input: DeletePermissionInput;
};

export type MutationDeleteRedirectUriArgs = {
  id: Scalars['String'];
};

export type MutationDeleteResourceTypeArgs = {
  input: DeleteAuthorizationResourceTypeInput;
};

export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};

export type MutationDeleteSamlX509CertificateArgs = {
  input: DeleteSamlX509CertificateInput;
};

export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};

export type MutationDeleteUserlandApplicationArgs = {
  input: DeleteUserlandApplicationInput;
};

export type MutationDeleteUserlandUserArgs = {
  input: DeleteUserlandUserInput;
};

export type MutationDeleteWaitlistEntryArgs = {
  input: DeleteWaitlistEntryInput;
};

export type MutationDeleteWebhookEndpointArgs = {
  id: Scalars['String'];
};

export type MutationDeprovisionPlatformArgs = {
  input: DeprovisionPlatformInput;
};

export type MutationDisconnectSlackArgs = {
  environmentId: Scalars['ID'];
};

export type MutationEntitlementsUserClickedUpgradeButtonArgs = {
  input: EntitlementUserClickedUpgradeButtonInput;
};

export type MutationExpireKeyArgs = {
  input: ExpireKeyInput;
};

export type MutationExpirePortalSetupLinkArgs = {
  input: ExpirePortalSetupLinkInput;
};

export type MutationExpirePortalSetupLinksArgs = {
  input: ExpirePortalSetupLinksInput;
};

export type MutationExpireUserlandApplicationKeyArgs = {
  input: ExpireUserlandApplicationKeyInput;
};

export type MutationFinalizePaymentMethodArgs = {
  input: FinalizePaymentMethodInput;
};

export type MutationGenerateAuditTrailEventsCsvArgs = {
  action?: InputMaybe<Array<Scalars['String']>>;
  action_type?: InputMaybe<Array<Scalars['String']>>;
  actor_id?: InputMaybe<Array<Scalars['String']>>;
  actor_name?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  group?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  occurred_at?: InputMaybe<Scalars['DateTime']>;
  occurred_at_gt?: InputMaybe<Scalars['DateTime']>;
  occurred_at_gte?: InputMaybe<Scalars['DateTime']>;
  occurred_at_lt?: InputMaybe<Scalars['DateTime']>;
  occurred_at_lte?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  target_id?: InputMaybe<Array<Scalars['String']>>;
  target_name?: InputMaybe<Array<Scalars['String']>>;
};

export type MutationGeneratePortalLinkArgs = {
  input: GeneratePortalLinkInput;
};

export type MutationGeneratePortalSetupLinkArgs = {
  input: GeneratePortalSetupLinkInput;
};

export type MutationGenerateSlackInstallUrlArgs = {
  environmentId: Scalars['ID'];
};

export type MutationGenerateStripeConnectAuthorizeUrlArgs = {
  environmentId: Scalars['String'];
  stripeEntitlementsEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeSeatSyncEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type MutationGetAdminPortalCustomBrandingAssetUploadUrlArgs = {
  input: GetAdminPortalCustomBrandingAssetUploadUrlInput;
};

export type MutationImpersonateUserlandUserArgs = {
  input: ImpersonateUserlandUserInput;
};

export type MutationImportMigrationApplicationsArgs = {
  input: ImportMigrationApplicationsInput;
};

export type MutationImportMigrationConnectionsArgs = {
  input: ImportMigrationConnectionsInput;
};

export type MutationInviteUserToTeamArgs = {
  input: InviteUserToTeamInput;
};

export type MutationManuallyVerifyOrganizationDomainArgs = {
  id: Scalars['String'];
};

export type MutationOnboarding_CompleteStepArgs = {
  input: OnboardingCompleteStepInput;
};

export type MutationOnboarding_EnterTeamDetailsArgs = {
  input: OnboardingEnterTeamDetailsInput;
};

export type MutationPreviewJwtTemplateArgs = {
  input: PreviewJwtTemplateInput;
};

export type MutationReactivateUserlandUserOrganizationMembershipArgs = {
  input: ReactivateUserlandUserOrganizationMembershipInput;
};

export type MutationRefreshCustomDomainArgs = {
  id: Scalars['String'];
};

export type MutationRegisterCustomDomainArgs = {
  input: RegisterCustomDomainInput;
};

export type MutationRemoveCustomDomainArgs = {
  input: RemoveCustomDomainInput;
};

export type MutationRemoveEmailSuppressionArgs = {
  input: RemoveEmailSuppressionInput;
};

export type MutationRemoveRadarListEntryArgs = {
  input: RemoveRadarListEntryInput;
};

export type MutationRemoveUserFromTeamArgs = {
  usersOrganizationsId: Scalars['String'];
};

export type MutationRemoveUserlandUserFromOrganizationArgs = {
  input: RemoveUserlandUserFromOrganizationInput;
};

export type MutationRequestCustomDataIntegrationArgs = {
  input: RequestCustomDataIntegrationInput;
};

export type MutationRequestDataIntegrationArgs = {
  input: RequestDataIntegrationInput;
};

export type MutationRequestDataProviderArgs = {
  input: RequestDataProviderInput;
};

export type MutationResendDashboardInviteArgs = {
  input: ResendDashboardInviteInput;
};

export type MutationResendUserlandUserInviteArgs = {
  input: ResendUserlandUserInviteInput;
};

export type MutationResendWebhookEventArgs = {
  input: ResendWebhookEventInput;
};

export type MutationResetOauthCredentialsArgs = {
  input: ResetOauthCredentialsInput;
};

export type MutationResetOrganizationIdpAttributesConfigArgs = {
  input: ResetOrganizationIdpAttributesConfigInput;
};

export type MutationResetOrganizationRoleConfigArgs = {
  input: ResetOrganizationRoleConfigInput;
};

export type MutationResetUserMfaSettingsArgs = {
  input: ResetUserMfaSettingsInput;
};

export type MutationResetUserlandUserAuthenticationFactorsArgs = {
  input: ResetUserlandUserAuthenticationFactorsInput;
};

export type MutationResetUserlandUserSecondFactorsArgs = {
  input: ResetUserlandUserAuthenticationFactorsInput;
};

export type MutationRestartOrganizationDomainVerificationArgs = {
  id: Scalars['String'];
};

export type MutationRevokeUserlandSessionArgs = {
  input: RevokeUserlandSessionInput;
};

export type MutationRevokeUserlandUserInviteArgs = {
  input: RevokeUserlandUserInviteInput;
};

export type MutationSendSetupLinkEmailsArgs = {
  input: SendSetupLinkEmailsInput;
};

export type MutationSendTestEmailArgs = {
  input: SendTestEmailInput;
};

export type MutationSetApplicationPermissionsArgs = {
  input: SetApplicationPermissionsInput;
};

export type MutationSetAuthkitOauthResourcesArgs = {
  input: SetAuthkitOauthResourcesInput;
};

export type MutationSetAutoMappedCustomAttributesArgs = {
  input: SetAutoMappedCustomAttributesInput;
};

export type MutationSetDefaultDynamicRegistrationOAuthScopesArgs = {
  environmentId: Scalars['ID'];
  permissionIds: Array<Scalars['ID']>;
};

export type MutationSetDirectoryCustomAttributeMappingsArgs = {
  input: SetDirectoryCustomAttributeMappingsInput;
};

export type MutationSetDomainsForOrganizationArgs = {
  input: SetDomainsForOrganizationInput;
};

export type MutationSetEmailNotificationPreferencesArgs = {
  input: SetEmailNotificationPreferencesInput;
};

export type MutationSetLogoutUrisArgs = {
  input: SetLogoutUrisInput;
};

export type MutationSetPermissionsEnabledForApiKeysArgs = {
  environmentId: Scalars['ID'];
  permissionIds: Array<Scalars['ID']>;
};

export type MutationSetRedirectUrisArgs = {
  input: SetRedirectUrisInput;
};

export type MutationSetSsoCustomAttributeMappingsArgs = {
  input: SetSsoCustomAttributeMappingsInput;
};

export type MutationSetTeamDefaultRoleArgs = {
  input: SetTeamDefaultRoleInput;
};

export type MutationSetUserlandApplicationLogoutUrisArgs = {
  input: SetUserlandApplicationLogoutUrisInput;
};

export type MutationSetUserlandApplicationRedirectUrisArgs = {
  input: SetUserlandApplicationRedirectUrisInput;
};

export type MutationSetUserlandApplicationWebOriginsArgs = {
  input: SetUserlandApplicationWebOriginsInput;
};

export type MutationSetWebOriginsArgs = {
  dryRun?: Scalars['Boolean'];
  environmentId: Scalars['String'];
  origins: Array<Scalars['String']>;
};

export type MutationStartSyncingInternalDirectoryArgs = {
  input: StartSyncingInternalDirectoryInput;
};

export type MutationTestActionEndpointArgs = {
  input: TestActionEndpointInput;
};

export type MutationTestJwtTemplateArgs = {
  input: TestJwtTemplateInput;
};

export type MutationTestWebhookEndpointArgs = {
  event: WebhookEventFixtures;
  id: Scalars['String'];
};

export type MutationUnassignRoleFromInternalDirectoryGroupArgs = {
  input: UnassignRoleFromInternalDirectoryGroupInput;
};

export type MutationUnbindManagedListFromEnvironmentArgs = {
  input: UnbindManagedListFromEnvironmentInput;
};

export type MutationUpdateAppBrandingArgs = {
  input: UpdateAppBrandingInput;
};

export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};

export type MutationUpdateAttributeMapV2Args = {
  input: UpdateAttributeMapInput;
};

export type MutationUpdateAuth0MigrationCredentialsArgs = {
  input: UpdateAuth0MigrationCredentialsInput;
};

export type MutationUpdateConnectionArgs = {
  input: UpdateConnectionInput;
};

export type MutationUpdateConnectionFromDiscoveryEndpointArgs = {
  input: UpdateConnectionFromDiscoveryEndpointInput;
};

export type MutationUpdateConnectionFromMetadataUrlArgs = {
  input: UpdateConnectionFromMetadataUrlInput;
};

export type MutationUpdateConnectionFromMetadataXmlArgs = {
  input: UpdateConnectionFromMetadataXmlInput;
};

export type MutationUpdateConnectionGroupArgs = {
  input: UpdateConnectionGroupInput;
};

export type MutationUpdateCustomEmailProviderArgs = {
  input: UpdateCustomEmailProviderInput;
};

export type MutationUpdateCustomMappedCustomAttributeArgs = {
  input: UpdateCustomMappedCustomAttributeInput;
};

export type MutationUpdateDataIntegrationArgs = {
  input: UpdateDataIntegrationInput;
};

export type MutationUpdateDataProviderIntegrationArgs = {
  input: UpdateDataIntegrationInput;
};

export type MutationUpdateDirectoryArgs = {
  input: UpdateDirectoryInput;
};

export type MutationUpdateDirectoryAttributeMapArgs = {
  directory_attribute_map_id: Scalars['String'];
  emails_attribute?: InputMaybe<Scalars['String']>;
  external_id_attribute?: InputMaybe<Scalars['String']>;
  first_name_attribute?: InputMaybe<Scalars['String']>;
  group_name_attribute?: InputMaybe<Scalars['String']>;
  job_title_attribute?: InputMaybe<Scalars['String']>;
  last_name_attribute?: InputMaybe<Scalars['String']>;
  username_attribute?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateDirectoryConfigDashboardArgs = {
  input: UpdateDirectoryConfigInput;
};

export type MutationUpdateDirectoryGroupConfigsAllowListArgs = {
  input: UpdateDirectoryGroupConfigsAllowListInput;
};

export type MutationUpdateEnvironmentLocalizationArgs = {
  input: UpdateEnvironmentLocalizationInput;
};

export type MutationUpdateEnvironmentOrganizationAdminCollectionEnabledArgs = {
  input: UpdateEnvironmentOrganizationAdminCollectionEnabledInput;
};

export type MutationUpdateEnvironmentSsoSigninConsentArgs = {
  input: UpdateEnvironmentSsoSigninConsentInput;
};

export type MutationUpdateFlagArgs = {
  input: UpdateFlagInput;
};

export type MutationUpdateFlagEnvironmentArgs = {
  input: UpdateFlagEnvironmentInput;
};

export type MutationUpdateIdpAttributesConfigArgs = {
  input: UpdateIdpAttributesConfigInput;
};

export type MutationUpdateInitiateLoginUrlArgs = {
  environmentId: Scalars['String'];
  url: Scalars['String'];
};

export type MutationUpdateMigrationApplicationStatusArgs = {
  input: UpdateMigrationApplicationStatusInput;
};

export type MutationUpdateMigrationConnectionStatusArgs = {
  input: UpdateMigrationConnectionStatusInput;
};

export type MutationUpdateMigrationProxyStatusArgs = {
  input: UpdateMigrationProxyStatusInput;
};

export type MutationUpdateMyselfArgs = {
  input: UpdateMyselfInput;
};

export type MutationUpdateNotificationArgs = {
  id: Scalars['ID'];
  state?: InputMaybe<NotificationState>;
};

export type MutationUpdateOauthCredentialsArgs = {
  input: UpdateOauthCredentialsInput;
};

export type MutationUpdateOrganizationArgs = {
  allowProfilesOutsideOrganization?: InputMaybe<Scalars['Boolean']>;
  domainMfaRequired?: InputMaybe<Scalars['Boolean']>;
  domainSsoRequired?: InputMaybe<Scalars['Boolean']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  domainsDeveloperVerified?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isAppleOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isBitbucketOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isDiscordOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isDomainJitProvisioningEnabled?: InputMaybe<Scalars['Boolean']>;
  isGitLabOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isGithubOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isGoogleOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntuitOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isLinkedInOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isMagicAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isManagedUserSsoJitProvisioningEnabled?: InputMaybe<Scalars['Boolean']>;
  isMicrosoftOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasskeyAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasswordAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isSalesforceOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isSlackOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isSsoJitProvisioningEnabled?: InputMaybe<Scalars['Boolean']>;
  isUnmanagedUserJitProvisioningEnabled?: InputMaybe<Scalars['Boolean']>;
  isVercelMarketplaceOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isVercelOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isXeroOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  nonDomainMfaRequired?: InputMaybe<Scalars['Boolean']>;
  nonDomainSsoRequired?: InputMaybe<Scalars['Boolean']>;
  recreateDomainsWithDifferentState?: InputMaybe<Scalars['Boolean']>;
  setDomainCaptureEnabledDomains?: InputMaybe<Array<Scalars['ID']>>;
};

export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
};

export type MutationUpdatePortalSettingsArgs = {
  default_redirect_link: Scalars['String'];
  portal_settings_id: Scalars['String'];
};

export type MutationUpdatePortalSettingsV2Args = {
  input: UpdatePortalSettingsInput;
};

export type MutationUpdateRadarSettingsArgs = {
  input: UpdateRadarSettingsInput;
};

export type MutationUpdateRadarSettingsModeArgs = {
  input: UpdateRadarModeInput;
};

export type MutationUpdateRedirectUriArgs = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  redirectUriId: Scalars['String'];
  uri?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateResourceTypeArgs = {
  input: UpdateAuthorizationResourceTypeInput;
};

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};

export type MutationUpdateRoleConfigArgs = {
  input: UpdateRoleConfigInput;
};

export type MutationUpdateRoleOnOrganizationMembershipArgs = {
  input: UpdateRoleOnOrganizationMembershipInput;
};

export type MutationUpdateSessionArgs = {
  session: UpdateSessionInput;
};

export type MutationUpdateStripeConfigurationArgs = {
  environmentId: Scalars['String'];
  stripeEntitlementsEnabled: Scalars['Boolean'];
  stripeSeatSyncEnabled: Scalars['Boolean'];
};

export type MutationUpdateTeamDetailsArgs = {
  input: UpdateTeamDetailsInput;
};

export type MutationUpdateTeamMfaRequirementArgs = {
  input: UpdateTeamMfaRequirementInput;
};

export type MutationUpdateUserManagementActivatedArgs = {
  input: UpdateUserManagementActivatedInput;
};

export type MutationUpdateUserlandApplicationArgs = {
  input: UpdateUserlandApplicationInput;
};

export type MutationUpdateUserlandEmailSettingsArgs = {
  input: UpdateUserlandEmailSettingsInput;
};

export type MutationUpdateUserlandExternalLoginUriArgs = {
  input: UpdateUserlandExternalLoginUriInput;
};

export type MutationUpdateUserlandImpersonationSettingsArgs = {
  input: UpdateUserlandImpersonationSettingsInput;
};

export type MutationUpdateUserlandPasswordAuthenticationConfigArgs = {
  input: UpdateUserlandPasswordAuthenticationConfigInput;
};

export type MutationUpdateUserlandSettingsArgs = {
  input: UpdateUserlandSettingsInput;
};

export type MutationUpdateUserlandUserArgs = {
  input: UpdateUserlandUserInput;
};

export type MutationUpdateWebhookEndpointArgs = {
  endpointUrl?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<WebhookEndpointState>;
  webhookEndpointId: Scalars['String'];
};

export type MutationUploadCustomFontsArgs = {
  input: UploadCustomFontsInput;
};

export type MutationUpsertActionsEndpointArgs = {
  input: UpsertActionsEndpointInput;
};

export type MutationUpsertAuth0CredentialArgs = {
  input: UpsertAuth0CredentialInput;
};

export type MutationUpsertGoogleAnalyticsConfigArgs = {
  input: UpsertGoogleAnalyticsConfigInput;
};

export type MutationUpsertGroupRoleMappingsArgs = {
  input: UpsertDirectoryGroupRoleMappingsInput;
};

export type MutationUpsertGroupRoleMappingsForConnectionArgs = {
  input: UpsertConnectionGroupRoleMappingsInput;
};

export type MutationUpsertJwtTemplateArgs = {
  input: UpsertJwtTemplateInput;
};

export type MutationUpsertSamlX509CertificateArgs = {
  input: UpsertSamlX509CertificateInput;
};

export type MutationUpsertSegmentConfigArgs = {
  input: UpsertSegmentConfigInput;
};

export type MutationValidateJwtTemplateArgs = {
  input: ValidateJwtTemplateInput;
};

export type MutationVerifyAuthenticationFactorEnrollmentArgs = {
  input: VerifyAuthenticationFactorEnrollmentInput;
};

export type MutationVerifyDomainStatusArgs = {
  input: VerifyDomainStatusInput;
};

export type MutationVerifyRedirectUriArgs = {
  input: VerifyRedirectUriInput;
};

export type MyselfUpdated = {
  me: User;
};

export type NewlyCreatedKey = {
  key: Key;
  /** The value of the key. For API keys in production environments, this will be the only time the key's value is visible. */
  value: Scalars['String'];
};

export type NoAuditLogEventsFound = {
  message: Scalars['String'];
};

export type NoEndpointConfigured = {
  type: ActionsEndpointType;
};

export type Notification = {
  connectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  directoryId?: Maybe<Scalars['String']>;
  environmentId: Scalars['String'];
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  organizationId?: Maybe<Scalars['String']>;
  state?: Maybe<NotificationState>;
  title: Scalars['String'];
  type?: Maybe<NotificationType>;
  updatedAt: Scalars['DateTime'];
};

export type NotificationList = {
  data: Array<Notification>;
  listMetadata: ListMetadata;
};

export enum NotificationState {
  Read = 'Read',
  Unread = 'Unread',
}

export enum NotificationType {
  AuditLogStreamInvalidCredentials = 'AuditLogStreamInvalidCredentials',
  BillingFailed = 'BillingFailed',
  ConnectionAttributesMisconfigured = 'ConnectionAttributesMisconfigured',
  CustomDomainVerificationFailure = 'CustomDomainVerificationFailure',
  CustomEmailProviderSendEmailFailed = 'CustomEmailProviderSendEmailFailed',
  DirectoryCredentialsInvalid = 'DirectoryCredentialsInvalid',
  ExposedKey = 'ExposedKey',
  InvalidRedirectUri = 'InvalidRedirectUri',
  ItAdminEmailBounced = 'ItAdminEmailBounced',
  RelyingPartyTrustExpiration = 'RelyingPartyTrustExpiration',
  TeamDomainReserved = 'TeamDomainReserved',
  WebhookEndpointDisabled = 'WebhookEndpointDisabled',
  WebhookEndpointFailureWarning = 'WebhookEndpointFailureWarning',
  X509CertificateExpired = 'X509CertificateExpired',
  X509CertificateExpiring = 'X509CertificateExpiring',
}

export enum NullableOrganizationRoleConfigProperties {
  DsyncRoleAssignmentEnabled = 'dsyncRoleAssignmentEnabled',
  SsoRoleAssignmentEnabled = 'ssoRoleAssignmentEnabled',
}

export type OAuthCredential = {
  appleKeyId?: Maybe<Scalars['String']>;
  applePrivateKey?: Maybe<Scalars['String']>;
  appleTeamId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  customScopes: Array<Scalars['String']>;
  externalKey: Scalars['String'];
  id: Scalars['ID'];
  isUserlandEnabled: Scalars['Boolean'];
  isUsingCustomDomain: Scalars['Boolean'];
  redirectUri?: Maybe<Scalars['String']>;
  returnProviderTokens: Scalars['Boolean'];
  state: OAuthCredentialState;
  type: ConnectionType;
};

export type OAuthCredentialList = {
  data: Array<OAuthCredential>;
  listMetadata: ListMetadata;
};

/** Enum represents the state of the OAuth Credential. */
export enum OAuthCredentialState {
  Invalid = 'Invalid',
  Valid = 'Valid',
}

export type OAuthSession = {
  connectionId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errors: Array<ConnectionSessionError>;
  id: Scalars['ID'];
  profile?: Maybe<Profile>;
  state: OAuthSessionState;
  stateParameter: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Enum represents the state of the OAuth Session. */
export enum OAuthSessionState {
  Authorized = 'Authorized',
  Failed = 'Failed',
  Started = 'Started',
  Successful = 'Successful',
}

export type OAuthSessionsList = {
  data: Array<OAuthSession>;
  listMetadata: ListMetadata;
};

export type OauthConnectionMissingCredentials = {
  connectionId?: Maybe<Scalars['String']>;
};

/** An error pertaining to OAuth credentials. */
export type OauthCredentialsError = {
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type OauthCredentialsNotFound = {
  environmentId: Scalars['String'];
};

export type OauthCredentialsUpdated = {
  credentials: OAuthCredential;
};

export type OidcDiscoveryError = {
  helpMessage: Scalars['String'];
  reason: Scalars['String'];
  severity: OidcDiscoveryErrorSeverity;
  tag: Scalars['String'];
};

/** Represents the severity of the error. Warnings may be ignored. */
export enum OidcDiscoveryErrorSeverity {
  Error = 'Error',
  Warning = 'Warning',
}

export type OidcDiscoveryValidationFailed = {
  errors: Array<OidcDiscoveryError>;
};

export type OidcFailedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type OidcJwtSigningKeyPair = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  notAfter: Scalars['DateTime'];
  notBefore: Scalars['DateTime'];
  publicKeyCert: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OidcSession = {
  connectionId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errors: Array<ConnectionSessionError>;
  id: Scalars['ID'];
  initiator?: Maybe<OidcSessionInitiator>;
  profile?: Maybe<Profile>;
  profileSnapshot?: Maybe<ProfileSnapshot>;
  state: OidcSessionState;
  stateParameter?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/** Enum represents the initiator of the OIDC Session. */
export enum OidcSessionInitiator {
  AdminPortalTest = 'AdminPortalTest',
  ServiceProvider = 'ServiceProvider',
}

/** Enum represents the state of the OIDC Session. */
export enum OidcSessionState {
  Authorized = 'Authorized',
  Failed = 'Failed',
  Started = 'Started',
  Successful = 'Successful',
  Terminated = 'Terminated',
  Timedout = 'Timedout',
}

export type OidcSessionsList = {
  data: Array<OidcSession>;
  listMetadata: ListMetadata;
};

export type OnboardingCompanyDetailsInput = {
  name: Scalars['String'];
};

export type OnboardingCompleteStepInput = {
  /** The next step in the onboarding process, if one exists. */
  nextStep?: InputMaybe<Scalars['String']>;
};

export type OnboardingCompleteStepPayload = {
  team?: Maybe<Team>;
};

export type OnboardingEnterTeamDetailsInput = {
  company: OnboardingCompanyDetailsInput;
  /** Whether the CRM integration should be disabled. */
  noCrm?: InputMaybe<Scalars['Boolean']>;
  user: OnboardingUserDetailsInput;
};

export enum OnboardingGuide {
  AuditLogs = 'AuditLogs',
  Dsync = 'Dsync',
  Sso = 'SSO',
  UserManagement = 'UserManagement',
  UserManagementProd = 'UserManagementProd',
}

export type OnboardingGuideCompleted = {
  success: Scalars['Boolean'];
};

export type OnboardingGuideCompletions = {
  auditLogs: OnboardingGuideStatus;
  dsync: OnboardingGuideStatus;
  sso: OnboardingGuideStatus;
  userManagement: OnboardingGuideStatus;
  userManagementProd: OnboardingGuideStatus;
};

export type OnboardingGuideStatus = {
  chartTotal: Scalars['Float'];
  isDone: Scalars['Boolean'];
  totalsByMonth: Array<Scalars['Float']>;
};

export type OnboardingUserDetailsInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type OneShotEnvironmentAlreadyClaimed = {
  message: Scalars['String'];
};

export type OneShotEnvironmentClaimed = {
  environment: Environment;
};

export type OneShotEnvironmentNameAlreadyInUse = {
  message: Scalars['String'];
};

export type OneShotEnvironmentNotFound = {
  message: Scalars['String'];
};

export type OrbBillingData = {
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  planName: Scalars['String'];
  upcomingInvoice?: Maybe<UpcomingInvoice>;
};

export type OrderedDirectoryGroupConfigsList = {
  data: Array<DirectoryGroupConfig>;
  listMetadata: ListMetadata;
};

export type OrderedDirectoryGroupConfigsResult =
  | InvalidDirectoryGroupConfigCursor
  | OrderedDirectoryGroupConfigsList;

export type OrgActiveUsersSummary = {
  new: MetricSummary;
  organization: AnalyticsOrg;
  returning: MetricSummary;
  total: MetricSummary;
};

export type OrgActiveUsersSummaryResult = {
  cursor: ListMetadata;
  list: Array<OrgActiveUsersSummary>;
  updatedAt: Scalars['DateTime'];
};

/** Discriminant for byOrg queries — either a top-N leaderboard or a specific set of org IDs. */
export enum OrgSelectionKind {
  OrgIds = 'OrgIds',
  TopN = 'TopN',
}

export type Organization = {
  adminEmails: Array<Scalars['String']>;
  allowProfilesOutsideOrganization: Scalars['Boolean'];
  apiKeys: ApiKeyList;
  auditLogStream?: Maybe<AuditLogStream>;
  auditLogTrail?: Maybe<AuditLogTrail>;
  connections: ConnectionList;
  createdAt: Scalars['DateTime'];
  directories: DirectoryOrUntypedDirectoryList;
  domainMfaRequired: Scalars['Boolean'];
  domainSsoRequired: Scalars['Boolean'];
  domains: Array<OrganizationDomain>;
  enforcesVerifiedDomains: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAppleOauthEnabled: Scalars['Boolean'];
  isBitbucketOauthEnabled: Scalars['Boolean'];
  isDiscordOauthEnabled: Scalars['Boolean'];
  isDomainJitProvisioningEnabled: Scalars['Boolean'];
  isGitLabOauthEnabled: Scalars['Boolean'];
  isGithubOauthEnabled: Scalars['Boolean'];
  isGoogleOauthEnabled: Scalars['Boolean'];
  isIntuitOauthEnabled: Scalars['Boolean'];
  isLinkedInOauthEnabled: Scalars['Boolean'];
  isMagicAuthEnabled: Scalars['Boolean'];
  /** @deprecated Use isSsoJitProvisioningEnabled instead */
  isManagedUserSsoJitProvisioningEnabled: Scalars['Boolean'];
  isMicrosoftOauthEnabled: Scalars['Boolean'];
  isPasskeyAuthEnabled: Scalars['Boolean'];
  isPasswordAuthEnabled: Scalars['Boolean'];
  isSalesforceOauthEnabled: Scalars['Boolean'];
  isSlackOauthEnabled: Scalars['Boolean'];
  isSsoJitProvisioningEnabled: Scalars['Boolean'];
  /** @deprecated Use isDomainJitProvisioningEnabled instead */
  isUnmanagedUserJitProvisioningEnabled: Scalars['Boolean'];
  isVercelMarketplaceOauthEnabled: Scalars['Boolean'];
  isVercelOauthEnabled: Scalars['Boolean'];
  isXeroOauthEnabled: Scalars['Boolean'];
  latestConnection?: Maybe<OrganizationConnection>;
  latestDirectory?: Maybe<OrganizationDirectory>;
  metadata: Array<OrganizationMetadata>;
  name: Scalars['String'];
  nonDomainMfaRequired: Scalars['Boolean'];
  nonDomainSsoRequired: Scalars['Boolean'];
  seeded: Scalars['Boolean'];
  setupLinks?: Maybe<Array<PortalSetupLink>>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeEntitlements?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
  userlandUserInvites: UserlandUserInviteList;
  userlandUsers: UserlandUserList;
  usersCount?: Maybe<Scalars['Int']>;
  vaultKeySettingsByOrganization?: Maybe<VaultKeySettings>;
};

export type OrganizationApiKeysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type OrganizationConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ConnectionState>;
  states?: InputMaybe<Array<ConnectionState>>;
  type?: InputMaybe<ConnectionType>;
};

export type OrganizationDirectoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type OrganizationUserlandUserInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type OrganizationUserlandUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  authenticationMethods?: InputMaybe<Array<UserlandUserAuthenticationMethod>>;
  before?: InputMaybe<Scalars['String']>;
  dataIntegrationId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationMembershipStatus?: InputMaybe<Array<Scalars['String']>>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sessionStatus?: InputMaybe<UserlandUserSessionStatus>;
  sortField?: InputMaybe<UserlandUserSortField>;
};

export type OrganizationAdmin = {
  email: Scalars['String'];
  id: Scalars['ID'];
  isBouncing: Scalars['Boolean'];
  lastBounceAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationAdminAdded = {
  organizationAdmin: OrganizationAdmin;
};

export type OrganizationAdminMembershipDeleted = {
  organizationAdminId: Scalars['String'];
};

export type OrganizationAdminNotFound = {
  organizationAdminId: Scalars['String'];
  organizationId: Scalars['String'];
};

export type OrganizationAdminsResult = {
  organizationAdmins: Array<OrganizationAdmin>;
};

export type OrganizationAlreadyHasAdmin = {
  organizationAdmin: OrganizationAdmin;
};

export type OrganizationConnection = {
  certificateExpirationDate?: Maybe<Scalars['DateTime']>;
  certificateState?: Maybe<ConnectionCertificateState>;
  id: Scalars['ID'];
  state: ConnectionState;
  type: ConnectionType;
};

/** Enum represents the state of the connection within an organization with setup links. */
export enum OrganizationConnectionState {
  Active = 'Active',
  AwaitingSetup = 'AwaitingSetup',
  Deleting = 'Deleting',
  Expired = 'Expired',
  Expiring = 'Expiring',
  Inactive = 'Inactive',
  SetupInProgress = 'SetupInProgress',
  Validating = 'Validating',
}

export type OrganizationCreated = {
  organization: Organization;
};

export type OrganizationDirectory = {
  id: Scalars['ID'];
  state: DirectoryState;
  type: DirectoryType;
};

/** Enum represents the state of the Directory within an organization with setup links. */
export enum OrganizationDirectoryState {
  AwaitingSetup = 'AwaitingSetup',
  Deleting = 'Deleting',
  InvalidCredentials = 'InvalidCredentials',
  Linked = 'Linked',
  SetupInProgress = 'SetupInProgress',
  Unlinked = 'Unlinked',
  Validating = 'Validating',
}

export type OrganizationDomain = {
  domain: Scalars['String'];
  domainCaptureEnabled: Scalars['Boolean'];
  domainCaptureEnabledBy?: Maybe<Organization>;
  id: Scalars['ID'];
  state: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
  verificationContent?: Maybe<Scalars['String']>;
  verificationStrategy?: Maybe<OrganizationDomainVerificationStrategy>;
};

export type OrganizationDomainAlreadyInUse = {
  domain: Scalars['String'];
  organization: Organization;
};

/** Enum represents the verification strategy of an Organization Domain. */
export enum OrganizationDomainVerificationStrategy {
  Dns = 'Dns',
  Manual = 'Manual',
}

export type OrganizationIdpAttributesConfig = {
  dsyncCustomAttributeMappingEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ssoCustomAttributeMappingEnabled?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type OrganizationIdpAttributesConfigCreated = {
  organizationIdpAttributesConfig: OrganizationIdpAttributesConfig;
};

export type OrganizationIdpAttributesConfigNotFound = {
  organizationId: Scalars['String'];
};

export type OrganizationIdpAttributesConfigReset = {
  organizationIdpAttributesConfig: OrganizationIdpAttributesConfig;
};

export type OrganizationIdpAttributesConfigResult =
  | OrganizationIdpAttributesConfig
  | OrganizationIdpAttributesConfigNotFound;

export type OrganizationList = {
  data: Array<Organization>;
  listMetadata: ListMetadata;
};

export type OrganizationMetadata = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type OrganizationNotFound = {
  organizationId: Scalars['String'];
};

export type OrganizationRoleConfig = {
  defaultRole?: Maybe<Scalars['String']>;
  dsyncRoleAssignmentEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  rolePriorityOrder?: Maybe<Array<Scalars['String']>>;
  ssoRoleAssignmentEnabled?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type OrganizationRoleConfigCreated = {
  organizationRoleConfig: OrganizationRoleConfig;
};

export type OrganizationRoleConfigReset = {
  organizationRoleConfig: OrganizationRoleConfig;
};

export type OrganizationRoleConfigResultV2 =
  | OrganizationRoleConfig
  | RoleConfigNotFoundForOrganization;

/** Fields available for sorting organizations. */
export enum OrganizationSortField {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
}

/** Enum represents the pagination order. */
export enum PaginationOrder {
  Asc = 'Asc',
  Desc = 'Desc',
  Normal = 'Normal',
}

export type PasswordAuthDisabled = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

/** The types of characters in a password. */
export enum PasswordCharacterType {
  Lowercase = 'Lowercase',
  Number = 'Number',
  Symbol = 'Symbol',
  Uppercase = 'Uppercase',
}

export type PasswordlessSession = {
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  profile?: Maybe<Profile>;
  state: PasswordlessSessionState;
  updatedAt: Scalars['DateTime'];
};

export type PasswordlessSessionList = {
  data: Array<PasswordlessSession>;
  listMetadata: ListMetadata;
};

/** Enum represents the state of the Passwordless Session. */
export enum PasswordlessSessionState {
  Delivered = 'Delivered',
  Expired = 'Expired',
  New = 'New',
  Pending = 'Pending',
  Verified = 'Verified',
}

export type PaymentMethodAdded = {
  team: Team;
};

export type PeopleHrDirectory = {
  apiKey?: Maybe<Scalars['String']>;
};

export type Permission = {
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  environmentId: Scalars['String'];
  id: Scalars['ID'];
  isDefaultDynamicRegistrationOauthScope: Scalars['Boolean'];
  isEnabledForApiKeys: Scalars['Boolean'];
  name: Scalars['String'];
  resourceType?: Maybe<AuthorizationResourceType>;
  resourceTypeId?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  system: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type PermissionAlreadyExists = {
  slug: Scalars['String'];
};

export type PermissionCreated = {
  permission: Permission;
};

export type PermissionDeleted = {
  permissionId: Scalars['String'];
};

export type PermissionGroupByResourceType = {
  permissions: Array<Permission>;
  resourceTypeId: Scalars['ID'];
};

export type PermissionList = {
  permissions: Array<Permission>;
};

export type PermissionNotFound = {
  permissionId: Scalars['String'];
};

export type PermissionSlugInvalid = {
  slug: Scalars['String'];
};

export type PermissionSlugNotFound = {
  slug: Scalars['String'];
};

export type PermissionUpdated = {
  permission: Permission;
};

export type PermissionsByResourceTypeInput = {
  environmentId: Scalars['ID'];
  resourceTypeIds: Array<Scalars['ID']>;
};

export type PermissionsByResourceTypeResult = {
  groups: Array<PermissionGroupByResourceType>;
};

export type PermissionsEnabledForApiKeysSet = {
  environment: Environment;
};

export type PersonioDirectory = {
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
};

export type PlaintextApplicationCredential = ApplicationCredential & {
  applicationId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  plaintextSecret: Scalars['String'];
  secretHint: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PlatformDeprovisioned = {
  platform: Scalars['String'];
  teamId: Scalars['ID'];
};

export type PortalLinkGenerated = {
  portalLink: Scalars['String'];
};

export type PortalSettings = {
  defaultConnectionSuccessLink?: Maybe<Scalars['String']>;
  defaultDirectorySuccessLink?: Maybe<Scalars['String']>;
  defaultDomainVerificationSuccessLink?: Maybe<Scalars['String']>;
  defaultLogStreamsSuccessLink?: Maybe<Scalars['String']>;
  defaultRedirectLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type PortalSettingsUpdated = {
  portalSettings: PortalSettings;
};

export type PortalSetupLink = {
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  intents?: Maybe<Array<PortalSetupLinkIntent>>;
  state: PortalSetupLinkState;
  token: Scalars['String'];
  url: Scalars['String'];
};

export type PortalSetupLinkEvent = {
  action: PortalSetupLinkEventAction;
  id: Scalars['ID'];
  portalSetupLinkId: Scalars['String'];
};

export type PortalSetupLinkEventAction = {
  organizationAdminEmail?: Maybe<Scalars['String']>;
  type: PortalSetupLinkEventActionType;
};

/** Enum represents the type of action taken on an Admin Portal setup link. */
export enum PortalSetupLinkEventActionType {
  Created = 'Created',
  Deleted = 'Deleted',
  EmailSent = 'EmailSent',
}

export type PortalSetupLinkExpired = {
  intent: PortalSetupLinkIntent;
  organization: Organization;
};

export type PortalSetupLinkGenerated = {
  portalSetupLink: PortalSetupLink;
};

/** Enum represents the intent for a given of an Admin Portal setup link. */
export enum PortalSetupLinkIntent {
  BringYourOwnKey = 'BringYourOwnKey',
  CertificateRenewal = 'CertificateRenewal',
  DomainVerification = 'DomainVerification',
  Dsync = 'Dsync',
  LogStreams = 'LogStreams',
  Sso = 'Sso',
}

export type PortalSetupLinkList = {
  data: Array<PortalSetupLink>;
};

/** Enum represents the state of an Admin Portal setup link. */
export enum PortalSetupLinkState {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type PortalSetupLinksExpired = {
  organization: Organization;
};

export type PostmarkCustomEmailProvider = CustomEmailProvider & {
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type PreviewJwtTemplateInput = {
  environmentId: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  template: Scalars['String'];
  userlandUserId: Scalars['String'];
};

export type PreviewJwtTemplateResult =
  | JwtTemplateRenderingError
  | JwtTemplateRenderingResult;

export type Profile = {
  connection: Connection;
  /** @deprecated Use the `type` field on `connection` instead. */
  connectionType: ConnectionType;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  idpId?: Maybe<Scalars['String']>;
  /** The JSON representation of the Profile, as returned by the REST API. */
  json: Scalars['JSON'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  rawAttributes?: Maybe<Scalars['JSON']>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Role>>;
  state: ProfileState;
  updatedAt: Scalars['DateTime'];
};

export type ProfileByEmailInput = {
  connectionId: Scalars['String'];
  email: Scalars['String'];
};

export type ProfileByIdpIdInput = {
  connectionId: Scalars['String'];
  idpId: Scalars['String'];
};

export type ProfileList = {
  data: Array<Profile>;
  listMetadata: ListMetadata;
};

export type ProfileNotAllowedOutsideOrganizationError = {
  code: ConnectionSessionErrorCode;
  organizationDomains: Array<Scalars['String']>;
  profileDomain: Scalars['String'];
  reason: Scalars['String'];
};

export type ProfileSnapshot = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<Scalars['String']>>>;
  idpId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<ProfileSnapshotRole>;
  roles?: Maybe<Array<ProfileSnapshotRole>>;
};

export type ProfileSnapshotRole = {
  slug: Scalars['String'];
};

/** Enum represents the state of the profile. */
export enum ProfileState {
  Invalid = 'Invalid',
  Valid = 'Valid',
}

export type ProjectNotFound = {
  projectId: Scalars['String'];
};

export type ProjectV2 = {
  appBranding?: Maybe<AppBranding>;
  environments: Array<Environment>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProjectV2EnvironmentsArgs = {
  type?: InputMaybe<EnvironmentType>;
};

export type ProviderApplicationWithStatus = {
  allowedLogoutUrls: Array<Scalars['String']>;
  allowedOrigins: Array<Scalars['String']>;
  callbacks: Array<Scalars['String']>;
  clientId: Scalars['String'];
  externalId: Scalars['String'];
  imported: Scalars['Boolean'];
  migrationApplicationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Deprecated: application status is ignored for routing. Use CustomerMigration proxy status and CustomerMigrationConnection status. */
  status?: Maybe<CustomerMigrationApplicationStatus>;
  type: CustomerMigrationApplicationType;
};

export enum ProviderConnectionStrategy {
  Auth0 = 'AUTH0',
  Oidc = 'OIDC',
  Saml = 'SAML',
}

export type ProviderConnectionWithStatus = {
  connectionId?: Maybe<Scalars['ID']>;
  domains: Array<Scalars['String']>;
  externalId: Scalars['String'];
  imported: Scalars['Boolean'];
  name: Scalars['String'];
  status?: Maybe<CustomerMigrationConnectionStatus>;
  strategy: ProviderConnectionStrategy;
  successCount?: Maybe<Scalars['Int']>;
};

export type Query = {
  actionExecution: ActionExecution;
  actionExecutions: ActionExecutionsList;
  actionsEndpoint?: Maybe<ActionsEndpoint>;
  actionsEndpoints: Array<ActionsEndpoint>;
  actionsSecret: Scalars['String'];
  activePortalSetupLinks: PortalSetupLinkList;
  allRolesForOrganization: RoleList;
  application: Application;
  auditLogEvent: AuditLogEvent;
  auditLogEvents: AuditLogEventList;
  auditLogExport: AuditLogExport;
  auditLogSchemaPreview: AuditLogSchemaPreview;
  auditLogStream: AuditLogStream;
  auditLogTargets: AuditLogTargetList;
  auditLogValidator: AuditLogValidator;
  auditLogValidators: AuditLogValidatorList;
  auditTrailEvent: AuditTrailEvent;
  auditTrailEvents: AuditTrailEventList;
  authenticationFactors: AuthenticationFactorList;
  autoMappedCustomAttributes: Array<AutoMappedCustomAttribute>;
  checkEmailSuppression: EmailSuppressionCheckResult;
  connection: ConnectionOrUntypedConnection;
  connectionSession: ConnectionSession;
  contextSchema: ContextSchemaResult;
  currentEnvironment: Environment;
  currentTeam: Team;
  customDomain?: Maybe<CustomDomain>;
  customEmailDomain?: Maybe<CustomEmailDomainQueryResult>;
  customEmailProviders: Array<CustomEmailProvider>;
  customMappedCustomAttributes: CustomMappedCustomAttributeList;
  customerMigration?: Maybe<CustomerMigration>;
  customerMigrationLog?: Maybe<CustomerMigrationLog>;
  customerMigrationLogs: CustomerMigrationLogList;
  dataIntegration: DataIntegration;
  dataIntegrationForProvider: DataIntegration;
  dataProviderIntegration: DataProviderIntegration;
  dataProviderIntegrationForSlug: DataProviderIntegrationResult;
  dataProviders: Array<DataProviderConfig>;
  datadogWebhookEndpoint?: Maybe<DatadogWebhookEndpoint>;
  defaultRedirectUri?: Maybe<RedirectUri>;
  defaultUserlandApplication: UserlandApplication;
  descendantTypesForResourceType: AuthorizationResourceTypeList;
  directory: DirectoryOrUntypedDirectory;
  directoryAttributeMap: DirectoryAttributeMap;
  directoryCustomAttributeMappings: DirectoryCustomAttributeMappingList;
  directoryCustomAttributes: DirectoryCustomAttributeList;
  directoryGroupConfigsSummaryDashboard: DirectoryGroupConfigSummary;
  directorySyncRun: DirectorySyncRun;
  directoryUser: DirectoryUser;
  emailNotificationPreferences: EmailNotificationPreferences;
  environment: Environment;
  eventActions: Array<EventAction>;
  flag: Flag;
  flagBySlug: Flag;
  flagsForProject: FlagList;
  groupRoleMapping: GroupRoleMapping;
  groupsForConnection: ConnectionGroupsList;
  groupsForDirectory: DirectoryGroupsList;
  idpAttributesConfigForEnvironment: EnvironmentIdpAttributesConfig;
  idpAttributesConfigForOrganization: OrganizationIdpAttributesConfigResult;
  internalDirectory: InternalDirectory;
  isMfaEligible: Scalars['Boolean'];
  isRoleAssignmentEnabledForAnyOrganization: Scalars['Boolean'];
  jwtTemplate?: Maybe<JwtTemplate>;
  keys: KeyList;
  logoutUris: LogoutUriList;
  managedListBinding?: Maybe<ManagedListBinding>;
  me: User;
  membershipCountForRole: MembershipCountForRoleResult;
  migrationApplications: GetMigrationApplicationsResult;
  migrationConnections: GetMigrationConnectionsResult;
  oauthCredentialsByType: OAuthCredentialList;
  oidcJwtSigningKeyPair: OidcJwtSigningKeyPair;
  onboardingGuides: OnboardingGuideCompletions;
  organization: Organization;
  organizationAdmins: Array<OrganizationAdmin>;
  organizationCount: Scalars['Int'];
  organizations: OrganizationList;
  passwordlessSessions: PasswordlessSessionList;
  permissionsByResourceTypeIds: PermissionsByResourceTypeResult;
  permissionsForEnvironment: PermissionList;
  portalSetupLinkEmailSentEvents: Array<PortalSetupLinkEvent>;
  profile: Profile;
  profileByEmail: Profile;
  profileByIdpId: Profile;
  radarListDetails: RadarListDetails;
  radarListEntries: RadarListEntryList;
  redirectUris: RedirectUriList;
  request: Request;
  requests: RequestList;
  resourceInstanceCountForType: ResourceInstanceCountForTypeResult;
  resourceRoleAssignmentsForOrganizationMembership: AuthorizationResourceRoleAssignmentList;
  resourceTypesForEnvironment: AuthorizationResourceTypeList;
  roleConfigForEnvironmentV2: EnvironmentRoleConfig;
  roleConfigForOrganizationV2: OrganizationRoleConfigResultV2;
  roleCountForPermission: RoleCountForPermissionResult;
  roleMappingCountsForRoles: GroupRoleMappingCountForRoleList;
  rolesForEnvironment: RoleList;
  rolesForOrganization: RoleList;
  session: Session;
  slackConfigStatus: SlackConfigStatus;
  tags: TagList;
  teamPlatforms: Array<TeamPlatform>;
  userAuthenticationFactors: UserAuthenticationFactorList;
  userlandApplication: UserlandApplication;
  userlandApplications: UserlandApplicationList;
  userlandUser: UserlandUser;
  userlandUserInvites: UserlandUserInviteList;
  userlandUserOrganizationMembership: UserlandUserOrganizationMembership;
  userlandUserOrganizationMemberships: UserlandUserOrganizationMembershipList;
  userlandUserOrganizationMembershipsByUserIds: UserlandUserOrganizationMembershipList;
  userlandUsers: UserlandUserList;
  usersCount: Scalars['Int'];
  vaultKeySettingsById: VaultKeySettings;
  waitlistEntries: WaitlistEntryList;
  webhook: Webhook;
  webhookEndpoint: WebhookEndpoint;
  webhookEndpoints: WebhookEndpointList;
  webhookEvents: Array<WebhookEvent>;
};

export type QueryActionExecutionArgs = {
  id: Scalars['String'];
};

export type QueryActionExecutionsArgs = {
  actionsEndpointIds?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryActionsEndpointArgs = {
  environmentId: Scalars['String'];
  type: ActionsEndpointType;
};

export type QueryActionsEndpointsArgs = {
  environmentId: Scalars['String'];
};

export type QueryActionsSecretArgs = {
  environmentId: Scalars['String'];
};

export type QueryActivePortalSetupLinksArgs = {
  organizationId: Scalars['String'];
};

export type QueryAllRolesForOrganizationArgs = {
  id: Scalars['ID'];
};

export type QueryApplicationArgs = {
  id: Scalars['String'];
};

export type QueryAuditLogEventArgs = {
  id: Scalars['String'];
};

export type QueryAuditLogEventsArgs = {
  actions?: InputMaybe<Array<Scalars['String']>>;
  actorIds?: InputMaybe<Array<Scalars['String']>>;
  actors?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  targetIds?: InputMaybe<Array<Scalars['String']>>;
  targets?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAuditLogExportArgs = {
  id: Scalars['String'];
};

export type QueryAuditLogSchemaPreviewArgs = {
  action: Scalars['String'];
  environmentId?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['JSON']>;
  targets: Array<Scalars['String']>;
};

export type QueryAuditLogStreamArgs = {
  id: Scalars['String'];
};

export type QueryAuditLogTargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  target?: InputMaybe<Scalars['String']>;
};

export type QueryAuditLogValidatorArgs = {
  id: Scalars['String'];
};

export type QueryAuditLogValidatorsArgs = {
  action?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryAuditTrailEventArgs = {
  id: Scalars['String'];
};

export type QueryAuditTrailEventsArgs = {
  action?: InputMaybe<Array<Scalars['String']>>;
  action_type?: InputMaybe<Array<Scalars['String']>>;
  actor_id?: InputMaybe<Array<Scalars['String']>>;
  actor_name?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  group?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  occurred_at?: InputMaybe<Scalars['DateTime']>;
  occurred_at_gt?: InputMaybe<Scalars['DateTime']>;
  occurred_at_gte?: InputMaybe<Scalars['DateTime']>;
  occurred_at_lt?: InputMaybe<Scalars['DateTime']>;
  occurred_at_lte?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  target_id?: InputMaybe<Array<Scalars['String']>>;
  target_name?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAuthenticationFactorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryAutoMappedCustomAttributesArgs = {
  environmentId: Scalars['String'];
};

export type QueryCheckEmailSuppressionArgs = {
  input: CheckEmailSuppressionInput;
};

export type QueryConnectionArgs = {
  id: Scalars['String'];
};

export type QueryConnectionSessionArgs = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QueryContextSchemaArgs = {
  environmentId: Scalars['String'];
};

export type QueryCustomDomainArgs = {
  environmentId: Scalars['String'];
  type: CustomDomainType;
};

export type QueryCustomEmailProvidersArgs = {
  environmentId: Scalars['String'];
};

export type QueryCustomerMigrationArgs = {
  environmentId: Scalars['String'];
};

export type QueryCustomerMigrationLogArgs = {
  customerMigrationId: Scalars['ID'];
  id: Scalars['ID'];
};

export type QueryCustomerMigrationLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customerMigrationId: Scalars['ID'];
  endpointType?: InputMaybe<CustomerMigrationLogEndpointType>;
  first?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  routingDecision?: InputMaybe<CustomerMigrationLogRoutingDecision>;
  status?: InputMaybe<CustomerMigrationLogStatus>;
};

export type QueryDataIntegrationArgs = {
  id: Scalars['String'];
};

export type QueryDataIntegrationForProviderArgs = {
  environmentId: Scalars['ID'];
  provider: DataIntegrationType;
};

export type QueryDataProviderIntegrationArgs = {
  id: Scalars['ID'];
};

export type QueryDataProviderIntegrationForSlugArgs = {
  environmentId: Scalars['ID'];
  providerSlug: Scalars['String'];
};

export type QueryDatadogWebhookEndpointArgs = {
  environmentId: Scalars['String'];
};

export type QueryDefaultRedirectUriArgs = {
  environmentId: Scalars['String'];
};

export type QueryDefaultUserlandApplicationArgs = {
  environmentId: Scalars['String'];
};

export type QueryDescendantTypesForResourceTypeArgs = {
  loadTopologies?: InputMaybe<Scalars['Boolean']>;
  resourceTypeId: Scalars['ID'];
};

export type QueryDirectoryArgs = {
  id: Scalars['String'];
};

export type QueryDirectoryAttributeMapArgs = {
  id: Scalars['String'];
};

export type QueryDirectoryCustomAttributeMappingsArgs = {
  directoryId: Scalars['String'];
};

export type QueryDirectoryCustomAttributesArgs = {
  environmentId: Scalars['String'];
};

export type QueryDirectoryGroupConfigsSummaryDashboardArgs = {
  id: Scalars['String'];
};

export type QueryDirectorySyncRunArgs = {
  id: Scalars['String'];
};

export type QueryDirectoryUserArgs = {
  directoryId: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
};

export type QueryEnvironmentArgs = {
  id: Scalars['String'];
};

export type QueryEventActionsArgs = {
  environmentId: Scalars['String'];
};

export type QueryFlagArgs = {
  id: Scalars['ID'];
};

export type QueryFlagBySlugArgs = {
  projectId: Scalars['String'];
  slug: Scalars['String'];
};

export type QueryFlagsForProjectArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  projectId: Scalars['String'];
  rangeEnd?: InputMaybe<Scalars['DateTime']>;
  rangeStart?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGroupRoleMappingArgs = {
  id: Scalars['String'];
};

export type QueryGroupsForConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  connectionId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryGroupsForDirectoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  directoryId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  memberCountMaximum?: InputMaybe<Scalars['Int']>;
  memberCountMinimum?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  roleId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryIdpAttributesConfigForEnvironmentArgs = {
  id: Scalars['ID'];
};

export type QueryIdpAttributesConfigForOrganizationArgs = {
  id: Scalars['ID'];
};

export type QueryInternalDirectoryArgs = {
  id: Scalars['String'];
};

export type QueryIsRoleAssignmentEnabledForAnyOrganizationArgs = {
  environmentId: Scalars['ID'];
};

export type QueryJwtTemplateArgs = {
  environmentId: Scalars['String'];
};

export type QueryKeysArgs = {
  applicationId?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  scope?: InputMaybe<KeyScope>;
};

export type QueryLogoutUrisArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryManagedListBindingArgs = {
  environmentId?: InputMaybe<Scalars['String']>;
  listId: Scalars['String'];
};

export type QueryMembershipCountForRoleArgs = {
  id: Scalars['ID'];
};

export type QueryMigrationApplicationsArgs = {
  customerMigrationId: Scalars['String'];
};

export type QueryMigrationConnectionsArgs = {
  customerMigrationId: Scalars['String'];
  includeProviderConnections?: InputMaybe<Scalars['Boolean']>;
};

export type QueryOauthCredentialsByTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  type: ConnectionType;
};

export type QueryOidcJwtSigningKeyPairArgs = {
  connectionId: Scalars['String'];
};

export type QueryOnboardingGuidesArgs = {
  environmentId: Scalars['String'];
};

export type QueryOrganizationArgs = {
  id: Scalars['String'];
};

export type QueryOrganizationAdminsArgs = {
  organizationId: Scalars['String'];
};

export type QueryOrganizationCountArgs = {
  environmentId: Scalars['String'];
};

export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  auditLogStreamState?: InputMaybe<AuditLogStreamState>;
  auditLogStreamType?: InputMaybe<AuditLogStreamType>;
  before?: InputMaybe<Scalars['String']>;
  connectionState?: InputMaybe<OrganizationConnectionState>;
  connectionType?: InputMaybe<ConnectionType>;
  directoryState?: InputMaybe<OrganizationDirectoryState>;
  directoryType?: InputMaybe<DirectoryType>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  environmentId: Scalars['String'];
  expiringCertificateWindow?: InputMaybe<Scalars['DateTime']>;
  hasDataIntegrations?: InputMaybe<Scalars['Boolean']>;
  hasOrganizationAdmin?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  rangeEnd?: InputMaybe<Scalars['DateTime']>;
  rangeStart?: InputMaybe<Scalars['DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<OrganizationSortField>;
  usersCountMaximum?: InputMaybe<Scalars['Int']>;
  usersCountMinimum?: InputMaybe<Scalars['Int']>;
};

export type QueryPasswordlessSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  connectionId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryPermissionsByResourceTypeIdsArgs = {
  input: PermissionsByResourceTypeInput;
};

export type QueryPermissionsForEnvironmentArgs = {
  id: Scalars['ID'];
};

export type QueryPortalSetupLinkEmailSentEventsArgs = {
  portalSetupLinkId: Scalars['String'];
};

export type QueryProfileArgs = {
  id: Scalars['String'];
};

export type QueryProfileByEmailArgs = {
  input: ProfileByEmailInput;
};

export type QueryProfileByIdpIdArgs = {
  input: ProfileByIdpIdInput;
};

export type QueryRadarListDetailsArgs = {
  action: RadarListAction;
  environmentId?: InputMaybe<Scalars['String']>;
  type: RadarBlocklistType;
};

export type QueryRadarListEntriesArgs = {
  action: RadarListAction;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  type: RadarBlocklistType;
};

export type QueryRedirectUrisArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

export type QueryRequestArgs = {
  id: Scalars['String'];
};

export type QueryRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  method?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<PaginationOrder>;
  path?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type QueryResourceInstanceCountForTypeArgs = {
  id: Scalars['ID'];
};

export type QueryResourceRoleAssignmentsForOrganizationMembershipArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationMembershipId: Scalars['String'];
};

export type QueryResourceTypesForEnvironmentArgs = {
  id: Scalars['ID'];
  loadTopologies?: InputMaybe<Scalars['Boolean']>;
  orderByHierarchy?: InputMaybe<Scalars['Boolean']>;
};

export type QueryRoleConfigForEnvironmentV2Args = {
  id: Scalars['ID'];
};

export type QueryRoleConfigForOrganizationV2Args = {
  id: Scalars['ID'];
};

export type QueryRoleCountForPermissionArgs = {
  id: Scalars['ID'];
};

export type QueryRoleMappingCountsForRolesArgs = {
  input: RoleMappingCountForRoleListInput;
};

export type QueryRolesForEnvironmentArgs = {
  id: Scalars['ID'];
  resourceScope?: InputMaybe<Scalars['String']>;
};

export type QueryRolesForOrganizationArgs = {
  id: Scalars['ID'];
};

export type QuerySlackConfigStatusArgs = {
  environmentId: Scalars['ID'];
};

export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<PaginationOrder>;
  projectId: Scalars['String'];
};

export type QueryUserlandApplicationArgs = {
  id: Scalars['ID'];
};

export type QueryUserlandApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryUserlandUserArgs = {
  id: Scalars['ID'];
};

export type QueryUserlandUserInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryUserlandUserOrganizationMembershipArgs = {
  id: Scalars['String'];
};

export type QueryUserlandUserOrganizationMembershipsArgs = {
  id: Scalars['String'];
};

export type QueryUserlandUserOrganizationMembershipsByUserIdsArgs = {
  input: UserlandUserOrganizationMembershipsByUserIdsArgs;
};

export type QueryUserlandUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dataIntegrationId?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sessionStatus?: InputMaybe<UserlandUserSessionStatus>;
  sortField?: InputMaybe<UserlandUserSortField>;
};

export type QueryUsersCountArgs = {
  environmentId: Scalars['String'];
};

export type QueryVaultKeySettingsByIdArgs = {
  id: Scalars['String'];
};

export type QueryWaitlistEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<WaitlistEntryState>;
};

export type QueryWebhookArgs = {
  id: Scalars['String'];
};

export type QueryWebhookEndpointArgs = {
  id: Scalars['String'];
};

export type QueryWebhookEndpointsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
};

/** Type of blocklist for Radar lists. */
export enum RadarBlocklistType {
  Country = 'Country',
  Device = 'Device',
  DeviceFingerprint = 'DeviceFingerprint',
  Domain = 'Domain',
  Email = 'Email',
  IpAddress = 'IpAddress',
  UserAgent = 'UserAgent',
}

export type RadarBotDetectionData = {
  anomalousIpAddress?: Maybe<Scalars['Boolean']>;
  automationSignalDetected?: Maybe<Scalars['Boolean']>;
  emailPatternDetected?: Maybe<Scalars['Boolean']>;
  excessiveDomainSignUps?: Maybe<Scalars['Boolean']>;
  ipRiskDetected?: Maybe<Scalars['Boolean']>;
  missingDeviceFingerprint?: Maybe<Scalars['Boolean']>;
};

export enum RadarDecision {
  Block = 'Block',
  Challenge = 'Challenge',
  Log = 'Log',
}

export type RadarDetection = {
  action: RadarDetectionAction;
  botDetectionData?: Maybe<RadarBotDetectionData>;
  botScore?: Maybe<Scalars['Int']>;
  challengeCompletedAt?: Maybe<Scalars['DateTime']>;
  challengeType?: Maybe<RadarDetectionChallengeType>;
  control: RadarDetectionControl;
  createdAt: Scalars['DateTime'];
  device?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailDomain: Scalars['String'];
  grantType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ipAddress: Scalars['String'];
  isSignup?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  restrictionData?: Maybe<RadarRestrictionData>;
  updatedAt: Scalars['DateTime'];
  userAgent: Scalars['String'];
  userlandUserId?: Maybe<Scalars['String']>;
};

/** Action taken for radar detection. */
export enum RadarDetectionAction {
  Allow = 'Allow',
  Block = 'Block',
  Challenge = 'Challenge',
  Log = 'Log',
}

/** Type of challenge for radar detection. */
export enum RadarDetectionChallengeType {
  Email = 'Email',
  Sms = 'SMS',
}

/** Type of radar detection control. */
export enum RadarDetectionControl {
  BotDetection = 'BotDetection',
  BruteForceAttack = 'BruteForceAttack',
  DomainSignUpRateLimit = 'DomainSignUpRateLimit',
  ImpossibleTravel = 'ImpossibleTravel',
  RepeatSignUp = 'RepeatSignUp',
  Restriction = 'Restriction',
  StaleAccount = 'StaleAccount',
  UnrecognizedDevice = 'UnrecognizedDevice',
}

export type RadarDetectionList = {
  data: Array<RadarDetection>;
  listMetadata: ListMetadata;
};

/** Action to take on a Radar list. */
export enum RadarListAction {
  Allow = 'Allow',
  Block = 'Block',
  Challenge = 'Challenge',
  Log = 'Log',
}

export type RadarListBindingOperationSuccess = {
  success: Scalars['Boolean'];
};

export type RadarListDetails = {
  entryCount: Scalars['Int'];
};

export type RadarListEntry = {
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type RadarListEntryList = {
  data: Array<RadarListEntry>;
  listMetadata: ListMetadata;
};

export type RadarListEntryOperationSuccess = {
  success: Scalars['Boolean'];
};

export type RadarListInfo = {
  action?: Maybe<RadarListAction>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: RadarBlocklistType;
  workosManaged: Scalars['Boolean'];
};

export enum RadarMode {
  Decision = 'Decision',
  Log = 'Log',
  Off = 'Off',
}

export type RadarRestrictionData = {
  blocklistType?: Maybe<RadarBlocklistType>;
  list?: Maybe<RadarListInfo>;
  type: RadarRestrictionType;
};

/** Type of radar restriction. */
export enum RadarRestrictionType {
  List = 'List',
  PasswordSignup = 'PasswordSignup',
}

export type RadarSettings = {
  configuration: Configuration;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  radarMode: RadarMode;
  smsChallengesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type RadarSettingsUpdated = {
  radarSettings: RadarSettings;
};

/** Enum represents the type of a Radius. */
export enum Radius {
  Full = 'Full',
  Large = 'Large',
  Medium = 'Medium',
  None = 'None',
  Small = 'Small',
}

export type ReactivateUserlandUserOrganizationMembershipInput = {
  userlandUserOrganizationMembershipId: Scalars['String'];
};

export type ReactivateUserlandUserOrganizationMembershipResult =
  | UserlandUserOrganizationMembershipNotFound
  | UserlandUserOrganizationMembershipReactivated;

export type ReceivedAttribute = {
  attribute: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type RedirectUri = {
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  uri: Scalars['String'];
};

export type RedirectUriChecked = {
  success: Scalars['Boolean'];
};

export type RedirectUriList = {
  data: Array<RedirectUri>;
  listMetadata: ListMetadata;
};

export type RedirectUrisSet = {
  redirectUris: Array<RedirectUri>;
};

export type RefreshCustomDomainResult =
  | CustomDomainNotFound
  | CustomDomainRefreshed;

export type RegisterCustomDomainInput = {
  domain: Scalars['String'];
};

export type RegisterCustomDomainResult =
  | CustomDomainRegistered
  | InvalidDomain
  | OauthCredentialsNotFound;

export type RemoveCustomDomainInput = {
  customDomainId: Scalars['String'];
  environmentId: Scalars['String'];
  scope: CustomDomainScope;
};

export type RemoveCustomDomainResult = {
  /** All environments that were affected by the removal operation. */
  updatedEnvironments: Array<Environment>;
};

export type RemoveEmailSuppressionInput = {
  email: Scalars['String'];
  environmentId: Scalars['ID'];
};

export type RemoveEmailSuppressionResult =
  | EmailSuppressionRemovalSuccess
  | EnvironmentNotFoundForSuppression;

export type RemoveRadarListEntryInput = {
  action: RadarListAction;
  environmentId?: InputMaybe<Scalars['String']>;
  type: RadarBlocklistType;
  value: Scalars['String'];
};

export type RemoveRadarListEntryResult = RadarListEntryOperationSuccess;

export type RemoveUserlandUserFromOrganizationInput = {
  organizationId: Scalars['String'];
  userlandUserId: Scalars['String'];
};

export type RemoveUserlandUserFromOrganizationResult =
  | OrganizationNotFound
  | UserlandUserNotFound
  | UserlandUserOrganizationMembershipNotFound
  | UserlandUserRemovedFromOrganization;

export type RepeatSignUp = {
  decision: RadarDecision;
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
};

export type Request = {
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  method: Scalars['String'];
  path: Scalars['String'];
  requestBody?: Maybe<Scalars['JSON']>;
  requestHeaders: Scalars['JSON'];
  requestId?: Maybe<Scalars['String']>;
  requestQuery?: Maybe<Scalars['JSON']>;
  responseBody?: Maybe<Scalars['JSON']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['Float'];
};

export type RequestCustomDataIntegrationInput = {
  environmentId: Scalars['ID'];
  providerName: Scalars['String'];
  useCase: Scalars['String'];
};

export type RequestCustomDataIntegrationResult = CustomDataIntegrationRequested;

export type RequestDataIntegrationInput = {
  environmentId: Scalars['ID'];
  provider: DataIntegrationType;
};

export type RequestDataIntegrationResult =
  | DataIntegrationNotFound
  | DataIntegrationRequested;

export type RequestDataProviderInput = {
  environmentId: Scalars['ID'];
  providerSlug: Scalars['String'];
};

export type RequestDataProviderResult =
  | DataProviderNotFound
  | DataProviderRequested;

export type RequestList = {
  data: Array<Request>;
  listMetadata: ListMetadata;
};

export type ResendCustomEmailProvider = CustomEmailProvider & {
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type ResendDashboardInviteInput = {
  teamMembershipId: Scalars['String'];
};

export type ResendDashboardInviteResult =
  | DashboardInviteNotExpired
  | DashboardInviteNotFound
  | DashboardInviteResent;

export type ResendNotAllowedForEnvironment = {
  environmentId: Scalars['String'];
};

export type ResendUserlandUserInviteInput = {
  userlandUserInviteId: Scalars['String'];
};

export type ResendUserlandUserInviteResult =
  | UserlandUserInviteNotFound
  | UserlandUserInviteNotPending
  | UserlandUserInviteResent;

export type ResendWebhookEventFailed = {
  webhookId: Scalars['String'];
};

export type ResendWebhookEventInput = {
  webhookId: Scalars['String'];
};

export type ResendWebhookEventResult =
  | ResendNotAllowedForEnvironment
  | ResendWebhookEventFailed
  | ResendWebhookEventSuccessful
  | WebhookEventNotFound;

export type ResendWebhookEventSuccessful = {
  webhookId: Scalars['String'];
};

export type ResetOauthCredentialsInput = {
  oauthCredentialId: Scalars['String'];
  userlandEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type ResetOauthCredentialsPayload = {
  oauthCredentials?: Maybe<OAuthCredential>;
};

export type ResetOrganizationIdpAttributesConfigInput = {
  organizationIdpAttributesConfigId: Scalars['String'];
};

export type ResetOrganizationIdpAttributesConfigResult =
  | IdpAttributesConfigNotFound
  | OrganizationIdpAttributesConfigReset;

export type ResetOrganizationRoleConfigInput = {
  resetProperties: Array<NullableOrganizationRoleConfigProperties>;
  roleConfigId: Scalars['String'];
};

export type ResetOrganizationRoleConfigResult =
  | OrganizationRoleConfigReset
  | RoleConfigNotFound;

export type ResetUserMfaSettingsInput = {
  userId: Scalars['String'];
};

export type ResetUserMfaSettingsResult = UserMfaSettingsReset;

export type ResetUserlandUserAuthenticationFactorsInput = {
  userlandUserId: Scalars['String'];
};

export type ResetUserlandUserAuthenticationFactorsResult =
  | UserlandUserAuthenticationFactorsReset
  | UserlandUserNotFound;

export type ResourceInstanceCountForType = {
  resourceInstanceCount: Scalars['Int'];
};

export type ResourceInstanceCountForTypeResult =
  | AuthorizationResourceTypeNotFound
  | ResourceInstanceCountForType;

export type ResponseReplayedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type RevokeUserlandSessionInput = {
  sessionId: Scalars['String'];
};

export type RevokeUserlandSessionResult = RevokedUserlandSession;

export type RevokeUserlandUserInviteInput = {
  userlandUserInviteId: Scalars['String'];
};

export type RevokeUserlandUserInviteResult =
  | UserlandUserInviteNotFound
  | UserlandUserInviteNotPending
  | UserlandUserInviteRevoked;

export type RevokedUserlandSession = {
  sessionId: Scalars['String'];
};

export type RipplingDirectory = {
  apiKey?: Maybe<Scalars['String']>;
};

export type Role = {
  createdAt: Scalars['DateTime'];
  defaultForOrganizationsCount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
  resourceType?: Maybe<AuthorizationResourceType>;
  resourceTypeId?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  state: RoleState;
  type: RoleType;
  updatedAt: Scalars['DateTime'];
};

export type RoleAlreadyExists = {
  slug: Scalars['String'];
};

export type RoleAssignedToInternalDirectoryGroup = {
  internalDirectoryGroup: InternalDirectoryGroup;
};

export type RoleConfig = {
  createdAt: Scalars['DateTime'];
  defaultRole: Scalars['String'];
  dsyncRoleAssignmentEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  multipleRolesEnabled?: Maybe<Scalars['Boolean']>;
  rolePriorityOrder: Array<Scalars['String']>;
  ssoRoleAssignmentEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
};

export type RoleConfigNotFound = {
  roleConfigId: Scalars['String'];
};

export type RoleConfigNotFoundForOrganization = {
  organizationId: Scalars['String'];
};

export type RoleConfigUpdated = {
  roleConfig: RoleConfig;
};

export type RoleCountForPermission = {
  roleCount: Scalars['Int'];
};

export type RoleCountForPermissionResult =
  | PermissionNotFound
  | RoleCountForPermission;

export type RoleCreated = {
  role: Role;
  roleConfig: RoleConfig;
};

export type RoleDeleted = {
  roleConfig: RoleConfig;
};

export type RoleList = {
  roles: Array<Role>;
};

export type RoleMappingCountForRoleListInput = {
  directoryId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};

export type RoleNotFound = {
  roleId: Scalars['String'];
};

export type RoleOnOrganizationMembershipUpdated = {
  organizationMembership: UserlandUserOrganizationMembership;
};

/** Enum represents the different role states. */
export enum RoleState {
  Active = 'Active',
  Deleting = 'Deleting',
}

/** Enum represents the different role types. */
export enum RoleType {
  Environment = 'Environment',
  Organization = 'Organization',
}

export type RoleUnassignedFromInternalDirectoryGroup = {
  internalDirectoryGroup: InternalDirectoryGroup;
};

export type RoleUpdated = {
  role: Role;
};

/** Enum represents represents valid S3 content types. */
export enum S3ContentType {
  Binary = 'Binary',
  Bmp = 'Bmp',
  Gif = 'Gif',
  Jpeg = 'Jpeg',
  Png = 'Png',
  Svg = 'Svg',
  Tiff = 'Tiff',
}

export type S3LogStream = {
  accountId?: Maybe<Scalars['String']>;
  bucketName?: Maybe<Scalars['String']>;
  bucketPath?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  roleName?: Maybe<Scalars['String']>;
  workosAccountId: Scalars['String'];
};

export type SamlSession = {
  connectionId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errors: Array<ConnectionSessionError>;
  id: Scalars['ID'];
  initiator?: Maybe<SamlSessionInitiator>;
  profile?: Maybe<Profile>;
  profileSnapshot?: Maybe<ProfileSnapshot>;
  redirectUri?: Maybe<Scalars['String']>;
  relayState?: Maybe<Scalars['String']>;
  samlRequest?: Maybe<Scalars['String']>;
  samlResponse?: Maybe<Scalars['String']>;
  state: SamlSessionState;
  stateParameter?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/** Enum represents the state of the SAML Session. */
export enum SamlSessionState {
  Authorized = 'Authorized',
  Failed = 'Failed',
  Started = 'Started',
  Successful = 'Successful',
  Timedout = 'Timedout',
}

export type SamlSessionsList = {
  data: Array<SamlSession>;
  listMetadata: ListMetadata;
};

export type SamlAssertionMissingSignaturesError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type SamlConnection = {
  idpEntityId?: Maybe<Scalars['String']>;
};

export type SamlRelyingPartyTrust = {
  id: Scalars['ID'];
  notAfter: Scalars['DateTime'];
  notBefore: Scalars['DateTime'];
};

export type SamlResponseMissingAssertionError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

/** Enum represents how the SAML Session was initiated. */
export enum SamlSessionInitiator {
  AdminPortalTest = 'AdminPortalTest',
  AdminPortalTestCertificateRenewal = 'AdminPortalTestCertificateRenewal',
  IdentityProvider = 'IdentityProvider',
  ServiceProvider = 'ServiceProvider',
}

export type SamlX509Certificate = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  notAfter?: Maybe<Scalars['DateTime']>;
  notBefore?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type SamlX509CertificateDeleted = {
  samlX509Certificate: SamlX509Certificate;
};

export type SamlX509CertificateNotFound = {
  samlX509CertificateId: Scalars['String'];
};

export type SamlX509CertificateUpserted = {
  samlX509Certificate: SamlX509Certificate;
};

/** Enum represents why the SAML X509 Certificate was not valid. */
export enum SamlX509CertificateValidationErrorCode {
  ExpiredCertificate = 'ExpiredCertificate',
  MalformedCertificate = 'MalformedCertificate',
}

export type SegmentConfig = {
  enabled: Scalars['Boolean'];
  writeKey: Scalars['String'];
};

export type SegmentConfigUpserted = {
  segmentConfig: SegmentConfig;
};

export type SegmentWriteKeyInvalid = {
  validationError: Scalars['String'];
};

export type SendGridCustomEmailProvider = CustomEmailProvider & {
  createdAt: Scalars['DateTime'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  environmentId: Scalars['String'];
  id: Scalars['String'];
  providerType: CustomEmailProviderType;
  status: CustomEmailProviderStatus;
  updatedAt: Scalars['DateTime'];
};

export type SendSetupLinkEmailsInput = {
  certificateExpirationDate?: InputMaybe<Scalars['DateTime']>;
  connectionId?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  intents: Array<PortalSetupLinkIntent>;
  organizationId: Scalars['String'];
};

export type SendSetupLinkEmailsResult =
  | InvalidEmail
  | MissingIntent
  | OrganizationNotFound
  | SetupLinkEmailsSent
  | SetupLinkNotFound;

export type SendTestEmailInput = {
  environmentId: Scalars['String'];
};

export type SendTestEmailRateLimitedError = {
  retryAfterSeconds: Scalars['Float'];
};

export type SendTestEmailResult =
  | SendTestEmailRateLimitedError
  | SendTestEmailSendError
  | SendTestEmailSuccess;

export type SendTestEmailSendError = {
  error: Scalars['String'];
};

export type SendTestEmailSuccess = {
  success: Scalars['Boolean'];
};

export type SentEmail = {
  events: Array<SentEmailEvent>;
  id: Scalars['ID'];
  status: Scalars['String'];
  subject: Scalars['String'];
  timestamp: Scalars['DateTime'];
  to: Scalars['String'];
};

export type SentEmailEvent = {
  message: Scalars['String'];
  subType: Scalars['String'];
  timestamp: Scalars['DateTime'];
  type: Scalars['String'];
};

export type SentEmailList = {
  data: Array<SentEmail>;
  listMetadata: ListMetadata;
};

export type Session = {
  currentEnvironment: Environment;
  teamId: Scalars['ID'];
};

/** Enumeration of the different providers that can be used to create a session. */
export enum SessionProvider {
  AppleOauth = 'AppleOauth',
  BitbucketOAuth = 'BitbucketOAuth',
  CrossAppAuth = 'CrossAppAuth',
  DiscordOAuth = 'DiscordOAuth',
  ExternalAuth = 'ExternalAuth',
  GitLabOAuth = 'GitLabOAuth',
  GithubOAuth = 'GithubOAuth',
  GoogleOAuth = 'GoogleOAuth',
  Impersonation = 'Impersonation',
  IntuitOAuth = 'IntuitOAuth',
  LinkedInOAuth = 'LinkedInOAuth',
  MagicAuth = 'MagicAuth',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MigratedSession = 'MigratedSession',
  Passkey = 'Passkey',
  Password = 'Password',
  SalesforceOAuth = 'SalesforceOAuth',
  SingleSignOn = 'SingleSignOn',
  SlackOAuth = 'SlackOAuth',
  VercelMarketplaceOAuth = 'VercelMarketplaceOAuth',
  VercelOAuth = 'VercelOAuth',
  XeroOAuth = 'XeroOAuth',
}

export type SetApplicationPermissions = {
  application: Application;
};

export type SetApplicationPermissionsInput = {
  applicationId: Scalars['ID'];
  permissionIds: Array<Scalars['ID']>;
};

export type SetApplicationPermissionsResult = SetApplicationPermissions;

export type SetAuthkitOauthResourceInput = {
  id?: InputMaybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type SetAuthkitOauthResourcesInput = {
  environmentId: Scalars['String'];
  resources: Array<SetAuthkitOauthResourceInput>;
};

export type SetAuthkitOauthResourcesResult =
  | AuthkitOauthResourceNotFoundError
  | AuthkitOauthResourcesSet
  | InvalidAuthkitOauthResourceError;

export type SetAutoMappedCustomAttributesInput = {
  attributeNames: Array<AutoMappedCustomAttributeName>;
  environmentId: Scalars['String'];
};

export type SetAutoMappedCustomAttributesResult =
  | ActiveAutoMappedCustomAttributes
  | CustomAttributeInvalid;

export type SetDefaultDynamicRegistrationOAuthScopesResult =
  DefaultDynamicRegistrationOAuthScopesSet;

export type SetDirectoryCustomAttributeMappingsInput = {
  directoryId: Scalars['ID'];
  mappings: Array<DirectoryCustomAttributeMappingInput>;
};

export type SetDirectoryCustomAttributeMappingsResult =
  | DirectoryCustomAttributeMappingsSet
  | DirectoryCustomAttributeNotFound
  | DirectoryNotFound;

export type SetDomainsForOrganizationInput = {
  domains: Array<Scalars['String']>;
  domainsDeveloperVerified?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
};

export type SetDomainsForOrganizationPayload = {
  organization?: Maybe<Organization>;
};

export type SetEmailNotificationPreferenceInput = {
  category: EmailNotificationCategory;
  preference: EmailNotificationPreferenceConfiguration;
};

export type SetEmailNotificationPreferencesInput = {
  preferences: Array<SetEmailNotificationPreferenceInput>;
};

export type SetEmailNotificationPreferencesResult =
  EmailNotificationPreferences;

export type SetLogoutUriInput = {
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  uri: Scalars['String'];
};

export type SetLogoutUrisInput = {
  /** Validate the logout URIs without persisting them to the database. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  environmentId: Scalars['String'];
  logoutUris: Array<SetLogoutUriInput>;
};

export type SetLogoutUrisResult =
  | InvalidLogoutUriError
  | InvalidWildcardLogoutUri
  | LogoutUrisSet;

export type SetPermissionsEnabledForApiKeysResult =
  PermissionsEnabledForApiKeysSet;

export type SetRedirectUriInput = {
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  uri: Scalars['String'];
};

export type SetRedirectUrisInput = {
  applicationId?: InputMaybe<Scalars['String']>;
  /** Validate the redirect URIs without persisting them to the database. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  environmentId?: InputMaybe<Scalars['String']>;
  redirectUris: Array<SetRedirectUriInput>;
};

export type SetRedirectUrisResult =
  | InvalidRedirectUriError
  | InvalidWildcardRedirectUri
  | RedirectUrisSet;

export type SetSsoAttributeMappingsResult =
  | ConnectionNotFound
  | CustomAttributeNotFound
  | SsoCustomAttributeMappingsSet;

export type SetSsoCustomAttributeMappingsInput = {
  connectionId: Scalars['ID'];
  customAttributeMappings: Array<SsoCustomAttributeMappingInput>;
};

export type SetTeamDefaultRoleInput = {
  defaultRole: UsersOrganizationsRole;
};

export type SetTeamDefaultRoleResult = TeamDefaultRoleSet;

export type SetUserlandApplicationLogoutUriInput = {
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  uri: Scalars['String'];
};

export type SetUserlandApplicationLogoutUrisInput = {
  applicationId: Scalars['String'];
  /** Validate the logout URIs without persisting them to the database. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  logoutUris: Array<SetUserlandApplicationLogoutUriInput>;
};

export type SetUserlandApplicationLogoutUrisResult =
  | InvalidLogoutUriError
  | InvalidWildcardLogoutUri
  | LogoutUrisSet
  | MultipleDefaultUrisError
  | UserlandApplicationNotFound;

export type SetUserlandApplicationRedirectUriInput = {
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  uri: Scalars['String'];
};

export type SetUserlandApplicationRedirectUrisInput = {
  applicationId: Scalars['String'];
  /** Validate the redirect URIs without persisting them to the database. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  redirectUris: Array<SetUserlandApplicationRedirectUriInput>;
};

export type SetUserlandApplicationRedirectUrisResult =
  | InvalidRedirectUriError
  | InvalidWildcardRedirectUri
  | RedirectUrisSet
  | UserlandApplicationNotFound;

export type SetUserlandApplicationWebOriginsInput = {
  applicationId: Scalars['String'];
  /** Validate the web origins without persisting them to the database. */
  dryRun?: Scalars['Boolean'];
  origins: Array<Scalars['String']>;
};

export type SetUserlandApplicationWebOriginsResult =
  | InvalidWebOriginProtocol
  | InvalidWildcardWebOrigin
  | MalformedWebOrigin
  | UserlandApplicationNotFound
  | WebOriginsSet
  | WildcardNotAllowedInEnvironment;

export type SetWebOriginsResult =
  | InvalidWebOriginProtocol
  | InvalidWildcardWebOrigin
  | MalformedWebOrigin
  | WebOriginsSet
  | WildcardNotAllowedInEnvironment;

export type SetupIntentRequiresAction = {
  clientSecret: Scalars['String'];
  stripePaymentMethodId: Scalars['String'];
};

export type SetupLinkEmailsSent = {
  organizationAdmins: Array<OrganizationAdmin>;
};

export type SetupLinkNotFound = {
  intent: PortalSetupLinkIntent;
  organizationId: Scalars['String'];
};

export type SftpDirectory = {
  publicKey?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Enum represents the type of the SFTP source provider. */
export enum SftpSourceProvider {
  Generic = 'Generic',
  Workday = 'Workday',
}

export type SharedSlackChannelGenerated = {
  slackChannel: SlackChannel;
};

export type SlackChannel = {
  externalChannelId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slackTeamId?: Maybe<Scalars['String']>;
};

export type SlackChannelForTeamNotFound = {
  teamId: Scalars['String'];
};

export type SlackChannelInviteSent = {
  slackChannel: SlackChannel;
};

export type SlackChannelNotReadyForInvites = {
  slackChannel: SlackChannel;
};

export type SlackConfigStatus = {
  channelId?: Maybe<Scalars['String']>;
  channelName?: Maybe<Scalars['String']>;
  isConnected: Scalars['Boolean'];
  teamName?: Maybe<Scalars['String']>;
};

export type SlackInstallUrl = {
  url: Scalars['String'];
};

export type SmsAuthenticationFactorType = {
  phoneNumber: Scalars['String'];
};

export type SplunkLogStream = {
  hecToken?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SsoAlreadyConnectedForDomain = {
  domain: Scalars['String'];
};

export type SsoCustomAttributeMapping = {
  attribute: Scalars['String'];
  id: Scalars['ID'];
};

export type SsoCustomAttributeMappingInput = {
  attribute: Scalars['String'];
  customAttributeId: Scalars['ID'];
};

export type SsoCustomAttributeMappingsSet = {
  customAttributeMappings: Array<SsoCustomAttributeMapping>;
};

export type SsoCustomAttributeWithMapping = {
  id: Scalars['ID'];
  name: Scalars['String'];
  ssoCustomAttributeMapping?: Maybe<SsoCustomAttributeMapping>;
  type: CustomAttributeType;
};

export type SsoCustomAttributeWithMappingList = {
  data: Array<SsoCustomAttributeWithMapping>;
};

export type StaleAccount = {
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
  notifyUser: Scalars['Boolean'];
};

/** The policy for enforcing profile email domain and organization domain alignment. */
export enum StandaloneSsoDomainPolicy {
  AllowAll = 'AllowAll',
  None = 'None',
  RestrictToOrganizationDomains = 'RestrictToOrganizationDomains',
}

export type StartSyncingInternalDirectoryInput = {
  id: Scalars['String'];
};

export type StartSyncingInternalDirectoryResult = SyncingInternalDirectory;

export type StripeBillingData = {
  billingAddress: BillingAddress;
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  defaultPaymentMethod: DefaultPaymentMethod;
  lastInvoiceSummary?: Maybe<LastInvoiceSummary>;
};

export type StripeCardError = {
  errorMessage: Scalars['String'];
};

export type StripeConnectAuthorizationError = {
  error?: Maybe<Scalars['String']>;
  errorDescription?: Maybe<Scalars['String']>;
};

/** The state of the environment's Stripe Connect connection. */
export enum StripeConnectState {
  Canceled = 'Canceled',
  Connected = 'Connected',
  Connecting = 'Connecting',
  ConnectionError = 'ConnectionError',
  Deauthorized = 'Deauthorized',
}

export type StripeError = {
  errorMessage: Scalars['String'];
};

export type SuccessResponse = {
  success: Scalars['Boolean'];
};

export type SyncingInternalDirectory = {
  internalDirectory: InternalDirectory;
};

export type Tag = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TagList = {
  data: Array<Tag>;
  listMetadata: ListMetadata;
};

export type TaxId = {
  countryCode: TaxIdCountryCode;
  type: TaxIdType;
  value: Scalars['String'];
};

export type TaxIdAdded = {
  taxId: TaxId;
};

/** Supported tax id country codes from Orb. */
export enum TaxIdCountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Ar = 'AR',
  At = 'AT',
  Au = 'AU',
  Be = 'BE',
  Bg = 'BG',
  Bo = 'BO',
  Br = 'BR',
  Ca = 'CA',
  Ch = 'CH',
  Cl = 'CL',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Do = 'DO',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Es = 'ES',
  Eu = 'EU',
  Fi = 'FI',
  Fr = 'FR',
  Gb = 'GB',
  Ge = 'GE',
  Gr = 'GR',
  Hk = 'HK',
  Hr = 'HR',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  In = 'IN',
  Is = 'IS',
  It = 'IT',
  Jp = 'JP',
  Ke = 'KE',
  Kr = 'KR',
  Li = 'LI',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mt = 'MT',
  Mx = 'MX',
  My = 'MY',
  Nl = 'NL',
  No = 'NO',
  Nz = 'NZ',
  Pe = 'PE',
  Ph = 'PH',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Sa = 'SA',
  Se = 'SE',
  Sg = 'SG',
  Si = 'SI',
  Sk = 'SK',
  Sv = 'SV',
  Th = 'TH',
  Tr = 'TR',
  Tw = 'TW',
  Ua = 'UA',
  Us = 'US',
  Uy = 'UY',
  Ve = 'VE',
  Vn = 'VN',
  Za = 'ZA',
}

export type TaxIdInvalid = {
  taxId: TaxId;
};

/** Supported tax id types from Orb. */
export enum TaxIdType {
  AdNrt = 'ad_nrt',
  AeTrn = 'ae_trn',
  ArCuit = 'ar_cuit',
  AuAbn = 'au_abn',
  AuArn = 'au_arn',
  BgUic = 'bg_uic',
  BoTin = 'bo_tin',
  BrCnpj = 'br_cnpj',
  BrCpf = 'br_cpf',
  CaBn = 'ca_bn',
  CaGstHst = 'ca_gst_hst',
  CaPstBc = 'ca_pst_bc',
  CaPstMb = 'ca_pst_mb',
  CaPstSk = 'ca_pst_sk',
  CaQst = 'ca_qst',
  ChVat = 'ch_vat',
  ClTin = 'cl_tin',
  CnTin = 'cn_tin',
  CoNit = 'co_nit',
  CrTin = 'cr_tin',
  DoRcn = 'do_rcn',
  EcRuc = 'ec_ruc',
  EgTin = 'eg_tin',
  EsCif = 'es_cif',
  EuOssVat = 'eu_oss_vat',
  EuVat = 'eu_vat',
  GbVat = 'gb_vat',
  GeVat = 'ge_vat',
  HkBr = 'hk_br',
  HuTin = 'hu_tin',
  IdNpwp = 'id_npwp',
  IlVat = 'il_vat',
  InGst = 'in_gst',
  IsVat = 'is_vat',
  JpCn = 'jp_cn',
  JpRn = 'jp_rn',
  JpTrn = 'jp_trn',
  KePin = 'ke_pin',
  KrBrn = 'kr_brn',
  LiUid = 'li_uid',
  MxRfc = 'mx_rfc',
  MyFrp = 'my_frp',
  MyItn = 'my_itn',
  MySst = 'my_sst',
  NoVat = 'no_vat',
  NzGst = 'nz_gst',
  PeRuc = 'pe_ruc',
  PhTin = 'ph_tin',
  RoTin = 'ro_tin',
  RsPib = 'rs_pib',
  RuInn = 'ru_inn',
  RuKpp = 'ru_kpp',
  SaVat = 'sa_vat',
  SgGst = 'sg_gst',
  SgUen = 'sg_uen',
  SiTin = 'si_tin',
  SvNit = 'sv_nit',
  ThVat = 'th_vat',
  TrTin = 'tr_tin',
  TwVat = 'tw_vat',
  UaVat = 'ua_vat',
  UsEin = 'us_ein',
  UyRuc = 'uy_ruc',
  VeRif = 've_rif',
  VnTin = 'vn_tin',
  ZaVat = 'za_vat',
}

export type Team = {
  billingDetails: TeamBillingDetails;
  billingInvoice: DetailedBillingInvoiceResult;
  canDeleteTeam: TeamDeletionValidationResult;
  connection?: Maybe<Connection>;
  createdAt: Scalars['DateTime'];
  defaultUserProvisioningRole?: Maybe<UsersOrganizationsRole>;
  domain: Scalars['String'];
  endpoint_url?: Maybe<Scalars['String']>;
  entitlements: Array<Entitlement>;
  id: Scalars['ID'];
  internalDirectory?: Maybe<InternalDirectory>;
  isMfaRequired: Scalars['Boolean'];
  isUsingConsumerDomain: Scalars['Boolean'];
  name: Scalars['String'];
  onboarding: TeamOnboardingStatus;
  orbBillingData?: Maybe<OrbBillingData>;
  organizationId?: Maybe<Scalars['String']>;
  paymentHistory: BillingPaymentHistory;
  productionEnabledAt?: Maybe<Scalars['DateTime']>;
  productionState?: Maybe<TeamProductionState>;
  projectsV2: Array<ProjectV2>;
  replyToEmail?: Maybe<Scalars['String']>;
  sdk_language?: Maybe<Scalars['String']>;
  slackChannels: Array<SlackChannel>;
  sso_onboarding_step?: Maybe<Scalars['Int']>;
  stripeBillingData: StripeBillingData;
  stripe_customer_id?: Maybe<Scalars['String']>;
  unassociatedSlackChannels: Array<UnassociatedSlackChannel>;
  userManagementActivated: Scalars['Boolean'];
  users_teams: Array<UsersTeam>;
  workOsOrganizationDomains?: Maybe<Array<OrganizationDomain>>;
};

export type TeamBillingInvoiceArgs = {
  invoiceId: Scalars['String'];
};

export type TeamAuditLogStats = {
  billable30DayRention: Scalars['Float'];
  billable90DayRetention: Scalars['Float'];
  billable365DayRetention: Scalars['Float'];
  billableStreams: Scalars['Float'];
};

export type TeamBillingDetails = {
  auditLogs: TeamAuditLogStats;
  connections: TeamConnectionStats;
  directories: TeamDirectoryStats;
  email?: Maybe<Scalars['String']>;
  /** Whether the team has a billing address saved to Stripe. */
  hasBillingAddress: Scalars['Boolean'];
  taxId?: Maybe<TaxId>;
};

export type TeamCannotBeDeleted = {
  reason: Scalars['String'];
  team: Team;
};

export type TeamConnectionStats = {
  billableConnectionCount: Scalars['Float'];
};

export type TeamDefaultRoleSet = {
  team: Team;
};

export type TeamDeletionQueued = {
  message: Scalars['String'];
  team: Team;
};

export type TeamDeletionValidationResult = {
  canDelete: Scalars['Boolean'];
  hasOnlyCustomDomainCharges: Scalars['Boolean'];
};

export type TeamDetailsUpdated = {
  team: Team;
};

export type TeamDirectoryStats = {
  billableDirectoryCount: Scalars['Float'];
};

export type TeamMfaIneligible = {
  teamId: Scalars['String'];
};

export type TeamMfaRequirementUpdated = {
  team: Team;
};

export type TeamMissingStripeData = {
  teamId: Scalars['String'];
};

export type TeamNotFound = {
  teamId: Scalars['String'];
};

export type TeamOnboarded = {
  status: Scalars['String'];
};

export type TeamOnboarding = {
  /** The next onboarding step the team needs to go through. */
  nextStep: Scalars['String'];
  status: Scalars['String'];
};

export type TeamOnboardingStatus = TeamOnboarded | TeamOnboarding;

export type TeamPlatform = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lastActivityAt: Scalars['DateTime'];
  platform: Scalars['String'];
  teamId: Scalars['ID'];
};

export type TeamPlatformNotFound = {
  platform: Scalars['String'];
  teamId: Scalars['ID'];
};

export enum TeamProductionState {
  Active = 'Active',
  Deleting = 'Deleting',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
}

export type TestActionEndpointInput = {
  context: Scalars['JSON'];
  environmentId: Scalars['String'];
  type: ActionsEndpointType;
};

export type TestActionEndpointResult =
  | ActionExecution
  | InvalidContext
  | NoEndpointConfigured
  | UnsupportedType;

export type TestJwtTemplateInput = {
  context: Scalars['JSON'];
  environmentId: Scalars['String'];
  template: Scalars['String'];
};

export type TestJwtTemplateResult =
  | InvalidJwtTemplateContextError
  | JwtTemplateRenderingError
  | JwtTemplateRenderingResult;

/** Enum represents the type of a Theme. */
export enum Theme {
  Dark = 'Dark',
  Light = 'Light',
  System = 'System',
}

export type ThirdPartyApplication = Application & {
  clientConfidentiality: ApplicationClientConfidentiality;
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credentials: Array<ApplicationCredential>;
  darkLogoPath?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isClientIdMetadataDocument: Scalars['Boolean'];
  isFirstParty: Scalars['Boolean'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  lightLogoPath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization: Organization;
  permissions: Array<Permission>;
  redirectUris: Array<RedirectUri>;
  type: ApplicationType;
  updatedAt: Scalars['DateTime'];
};

export type TooManyOrganizationAdmins = {
  currentCount: Scalars['Int'];
  limit: Scalars['Int'];
  requestedCount: Scalars['Int'];
};

/** Number of top organizations to return. */
export enum TopN {
  Top10 = 'Top10',
}

export type TotpAuthenticationFactorType = {
  issuer: Scalars['String'];
  secret: Scalars['String'];
  user: Scalars['String'];
};

export type TotpUserAuthenticationFactorEnrolled = {
  challengeId: Scalars['String'];
  qrCode: Scalars['String'];
  secret: Scalars['String'];
  userAuthenticationFactor: UserAuthenticationFactor;
};

export type UnassignRoleFromInternalDirectoryGroupInput = {
  internalDirectoryGroupId: Scalars['String'];
};

export type UnassignRoleFromInternalDirectoryGroupResult =
  | InternalDirectoryGroupNotFound
  | RoleUnassignedFromInternalDirectoryGroup;

export type UnassociatedSlackChannel = {
  id: Scalars['ID'];
};

export type UnauthorizedComplianceExport = {
  type: ComplianceExportType;
};

export type UnbindManagedListFromEnvironmentInput = {
  action: RadarListAction;
  environmentId?: InputMaybe<Scalars['String']>;
  listId: Scalars['String'];
};

export type UnbindManagedListFromEnvironmentResult =
  RadarListBindingOperationSuccess;

export type UnrecognizedDevice = {
  enabled: Scalars['Boolean'];
  notifyAdmin: Scalars['Boolean'];
  notifyUser: Scalars['Boolean'];
};

export type UnsupportedType = {
  type: ActionsEndpointType;
};

/** A Connection that has not yet been assigned a type. */
export type UntypedConnection = {
  environment: Environment;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
};

/** A Directory that has not yet been assigned a type. */
export type UntypedDirectory = {
  environment: Environment;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
};

export type UpcomingInvoice = {
  lineItems: Array<InvoiceLineItem>;
  total: Scalars['Float'];
};

export type UpdateAppBrandingInput = {
  authkitLogoStyle?: InputMaybe<LogoStyle>;
  authkitShowLastUsedBadge?: InputMaybe<Scalars['Boolean']>;
  authkitSignInContentPanelAlignment?: InputMaybe<AuthKitPageContentPanelAlignment>;
  authkitSignInContentPanelHiddenOnMobile?: InputMaybe<Scalars['Boolean']>;
  authkitSignInCustomCss?: InputMaybe<Scalars['String']>;
  authkitSignInCustomHtml?: InputMaybe<Scalars['String']>;
  authkitSignInHeadingLocalized?: InputMaybe<Scalars['JSON']>;
  authkitSignInHeadingText?: InputMaybe<Scalars['String']>;
  authkitSignInLayout?: InputMaybe<AuthKitPageLayout>;
  authkitSignInLegalText?: InputMaybe<Scalars['String']>;
  authkitSignInLinkTextLocalized?: InputMaybe<Scalars['JSON']>;
  authkitSignInPrivacyPolicyUrl?: InputMaybe<Scalars['String']>;
  authkitSignInTermsOfServiceUrl?: InputMaybe<Scalars['String']>;
  authkitSignUpActionLinkText?: InputMaybe<Scalars['String']>;
  authkitSignUpContentPanelAlignment?: InputMaybe<AuthKitPageContentPanelAlignment>;
  authkitSignUpContentPanelHiddenOnMobile?: InputMaybe<Scalars['Boolean']>;
  authkitSignUpCustomCss?: InputMaybe<Scalars['String']>;
  authkitSignUpCustomHtml?: InputMaybe<Scalars['String']>;
  authkitSignUpHeadingLocalized?: InputMaybe<Scalars['JSON']>;
  authkitSignUpHeadingText?: InputMaybe<Scalars['String']>;
  authkitSignUpLayout?: InputMaybe<AuthKitPageLayout>;
  authkitSignUpLegalText?: InputMaybe<Scalars['String']>;
  authkitSignUpLinkText?: InputMaybe<Scalars['String']>;
  authkitSignUpLinkTextLocalized?: InputMaybe<Scalars['JSON']>;
  authkitSignUpPrivacyPolicyUrl?: InputMaybe<Scalars['String']>;
  authkitSignUpShowNameFields?: InputMaybe<Scalars['Boolean']>;
  authkitSignUpTermsOfServiceUrl?: InputMaybe<Scalars['String']>;
  customCssElements?: InputMaybe<CustomCssElementsInput>;
  darkButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  darkButtonForegroundColor?: InputMaybe<Scalars['String']>;
  darkFaviconFile?: InputMaybe<Scalars['Upload']>;
  darkLinkColor?: InputMaybe<Scalars['String']>;
  darkLogoFile?: InputMaybe<Scalars['Upload']>;
  darkLogoIconFile?: InputMaybe<Scalars['Upload']>;
  darkPageBackgroundColor?: InputMaybe<Scalars['String']>;
  emailLogoStyle?: InputMaybe<LogoStyle>;
  font?: InputMaybe<FontInput>;
  id: Scalars['String'];
  inviteAdminReplyToEmail?: InputMaybe<Scalars['String']>;
  lightButtonBackgroundColor?: InputMaybe<Scalars['String']>;
  lightButtonForegroundColor?: InputMaybe<Scalars['String']>;
  lightFaviconFile?: InputMaybe<Scalars['Upload']>;
  lightLinkColor?: InputMaybe<Scalars['String']>;
  lightLogoFile?: InputMaybe<Scalars['Upload']>;
  lightLogoIconFile?: InputMaybe<Scalars['Upload']>;
  lightPageBackgroundColor?: InputMaybe<Scalars['String']>;
  logoIconFit?: InputMaybe<LogoIconFit>;
  radius?: InputMaybe<Radius>;
  theme?: InputMaybe<Theme>;
};

export type UpdateAppBrandingResult =
  | AppBrandingNotFound
  | AppBrandingUpdated
  | AppBrandingUploadAssetsError;

export type UpdateApplicationInput = {
  applicationId: Scalars['String'];
  darkLogoFile?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['String']>;
  lightLogoFile?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateApplicationResult =
  | ApplicationAssetUploadError
  | ApplicationNotFound
  | ApplicationUpdated;

export type UpdateAttributeMapInput = {
  attributeMapId: Scalars['String'];
  emailAttribute: Scalars['String'];
  firstNameAttribute: Scalars['String'];
  groupsAttribute?: InputMaybe<Scalars['String']>;
  idpIdAttribute: Scalars['String'];
  lastNameAttribute: Scalars['String'];
};

export type UpdateAuth0CredentialsError = {
  code: Scalars['String'];
  message: Scalars['String'];
};

export type UpdateAuth0CredentialsSuccess = {
  certificateType?: Maybe<Scalars['String']>;
  customDomain?: Maybe<Scalars['String']>;
  customerMigration: CustomerMigration;
  originDomain?: Maybe<Scalars['String']>;
};

export type UpdateAuth0MigrationCredentialsInput = {
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  customerMigrationId: Scalars['String'];
  domain: Scalars['String'];
};

export type UpdateAuth0MigrationCredentialsResult =
  | CustomerMigrationNotFound
  | UpdateAuth0CredentialsError
  | UpdateAuth0CredentialsSuccess;

export type UpdateAuthorizationResourceTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentTypeIds?: InputMaybe<Array<Scalars['String']>>;
  resourceTypeId: Scalars['String'];
};

export type UpdateAuthorizationResourceTypeResult =
  | AuthorizationResourceTypeNotFound
  | AuthorizationResourceTypeUpdateNotValid
  | AuthorizationResourceTypeUpdated;

export type UpdateBambooHrDirectoryInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};

export type UpdateBotDetectionInput = {
  decision?: InputMaybe<RadarDecision>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateBreatheHrDirectoryInput = {
  apiKey?: InputMaybe<Scalars['String']>;
};

export type UpdateBruteForceAttackInput = {
  decision?: InputMaybe<RadarDecision>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCezanneHrDirectoryInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
};

export type UpdateConnectionFromDiscoveryEndpointInput = {
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  connectionId: Scalars['String'];
  discoveryEndpoint: Scalars['String'];
  ignoreWarnings?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type UpdateConnectionFromDiscoveryEndpointResult =
  | ConnectionNotFound
  | ConnectionUpdatedFromDiscoveryEndpoint
  | OidcDiscoveryValidationFailed;

export type UpdateConnectionFromMetadataUrlInput = {
  connectionId: Scalars['String'];
  metadataUrl: Scalars['String'];
};

export type UpdateConnectionFromMetadataUrlResult =
  | ConnectionNotFound
  | ConnectionUpdatedFromMetadataUrl
  | InvalidSamlX509Certificate
  | MetadataFetchFailed;

export type UpdateConnectionFromMetadataXmlInput = {
  connectionId: Scalars['String'];
  metadataXml: Scalars['String'];
};

export type UpdateConnectionFromMetadataXmlResult =
  | ConnectionNotFound
  | ConnectionUpdatedFromMetadataXml
  | InvalidSamlX509Certificate
  | MetadataParseFailed;

export type UpdateConnectionGroupInput = {
  connectionGroupId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateConnectionGroupResult =
  | ConnectionGroupNotFound
  | ConnectionGroupUpdated;

export type UpdateConnectionInput = {
  connectionId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  oidc?: InputMaybe<UpdateOidcConnectionInput>;
  saml?: InputMaybe<UpdateSamlConnectionInput>;
};

export type UpdateConnectionResult =
  | ConnectionNotFound
  | ConnectionUpdated
  | InvalidSamlX509Certificate;

export type UpdateCredentialStuffingInput = {
  decision?: InputMaybe<RadarDecision>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomEmailProviderInput = {
  awsSesRegion?: InputMaybe<Scalars['String']>;
  customEmailProviderId: Scalars['String'];
  defaultReplyTo: Scalars['String'];
  defaultSender: Scalars['String'];
  mailgunDomain?: InputMaybe<Scalars['String']>;
  mailgunRegion?: InputMaybe<MailgunCustomEmailProviderRegion>;
  unencryptedAwsAccessKeyId?: InputMaybe<Scalars['String']>;
  unencryptedAwsSecretAccessKey?: InputMaybe<Scalars['String']>;
  unencryptedMailgunApiKey?: InputMaybe<Scalars['String']>;
  unencryptedPostmarkAccountToken?: InputMaybe<Scalars['String']>;
  unencryptedPostmarkServerToken?: InputMaybe<Scalars['String']>;
  unencryptedResendApiKey?: InputMaybe<Scalars['String']>;
  unencryptedSendGridApiKey?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomEmailProviderResult =
  | CustomEmailProviderEmailAddressDomainNotVerifiedErrorList
  | CustomEmailProviderInputError
  | CustomEmailProviderNotFound
  | CustomEmailProviderSenderDomainNotVerifiedError
  | CustomEmailProviderUpdated
  | MailgunCustomEmailProviderDomainNotVerifiedError;

export type UpdateCustomMappedCustomAttributeInput = {
  customAttributeId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomMappedCustomAttributeResult =
  | CustomAttributeInvalid
  | CustomAttributeNotFound
  | CustomMappedCustomAttributeUpdated;

export type UpdateDataIntegrationInput = {
  credentials?: InputMaybe<DataIntegrationCredentialsInput>;
  dataIntegrationId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  scopes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDataIntegrationResult =
  | DataIntegrationNotFound
  | DataIntegrationUpdated
  | InvalidDataIntegrationCredentialsType;

export type UpdateDataProviderIntegrationResult =
  | DataIntegrationNotFound
  | DataProviderIntegrationUpdated
  | InvalidDataIntegrationCredentialsType;

export type UpdateDirectoryConfigInput = {
  directoryConfigId: Scalars['String'];
  groupsSync: DirectoryConfigGroupsSync;
};

export type UpdateDirectoryGroupConfigsAllowListInput = {
  directoryId: Scalars['String'];
  syncDirectoryGroupConfigIds?: InputMaybe<Array<Scalars['String']>>;
  unSyncDirectoryGroupConfigIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDirectoryGroupConfigsAllowListResult =
  | DirectoryNotFound
  | MissingDirectoryGroupsConfigsToUpdate
  | UpdatedAllowList;

export type UpdateDirectoryInput = {
  bambooHr?: InputMaybe<UpdateBambooHrDirectoryInput>;
  breatheHr?: InputMaybe<UpdateBreatheHrDirectoryInput>;
  cezanneHr?: InputMaybe<UpdateCezanneHrDirectoryInput>;
  directoryId: Scalars['String'];
  fourthHr?: InputMaybe<UpdateFourthHrDirectoryInput>;
  hibob?: InputMaybe<UpdateHibobDirectoryInput>;
  name?: InputMaybe<Scalars['String']>;
  peopleHr?: InputMaybe<UpdatePeopleHrDirectoryInput>;
  personio?: InputMaybe<UpdatePersonioDirectoryInput>;
  rippling?: InputMaybe<UpdateRipplingDirectoryInput>;
  sftp?: InputMaybe<UpdateSftpDirectoryInput>;
  workday?: InputMaybe<UpdateWorkdayDirectoryInput>;
};

export type UpdateDirectoryResult =
  | DirectoryNotFound
  | DirectoryProviderErrors
  | DirectoryUpdated
  | InvalidSshKey;

export type UpdateEnvironmentLocalizationInput = {
  defaultLocale?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  localizationEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEnvironmentLocalizationPayload = {
  environment: Environment;
};

export type UpdateEnvironmentOrganizationAdminCollectionEnabledInput = {
  environmentId: Scalars['String'];
  organizationAdminCollectionEnabled: Scalars['Boolean'];
};

export type UpdateEnvironmentOrganizationAdminCollectionEnabledPayload = {
  environment: Environment;
};

export type UpdateEnvironmentSsoSigninConsentInput = {
  environmentId: Scalars['String'];
  ssoSignInConsentEnabled: Scalars['Boolean'];
};

export type UpdateEnvironmentSsoSigninConsentPayload = {
  environment: Environment;
};

export type UpdateFasterThanPossibleTravelInput = {
  decision?: InputMaybe<RadarDecision>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
  notifyUser?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFlagEnvironmentInput = {
  accessType: FlagEnvironmentAccessType;
  defaultEnabled: Scalars['Boolean'];
  flagEnabled: Scalars['Boolean'];
  flagEnvironmentId: Scalars['String'];
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateFlagEnvironmentResult =
  | FlagEnvironmentNotFound
  | FlagEnvironmentUpdated;

export type UpdateFlagInput = {
  description?: InputMaybe<Scalars['String']>;
  flagId: Scalars['String'];
  name: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateFlagResult = FlagNotFound | FlagUpdated;

export type UpdateFourthHrDirectoryInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateHibobDirectoryInput = {
  apiToken?: InputMaybe<Scalars['String']>;
  serviceUserId?: InputMaybe<Scalars['String']>;
};

export type UpdateIdpAttributesConfigInput = {
  dsyncCustomAttributeMappingEnabled: Scalars['Boolean'];
  idpAttributesConfigId: Scalars['String'];
  ssoCustomAttributeMappingEnabled: Scalars['Boolean'];
};

export type UpdateIdpAttributesConfigResult =
  | IdpAttributesConfigNotFound
  | IdpAttributesConfigUpdated;

export type UpdateInitiateLoginUrlResult =
  | EnvironmentNotFound
  | InitiateLoginUrlUpdated;

export type UpdateMigrationApplicationStatusInput = {
  id: Scalars['ID'];
  status: CustomerMigrationApplicationStatus;
};

export type UpdateMigrationApplicationStatusResult =
  | MigrationApplicationNotFound
  | UpdateMigrationApplicationStatusSuccess;

export type UpdateMigrationApplicationStatusSuccess = {
  application: CustomerMigrationApplication;
};

export type UpdateMigrationConnectionStatusInput = {
  customerMigrationId: Scalars['ID'];
  externalId: Scalars['String'];
  status: CustomerMigrationConnectionStatus;
};

export type UpdateMigrationConnectionStatusResult =
  | MigrationConnectionNotFound
  | UpdateMigrationConnectionStatusSuccess;

export type UpdateMigrationConnectionStatusSuccess = {
  externalId: Scalars['String'];
  status: CustomerMigrationConnectionStatus;
};

export type UpdateMigrationProxyStatusInput = {
  customerMigrationId: Scalars['ID'];
  status: CustomerMigrationProxyStatus;
};

export type UpdateMigrationProxyStatusResult =
  | CustomerMigrationNotFound
  | UpdateMigrationProxyStatusSuccess;

export type UpdateMigrationProxyStatusSuccess = {
  customerMigration: CustomerMigration;
};

export type UpdateMyselfInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpdateMyselfResult = MyselfUpdated;

export type UpdateOauthCredentialsInput = {
  appleKeyId?: InputMaybe<Scalars['String']>;
  applePrivateKey?: InputMaybe<Scalars['String']>;
  appleTeamId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  customScopes?: InputMaybe<Array<Scalars['String']>>;
  isUserlandEnabled?: InputMaybe<Scalars['Boolean']>;
  oauthCredentialId: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  returnProviderTokens?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOauthCredentialsResult =
  | InvalidOauthCredentials
  | OauthCredentialsNotFound
  | OauthCredentialsUpdated;

export type UpdateOidcConnectionInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  discoveryEndpoint?: InputMaybe<Scalars['String']>;
  returnProviderTokens?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationPayload = {
  organization?: Maybe<Organization>;
};

export type UpdateOrganizationResult =
  | ConsumerDomainForbidden
  | ExternalIdAlreadyUsed
  | UpdateOrganizationPayload;

export type UpdatePeopleHrDirectoryInput = {
  apiKey?: InputMaybe<Scalars['String']>;
};

export type UpdatePermissionInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissionId: Scalars['String'];
};

export type UpdatePermissionResult = PermissionNotFound | PermissionUpdated;

export type UpdatePersonioDirectoryInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
};

export type UpdatePortalSettingsInput = {
  defaultConnectionSuccessLink?: InputMaybe<Scalars['String']>;
  defaultDirectorySuccessLink?: InputMaybe<Scalars['String']>;
  defaultDomainVerificationSuccessLink?: InputMaybe<Scalars['String']>;
  defaultLogStreamsSuccessLink?: InputMaybe<Scalars['String']>;
  defaultRedirectLink?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdatePortalSettingsResult =
  | InvalidRedirectUri
  | PortalSettingsUpdated;

export type UpdateRadarConfigurationInput = {
  botDetection?: InputMaybe<UpdateBotDetectionInput>;
  bruteForceAttack?: InputMaybe<UpdateBruteForceAttackInput>;
  credentialStuffing?: InputMaybe<UpdateCredentialStuffingInput>;
  fasterThanPossibleTravel?: InputMaybe<UpdateFasterThanPossibleTravelInput>;
  repeatSignUp?: InputMaybe<UpdateRepeatSignUpInput>;
  staleAccount?: InputMaybe<UpdateStaleAccountInput>;
  unrecognizedDevice?: InputMaybe<UpdateUnrecognizedDeviceInput>;
};

export type UpdateRadarModeInput = {
  environmentId: Scalars['String'];
  radarMode: RadarMode;
};

export type UpdateRadarSettingsInput = {
  configuration?: InputMaybe<UpdateRadarConfigurationInput>;
  environmentId: Scalars['String'];
  smsChallengesEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRadarSettingsResult = RadarSettingsUpdated;

export type UpdateRepeatSignUpInput = {
  decision?: InputMaybe<RadarDecision>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRipplingDirectoryInput = {
  apiKey?: InputMaybe<Scalars['String']>;
};

export type UpdateRoleConfigInput = {
  defaultRole?: InputMaybe<Scalars['String']>;
  dsyncRoleAssignmentEnabled?: InputMaybe<Scalars['Boolean']>;
  multipleRolesEnabled?: InputMaybe<Scalars['Boolean']>;
  roleConfigId: Scalars['String'];
  rolePriorityOrder?: InputMaybe<Array<Scalars['String']>>;
  ssoRoleAssignmentEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRoleConfigResult = RoleConfigNotFound | RoleConfigUpdated;

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['String']>>;
  roleId: Scalars['String'];
};

export type UpdateRoleOnOrganizationMembershipInput = {
  organizationMembershipId: Scalars['String'];
  roleId?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateRoleOnOrganizationMembershipResult =
  | RoleNotFound
  | RoleOnOrganizationMembershipUpdated
  | UserlandUserOrganizationMembershipNotFound;

export type UpdateRoleResult = RoleNotFound | RoleUpdated;

export type UpdateSamlConnectionInput = {
  idpEntityId?: InputMaybe<Scalars['String']>;
  idpMetadataUrl?: InputMaybe<Scalars['String']>;
  idpUrl?: InputMaybe<Scalars['String']>;
  x509Certs?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateSessionInput = {
  currentEnvironmentId?: InputMaybe<Scalars['String']>;
  currentProjectID?: InputMaybe<Scalars['String']>;
};

export type UpdateSftpDirectoryInput = {
  publicKey?: InputMaybe<Scalars['String']>;
  sourceProvider?: InputMaybe<SftpSourceProvider>;
};

export type UpdateStaleAccountInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
  notifyUser?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateStripeConfigurationSuccess = {
  environment: Environment;
};

export type UpdateTeamDetailsInput = {
  name: Scalars['String'];
};

export type UpdateTeamDetailsResult =
  | InvalidTeamName
  | TeamDetailsUpdated
  | TeamNotFound;

export type UpdateTeamMfaRequirementInput = {
  requireMfa: Scalars['Boolean'];
};

export type UpdateTeamMfaRequirementResult =
  | TeamMfaIneligible
  | TeamMfaRequirementUpdated;

export type UpdateUnrecognizedDeviceInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  notifyAdmin?: InputMaybe<Scalars['Boolean']>;
  notifyUser?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserManagementActivatedInput = {
  activated: Scalars['Boolean'];
};

export type UpdateUserlandApplicationInput = {
  accessTokenExpiry?: InputMaybe<Scalars['Int']>;
  appHomepageUrl?: InputMaybe<Scalars['String']>;
  applicationId: Scalars['String'];
  inactivityTimeout?: InputMaybe<Scalars['Int']>;
  initiateLoginUri?: InputMaybe<Scalars['String']>;
  maxSessionTime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  passwordResetUrl?: InputMaybe<Scalars['String']>;
  signUpUrl?: InputMaybe<Scalars['String']>;
  userInvitationUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateUserlandApplicationResult =
  | UserlandApplicationNotFound
  | UserlandApplicationUpdated
  | UserlandApplicationValidationFailed;

export type UpdateUserlandEmailSettingsInput = {
  environmentId: Scalars['String'];
  isEmailVerificationEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isInvitationEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isMagicAuthEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  isResetPasswordEmailEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserlandEmailSettingsResult = UserlandEmailSettingsUpdated;

export type UpdateUserlandExternalLoginUriInput = {
  environmentId: Scalars['String'];
  externalLoginUri?: InputMaybe<Scalars['String']>;
};

export type UpdateUserlandExternalLoginUriResult =
  | EnvironmentNotFound
  | ExternalLoginUriNotAllowed
  | InvalidExternalLoginUri
  | InvalidExternalLoginUriProtocol
  | UserlandExternalLoginUriUpdated;

export type UpdateUserlandImpersonationSettingsInput = {
  environmentId: Scalars['String'];
  isEnabled: Scalars['Boolean'];
};

export type UpdateUserlandImpersonationSettingsResult =
  UserlandImpersonationSettingsUpdated;

export type UpdateUserlandPasswordAuthenticationConfigInput = {
  environmentId: Scalars['String'];
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserlandPasswordAuthenticationConfigResult =
  | EnvironmentNotFound
  | UserlandPasswordAuthenticationConfigUpdated;

export type UpdateUserlandSettingsInput = {
  accessTokenExpiry?: InputMaybe<Scalars['Int']>;
  allowSignUp?: InputMaybe<Scalars['Boolean']>;
  appHomepageUrl?: InputMaybe<Scalars['String']>;
  environmentId: Scalars['String'];
  inactivityTimeout?: InputMaybe<Scalars['Int']>;
  invitationExpiry?: InputMaybe<Scalars['Int']>;
  isAppleOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isAuthkitClientIdMetadataDocumentEnabled?: InputMaybe<Scalars['Boolean']>;
  isAuthkitDynamicClientRegistrationEnabled?: InputMaybe<Scalars['Boolean']>;
  isAuthkitEnabled?: InputMaybe<Scalars['Boolean']>;
  isAuthkitIdpInitiatedSsoEnabled?: InputMaybe<Scalars['Boolean']>;
  isBitbucketOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isDiscordOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isEmailVerificationRequired?: InputMaybe<Scalars['Boolean']>;
  isGitLabOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isGithubOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isGoogleOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isIntuitOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isLinkedInOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isMagicAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isMfaRequired?: InputMaybe<Scalars['Boolean']>;
  isMicrosoftOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasskeyAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasskeyProgressiveEnrollmentEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasswordAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasswordHistoryEnabled?: InputMaybe<Scalars['Boolean']>;
  isPasswordLowercaseRequired?: InputMaybe<Scalars['Boolean']>;
  isPasswordNumberRequired?: InputMaybe<Scalars['Boolean']>;
  isPasswordPwnedRequired?: InputMaybe<Scalars['Boolean']>;
  isPasswordSymbolRequired?: InputMaybe<Scalars['Boolean']>;
  isPasswordUppercaseRequired?: InputMaybe<Scalars['Boolean']>;
  isSalesforceOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isSlackOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isSsoEnabled?: InputMaybe<Scalars['Boolean']>;
  isVercelMarketplaceOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isVercelOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  isWaitlistEnabled?: InputMaybe<Scalars['Boolean']>;
  isXeroOauthEnabled?: InputMaybe<Scalars['Boolean']>;
  maxSessionTime?: InputMaybe<Scalars['Int']>;
  mfaEnabled?: InputMaybe<UserlandSettingsMfaEnabled>;
  passwordHistorySize?: InputMaybe<Scalars['Int']>;
  passwordMinimumLength?: InputMaybe<Scalars['Int']>;
  passwordMinimumStrength?: InputMaybe<Scalars['Int']>;
  passwordResetUrl?: InputMaybe<Scalars['String']>;
  signUpUrl?: InputMaybe<Scalars['String']>;
  userInvitationUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateUserlandSettingsResult = UserlandSettingsUpdated;

export type UpdateUserlandUserInput = {
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  userlandUserId: Scalars['String'];
};

export type UpdateUserlandUserResult =
  | ExternalIdAlreadyUsed
  | UserlandUserChangeEmailError
  | UserlandUserInvalidLocaleError
  | UserlandUserNotFound
  | UserlandUserUpdated;

export type UpdateWorkdayDirectoryInput = {
  groupEndpoint?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  userEndpoint?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdatedAllowList = {
  directoryGroupConfigs: Array<DirectoryGroupConfig>;
};

export type UploadCustomFontsInput = {
  fontFile1?: InputMaybe<Scalars['Upload']>;
  fontFile2?: InputMaybe<Scalars['Upload']>;
};

export type UploadCustomFontsResult =
  | CustomFontUploadError
  | CustomFontUploadResult;

export type UpsertActionsEndpointInput = {
  endpointUrl: Scalars['String'];
  environmentId: Scalars['String'];
  failOpen: Scalars['Boolean'];
  state: ActionsEndpointState;
  type: ActionsEndpointType;
};

export type UpsertActionsEndpointResult = ActionsEndpointUpserted;

export type UpsertAuth0CredentialInput = {
  apiDomain: Scalars['String'];
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  environmentId: Scalars['String'];
};

export type UpsertAuth0CredentialResult =
  | Auth0CredentialInvalid
  | Auth0CredentialUpdated;

export type UpsertConnectionGroupRoleMappingsInput = {
  connectionId: Scalars['String'];
  groupRoleMappingDefinitions: Array<GroupRoleMappingDefinitionInput>;
};

export type UpsertConnectionGroupRoleMappingsResult =
  | ConnectionNotFound
  | EnvironmentNotFound
  | GroupRoleMappingsUpserted;

export type UpsertDirectoryGroupRoleMappingsInput = {
  directoryId: Scalars['String'];
  groupRoleMappingDefinitions: Array<GroupRoleMappingDefinitionInput>;
};

export type UpsertDirectoryGroupRoleMappingsResult =
  | EnvironmentNotFound
  | GroupRoleMappingsUpserted;

export type UpsertGoogleAnalyticsConfigInput = {
  apiSecret?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  measurementId?: InputMaybe<Scalars['String']>;
};

export type UpsertGoogleAnalyticsConfigResult =
  | GoogleAnalyticsApiSecretInvalid
  | GoogleAnalyticsConfigUpserted
  | GoogleAnalyticsMeasurementIdInvalid;

export type UpsertJwtTemplateInput = {
  content: Scalars['String'];
  environmentId: Scalars['String'];
};

export type UpsertJwtTemplateResult =
  | JwtTemplateUpserted
  | JwtTemplateValidationError;

export type UpsertSamlX509CertificateInput = {
  connectionId: Scalars['String'];
  value: Scalars['String'];
};

export type UpsertSamlX509CertificateResult =
  | ConnectionNotFound
  | SamlX509CertificateUpserted;

export type UpsertSegmentConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  writeKey?: InputMaybe<Scalars['String']>;
};

export type UpsertSegmentConfigResult =
  | SegmentConfigUpserted
  | SegmentWriteKeyInvalid;

export type User = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMfaConfigured: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  users_teams: Array<UsersTeam>;
  workosUserId?: Maybe<Scalars['String']>;
};

export type UserAlreadyBelongsToAnotherTeam = {
  email: Scalars['String'];
};

export type UserAlreadyBelongsToCurrentTeam = {
  email: Scalars['String'];
};

export type UserAuthenticationFactor = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  state: UserAuthenticationFactorState;
  type: UserAuthenticationFactorType;
  updatedAt: Scalars['DateTime'];
};

export type UserAuthenticationFactorList = {
  data: Array<UserAuthenticationFactor>;
};

/** Represents if the factor has been activated. */
export enum UserAuthenticationFactorState {
  Active = 'Active',
  Pending = 'Pending',
}

/** Represents the possible types of additional authentication factors. */
export enum UserAuthenticationFactorType {
  Sms = 'Sms',
  Totp = 'Totp',
}

export type UserAuthenticationFactorVerified = {
  valid: Scalars['Boolean'];
};

export type UserInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role: UsersOrganizationsRole;
};

export type UserInvitedToTeam = {
  invitedMember: UsersTeam;
};

export type UserManagementActivated = {
  team: Team;
};

export type UserMetadata = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UserMfaSettingsReset = {
  userId: Scalars['String'];
};

export type UserNotAuthorized = {
  user: User;
};

export type UserNotInTeam = {
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserlandApplication = {
  accessTokenExpiry: Scalars['Int'];
  appHomepageUrl?: Maybe<Scalars['String']>;
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  environmentId: Scalars['String'];
  id: Scalars['ID'];
  inactivityTimeout?: Maybe<Scalars['Int']>;
  initiateLoginUri?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  keys: Array<Key>;
  logoutUris: Array<LogoutUri>;
  maxSessionTime: Scalars['Int'];
  name: Scalars['String'];
  passwordResetUrl?: Maybe<Scalars['String']>;
  redirectUris: Array<RedirectUri>;
  signUpUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userInvitationUrl?: Maybe<Scalars['String']>;
  webOrigins: Array<WebOrigin>;
};

export type UserlandApplicationCannotDeleteDefault = {
  /** The default application for an environment cannot be deleted. */
  message: Scalars['String'];
};

export type UserlandApplicationCreated = {
  userlandApplication: UserlandApplication;
};

export type UserlandApplicationDeleted = {
  applicationId: Scalars['String'];
};

export type UserlandApplicationKeyCreated = {
  key: NewlyCreatedKey;
};

export type UserlandApplicationKeyExpired = {
  expiredKey: Key;
  newKey?: Maybe<NewlyCreatedKey>;
};

export type UserlandApplicationList = {
  data: Array<UserlandApplication>;
  listMetadata: ListMetadata;
};

export type UserlandApplicationNotFound = {
  applicationId: Scalars['String'];
};

export type UserlandApplicationUpdated = {
  userlandApplication: UserlandApplication;
};

export type UserlandApplicationValidationFailed = {
  message: Scalars['String'];
};

export type UserlandEmailSettings = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isEmailVerificationEmailEnabled: Scalars['Boolean'];
  isInvitationEmailEnabled: Scalars['Boolean'];
  isMagicAuthEmailEnabled: Scalars['Boolean'];
  isResetPasswordEmailEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type UserlandEmailSettingsUpdated = {
  userlandEmailSettings: UserlandEmailSettings;
};

export type UserlandExternalLoginUriUpdated = {
  userlandSettings: UserlandSettings;
};

export type UserlandIdentity = {
  assignedResourceCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customAttributes: Scalars['JSONObject'];
  directoryUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organization: Organization;
  organizationId: Scalars['String'];
  role: Role;
  roles: Array<Role>;
  ssoProfile?: Maybe<Profile>;
  status: UserlandUserOrganizationMembershipStatus;
  type: UserlandUserOrganizationMembershipType;
  updatedAt: Scalars['DateTime'];
  userlandUserId: Scalars['String'];
};

export type UserlandIdentityList = {
  data: Array<UserlandIdentity>;
  listMetadata: ListMetadata;
};

export type UserlandImpersonationSettingsUpdated = {
  userlandSettings: UserlandSettings;
};

export type UserlandPasswordAuthenticationConfig = {
  isEnabled: Scalars['Boolean'];
};

export type UserlandPasswordAuthenticationConfigUpdated = {
  environment: Environment;
};

export type UserlandSession = {
  application?: Maybe<UserlandApplication>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  impersonationReason?: Maybe<Scalars['String']>;
  impersonator?: Maybe<User>;
  /** The impersonator's email address at the time of impersonation. This may be different if the user later changed their email address, so prefer the value from `impersonator` when available. */
  impersonatorEmail?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  provider: SessionProvider;
  state: UserlandSessionState;
  updatedAt: Scalars['DateTime'];
  userAgent?: Maybe<Scalars['String']>;
};

export type UserlandSessionEphemeral = {
  /** Placeholder field to allow empty @ObjectType for UserlandSessionEphemeral. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type UserlandSessionExpired = {
  endedAt: Scalars['DateTime'];
};

export type UserlandSessionIssued = {
  expiresAt: Scalars['DateTime'];
};

export type UserlandSessionList = {
  data: Array<UserlandSession>;
  listMetadata: ListMetadata;
};

export type UserlandSessionRevoked = {
  endedAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
};

export type UserlandSessionState =
  | UserlandSessionEphemeral
  | UserlandSessionExpired
  | UserlandSessionIssued
  | UserlandSessionRevoked;

export enum UserlandSessionStateFilter {
  Ephemeral = 'Ephemeral',
  Issued = 'Issued',
  Revoked = 'Revoked',
}

export type UserlandSettings = {
  accessTokenExpiry: Scalars['Int'];
  allowSignUp: Scalars['Boolean'];
  appHomepageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  externalLoginUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inactivityTimeout?: Maybe<Scalars['Int']>;
  invitationExpiry: Scalars['Int'];
  isAppleOauthEnabled: Scalars['Boolean'];
  isAuthkitClientIdMetadataDocumentEnabled: Scalars['Boolean'];
  isAuthkitDynamicClientRegistrationEnabled: Scalars['Boolean'];
  isAuthkitEnabled: Scalars['Boolean'];
  isAuthkitIdpInitiatedSsoEnabled: Scalars['Boolean'];
  isBitbucketOauthEnabled: Scalars['Boolean'];
  isDiscordOauthEnabled: Scalars['Boolean'];
  isEmailVerificationRequired: Scalars['Boolean'];
  isGitLabOauthEnabled: Scalars['Boolean'];
  isGithubOauthEnabled: Scalars['Boolean'];
  isGoogleOauthEnabled: Scalars['Boolean'];
  isImpersonationEnabled: Scalars['Boolean'];
  isIntuitOauthEnabled: Scalars['Boolean'];
  isLinkedInOauthEnabled: Scalars['Boolean'];
  isMagicAuthEnabled: Scalars['Boolean'];
  isMfaRequired: Scalars['Boolean'];
  isMicrosoftOauthEnabled: Scalars['Boolean'];
  isPasskeyAuthEnabled: Scalars['Boolean'];
  isPasskeyProgressiveEnrollmentEnabled: Scalars['Boolean'];
  isPasswordAuthEnabled: Scalars['Boolean'];
  isPasswordHistoryEnabled: Scalars['Boolean'];
  isPasswordLowercaseRequired: Scalars['Boolean'];
  isPasswordNumberRequired: Scalars['Boolean'];
  isPasswordPwnedRequired: Scalars['Boolean'];
  isPasswordSymbolRequired: Scalars['Boolean'];
  isPasswordUppercaseRequired: Scalars['Boolean'];
  isSalesforceOauthEnabled: Scalars['Boolean'];
  isSlackOauthEnabled: Scalars['Boolean'];
  isSsoEnabled: Scalars['Boolean'];
  isVercelMarketplaceOauthEnabled: Scalars['Boolean'];
  isVercelOauthEnabled: Scalars['Boolean'];
  isWaitlistEnabled: Scalars['Boolean'];
  isXeroOauthEnabled: Scalars['Boolean'];
  maxSessionTime: Scalars['Int'];
  mfaEnabled: UserlandSettingsMfaEnabled;
  passwordHistorySize: Scalars['Int'];
  passwordMinimumLength: Scalars['Int'];
  passwordMinimumStrength: Scalars['Int'];
  passwordResetUrl?: Maybe<Scalars['String']>;
  signUpUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userInvitationUrl?: Maybe<Scalars['String']>;
};

/** The configuration for MFA for the environment. */
export enum UserlandSettingsMfaEnabled {
  Off = 'Off',
  Optional = 'Optional',
  Required = 'Required',
}

export type UserlandSettingsUpdated = {
  userlandSettings: UserlandSettings;
};

export type UserlandUser = {
  appleOauthProfile?: Maybe<Profile>;
  authenticationFactors: Array<UserlandUserAuthenticationFactor>;
  bitbucketOauthProfile?: Maybe<Profile>;
  createdAt: Scalars['DateTime'];
  dataInstallations: Array<DataInstallation>;
  directoryUser?: Maybe<DirectoryUser>;
  discordOauthProfile?: Maybe<Profile>;
  email: Scalars['String'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  githubOauthProfile?: Maybe<Profile>;
  gitlabOauthProfile?: Maybe<Profile>;
  googleOauthProfile?: Maybe<Profile>;
  hasPassword: Scalars['Boolean'];
  id: Scalars['ID'];
  identities: UserlandIdentityList;
  identity?: Maybe<UserlandIdentity>;
  intuitOauthProfile?: Maybe<Profile>;
  lastName?: Maybe<Scalars['String']>;
  lastSignedInAt?: Maybe<Scalars['DateTime']>;
  linkedinOauthProfile?: Maybe<Profile>;
  locale?: Maybe<Scalars['String']>;
  metadata: Array<UserMetadata>;
  microsoftOauthProfile?: Maybe<Profile>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  salesforceOauthProfile?: Maybe<Profile>;
  sessionCount: Scalars['Int'];
  sessions: UserlandSessionList;
  slackOauthProfile?: Maybe<Profile>;
  ssoProfile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime'];
  vercelMarketplaceOauthProfile?: Maybe<Profile>;
  vercelOauthProfile?: Maybe<Profile>;
  xeroOauthProfile?: Maybe<Profile>;
};

export type UserlandUserDataInstallationsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type UserlandUserIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type UserlandUserIdentityArgs = {
  organizationMembershipId: Scalars['String'];
};

export type UserlandUserSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  provider?: InputMaybe<SessionProvider>;
  states?: InputMaybe<Array<UserlandSessionStateFilter>>;
};

export type UserlandUserAddedToOrganization = {
  organization: Organization;
  userlandUser: UserlandUser;
};

export type UserlandUserAlreadyInvited = {
  organizationId: Scalars['String'];
  userlandUserId: Scalars['String'];
};

export type UserlandUserAuthenticationFactor = {
  factorType: UserlandUserAuthenticationFactorTypeData;
  id: Scalars['ID'];
  lastVerifiedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Please use `factorType` instead. */
  type: UserlandUserAuthenticationFactorType;
};

export enum UserlandUserAuthenticationFactorType {
  Totp = 'Totp',
  WebAuthn = 'WebAuthn',
}

export type UserlandUserAuthenticationFactorTypeData =
  | UserlandUserTotpAuthenticationFactorType
  | UserlandUserWebAuthnAuthenticationFactorType;

export type UserlandUserAuthenticationFactorsReset = {
  userlandUser: UserlandUser;
};

/** Authentication methods available to userland users. */
export enum UserlandUserAuthenticationMethod {
  AppleOAuth = 'AppleOAuth',
  DiscordOAuth = 'DiscordOAuth',
  GitHubOAuth = 'GitHubOAuth',
  GitLabOAuth = 'GitLabOAuth',
  GoogleOAuth = 'GoogleOAuth',
  LinkedInOAuth = 'LinkedInOAuth',
  MicrosoftOAuth = 'MicrosoftOAuth',
  None = 'None',
  Passkey = 'Passkey',
  Password = 'Password',
  Sso = 'SSO',
  SlackOAuth = 'SlackOAuth',
  XeroOAuth = 'XeroOAuth',
}

export type UserlandUserChangeEmailError = {
  reason: UserlandUserChangeEmailReason;
};

/** The reason why an email change failed. */
export enum UserlandUserChangeEmailReason {
  DirectoryOwnsEmail = 'DirectoryOwnsEmail',
  EmailNotAvailable = 'EmailNotAvailable',
  InvalidEmail = 'InvalidEmail',
  NotImplemented = 'NotImplemented',
  SsoIdpOwnsEmail = 'SsoIdpOwnsEmail',
}

export type UserlandUserCreated = {
  userlandUser: UserlandUser;
};

export type UserlandUserDeleted = {
  userlandUserId: Scalars['String'];
};

export type UserlandUserEmailInvalidFormat = {
  message: Scalars['String'];
};

export type UserlandUserEmailNotAvailable = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type UserlandUserImpl = UserlandUser & {
  appleOauthProfile?: Maybe<Profile>;
  authenticationFactors: Array<UserlandUserAuthenticationFactor>;
  bitbucketOauthProfile?: Maybe<Profile>;
  createdAt: Scalars['DateTime'];
  dataInstallations: Array<DataInstallation>;
  directoryUser?: Maybe<DirectoryUser>;
  discordOauthProfile?: Maybe<Profile>;
  email: Scalars['String'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  githubOauthProfile?: Maybe<Profile>;
  gitlabOauthProfile?: Maybe<Profile>;
  googleOauthProfile?: Maybe<Profile>;
  hasPassword: Scalars['Boolean'];
  id: Scalars['ID'];
  identities: UserlandIdentityList;
  identity?: Maybe<UserlandIdentity>;
  intuitOauthProfile?: Maybe<Profile>;
  lastName?: Maybe<Scalars['String']>;
  lastSignedInAt?: Maybe<Scalars['DateTime']>;
  linkedinOauthProfile?: Maybe<Profile>;
  locale?: Maybe<Scalars['String']>;
  metadata: Array<UserMetadata>;
  microsoftOauthProfile?: Maybe<Profile>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  salesforceOauthProfile?: Maybe<Profile>;
  sessionCount: Scalars['Int'];
  sessions: UserlandSessionList;
  slackOauthProfile?: Maybe<Profile>;
  ssoProfile?: Maybe<Profile>;
  updatedAt: Scalars['DateTime'];
  vercelMarketplaceOauthProfile?: Maybe<Profile>;
  vercelOauthProfile?: Maybe<Profile>;
  xeroOauthProfile?: Maybe<Profile>;
};

export type UserlandUserImplDataInstallationsArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type UserlandUserImplIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  organizationId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type UserlandUserImplIdentityArgs = {
  organizationMembershipId: Scalars['String'];
};

export type UserlandUserImplSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  provider?: InputMaybe<SessionProvider>;
  states?: InputMaybe<Array<UserlandSessionStateFilter>>;
};

export type UserlandUserInvalidLocaleError = {
  locale: Scalars['String'];
};

export type UserlandUserInvite = {
  acceptedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inviteeEmail: Scalars['String'];
  organization?: Maybe<Organization>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  state: UserlandUserInviteState;
  token: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserlandUserInviteCreated = {
  userlandUserInvite: UserlandUserInvite;
};

export type UserlandUserInviteList = {
  data: Array<UserlandUserInvite>;
  listMetadata: ListMetadata;
};

export type UserlandUserInviteNotFound = {
  userlandUserInviteId: Scalars['String'];
};

export type UserlandUserInviteNotPending = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type UserlandUserInviteResent = {
  userlandUserInvite: UserlandUserInvite;
};

export type UserlandUserInviteRevoked = {
  userlandUserInvite: UserlandUserInvite;
};

/** The state of a user invite. */
export enum UserlandUserInviteState {
  Accepted = 'Accepted',
  Expired = 'Expired',
  Pending = 'Pending',
  Revoked = 'Revoked',
}

export type UserlandUserList = {
  data: Array<UserlandUser>;
  listMetadata: ListMetadata;
};

export type UserlandUserNotFound = {
  userlandUserId: Scalars['String'];
};

export type UserlandUserOrganizationMembership = {
  createdAt: Scalars['DateTime'];
  directoryUserId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organizationId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  status: UserlandUserOrganizationMembershipStatus;
  type: UserlandUserOrganizationMembershipType;
  updatedAt: Scalars['DateTime'];
  userlandUserId: Scalars['String'];
};

export type UserlandUserOrganizationMembershipDeactivated = {
  userlandUserOrganizationMembership: UserlandUserOrganizationMembership;
};

export type UserlandUserOrganizationMembershipList = {
  organizationMemberships: Array<UserlandUserOrganizationMembership>;
};

export type UserlandUserOrganizationMembershipNotFound = {
  message: Scalars['String'];
};

export type UserlandUserOrganizationMembershipReactivated = {
  userlandUserOrganizationMembership: UserlandUserOrganizationMembership;
};

/** The status of a user organization membership. */
export enum UserlandUserOrganizationMembershipStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
}

/** The type of a user organization membership. */
export enum UserlandUserOrganizationMembershipType {
  Automatic = 'Automatic',
  Manual = 'Manual',
}

export type UserlandUserOrganizationMembershipsByUserIdsArgs = {
  organizationId: Scalars['String'];
  userlandUserIds: Array<Scalars['String']>;
};

export type UserlandUserPasswordContainsEmail = {
  message: Scalars['String'];
};

export type UserlandUserPasswordMissingCharacterType = {
  characterType: PasswordCharacterType;
  symbols?: Maybe<Scalars['String']>;
};

export type UserlandUserPasswordPwned = {
  occurrences: Scalars['Float'];
};

export type UserlandUserPasswordReused = {
  message: Scalars['String'];
};

export type UserlandUserPasswordTooLong = {
  maximumLength: Scalars['Float'];
};

export type UserlandUserPasswordTooShort = {
  minimumLength: Scalars['Float'];
};

export type UserlandUserPasswordTooWeak = {
  score: Scalars['Float'];
  suggestions: Array<Scalars['String']>;
  warning: Scalars['String'];
};

export type UserlandUserRemovedFromOrganization = {
  organization: Organization;
  userlandUser: UserlandUser;
};

/** Filter users by their session status - Active (has sessions) or Inactive (no sessions). */
export enum UserlandUserSessionStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

/** Fields available for sorting userland users. */
export enum UserlandUserSortField {
  Email = 'Email',
  LastSignInAt = 'LastSignInAt',
  SignInCount = 'SignInCount',
}

export type UserlandUserTotpAuthenticationFactorType = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

export type UserlandUserUpdated = {
  userlandUser: UserlandUser;
};

export type UserlandUserValidationError =
  | UserlandUserEmailInvalidFormat
  | UserlandUserEmailNotAvailable
  | UserlandUserPasswordContainsEmail
  | UserlandUserPasswordMissingCharacterType
  | UserlandUserPasswordPwned
  | UserlandUserPasswordReused
  | UserlandUserPasswordTooLong
  | UserlandUserPasswordTooShort
  | UserlandUserPasswordTooWeak;

export type UserlandUserValidationFailed = {
  errors: Array<UserlandUserValidationError>;
};

export type UserlandUserWebAuthnAuthenticationFactorType = {
  /** Placeholder field to allow empty @ObjectType. */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

/** Roles a user can have in an organization. */
export enum UsersOrganizationsRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Support = 'SUPPORT',
}

/** States a user can have in an organization. */
export enum UsersOrganizationsState {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
}

export type UsersTeam = {
  complianceTermsAcceptedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invitationExpiry?: Maybe<Scalars['DateTime']>;
  isInvitationExpired: Scalars['Boolean'];
  isManagedByDirectory: Scalars['Boolean'];
  role: UsersOrganizationsRole;
  state: UsersOrganizationsState;
  team: Team;
  user: User;
  user_id: Scalars['String'];
};

export type ValidateJwtTemplateInput = {
  environmentId: Scalars['String'];
  template: Scalars['String'];
};

export type ValidateJwtTemplateResult = JwtTemplateValidationResult;

export enum VaultKeyProvider {
  AwsKms = 'AWS_KMS',
  AzureKeyVault = 'AZURE_KEY_VAULT',
  GcpKms = 'GCP_KMS',
  WosVault = 'WOS_VAULT',
}

export type VaultKeySettings = {
  contextKey?: Maybe<Scalars['String']>;
  contextValue?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  keyProvider?: Maybe<VaultKeyProvider>;
  organizationId: Scalars['String'];
  organizationName?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  status: VaultKeyStatus;
  updatedAt: Scalars['DateTime'];
};

export type VaultKeySettingsList = {
  data: Array<VaultKeySettings>;
  listMetadata: ListMetadata;
};

export enum VaultKeyStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  InvalidPermissions = 'InvalidPermissions',
  Validating = 'Validating',
}

export type VerificationResult = {
  customEmailDomain: CustomEmailDomain;
};

export type VerifyAuthenticationFactorEnrollmentInput = {
  challengeId: Scalars['String'];
  code: Scalars['String'];
};

export type VerifyAuthenticationFactorEnrollmentResult =
  UserAuthenticationFactorVerified;

export type VerifyCustomEmailDomainResult = VerificationResult;

export type VerifyDomainStatusInput = {
  domain: Scalars['String'];
};

export type VerifyDomainStatusResult =
  | DomainStatusChecked
  | OauthCredentialsNotFound;

export type VerifyRedirectUriInput = {
  environmentId: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type VerifyRedirectUriResult =
  | OauthCredentialsNotFound
  | RedirectUriChecked;

export type WaitlistEntryApproveError = {
  message: Scalars['String'];
};

export type WaitlistEntryApproved = {
  waitlistEntry: WaitlistEntryType;
};

export type WaitlistEntryList = {
  data: Array<WaitlistEntryType>;
  listMetadata: ListMetadata;
};

export enum WaitlistEntryState {
  Approved = 'Approved',
  Pending = 'Pending',
}

export type WaitlistEntryType = {
  approvedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  state: WaitlistEntryState;
  updatedAt: Scalars['DateTime'];
};

export type WebOrigin = {
  id: Scalars['ID'];
  origin: Scalars['String'];
};

export type WebOriginsList = {
  origins: Array<Scalars['String']>;
};

export type WebOriginsSet = {
  origins: Array<Scalars['String']>;
};

export type Webhook = {
  attempt: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  deliverAfter?: Maybe<Scalars['DateTime']>;
  event: Scalars['String'];
  id: Scalars['ID'];
  metadata: Scalars['JSON'];
  requestBody?: Maybe<Scalars['JSON']>;
  responseBody?: Maybe<Scalars['JSON']>;
  responseStatusCode?: Maybe<Scalars['Int']>;
  state: WebhookState;
  webhookEndpointId: Scalars['String'];
};

export type WebhookEndpoint = {
  createdAt: Scalars['DateTime'];
  endpointUrl: Scalars['String'];
  events: Array<Scalars['String']>;
  id: Scalars['ID'];
  secret: Scalars['String'];
  state: WebhookEndpointState;
  statistics?: Maybe<WebhookEndpointStatistics>;
  webhooks: WebhookList;
};

export type WebhookEndpointWebhooksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<PaginationOrder>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<WebhookState>;
};

export type WebhookEndpointList = {
  data: Array<WebhookEndpoint>;
  listMetadata: ListMetadata;
};

/** Enum represents the state of the webhook endpoint. */
export enum WebhookEndpointState {
  Active = 'Active',
  InActive = 'InActive',
}

export type WebhookEndpointStatistics = {
  aggregatePeriodDays: Scalars['Int'];
  deliveredCount: Scalars['Int'];
  deliveryRate?: Maybe<Scalars['Float']>;
  failedCount: Scalars['Int'];
  id: Scalars['ID'];
  inProgressCount: Scalars['Int'];
  scheduledCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type WebhookEvent = {
  category: WebhookEventCategory;
  description: Scalars['String'];
  fixtures: Array<WebhookFixture>;
  id: Scalars['ID'];
};

/** Enum represents event category types of Webhooks. */
export enum WebhookEventCategory {
  ApiKey = 'ApiKey',
  Authentication = 'Authentication',
  Connection = 'Connection',
  Directory = 'Directory',
  DirectoryGroup = 'DirectoryGroup',
  DirectoryUser = 'DirectoryUser',
  EmailVerification = 'EmailVerification',
  Flag = 'Flag',
  Invitation = 'Invitation',
  MagicAuth = 'MagicAuth',
  Organization = 'Organization',
  OrganizationDomain = 'OrganizationDomain',
  OrganizationMembership = 'OrganizationMembership',
  OrganizationRole = 'OrganizationRole',
  PasswordReset = 'PasswordReset',
  Permission = 'Permission',
  Role = 'Role',
  Session = 'Session',
  User = 'User',
}

/** Enum represents event fixtures of Webhooks. */
export enum WebhookEventFixtures {
  ApiKeyCreated = 'ApiKeyCreated',
  ApiKeyRevoked = 'ApiKeyRevoked',
  AuthenticationEmailVerificationSucceeded = 'AuthenticationEmailVerificationSucceeded',
  AuthenticationMagicAuthFailed = 'AuthenticationMagicAuthFailed',
  AuthenticationMagicAuthSucceeded = 'AuthenticationMagicAuthSucceeded',
  AuthenticationMfaSucceeded = 'AuthenticationMfaSucceeded',
  AuthenticationOauthFailed = 'AuthenticationOauthFailed',
  AuthenticationOauthSucceeded = 'AuthenticationOauthSucceeded',
  AuthenticationPasswordFailed = 'AuthenticationPasswordFailed',
  AuthenticationPasswordSucceeded = 'AuthenticationPasswordSucceeded',
  AuthenticationSsoFailed = 'AuthenticationSsoFailed',
  AuthenticationSsoStarted = 'AuthenticationSsoStarted',
  AuthenticationSsoSucceeded = 'AuthenticationSsoSucceeded',
  AuthenticationSsoTimedOut = 'AuthenticationSsoTimedOut',
  ConnectionActivated = 'ConnectionActivated',
  ConnectionDeactivated = 'ConnectionDeactivated',
  ConnectionDeleted = 'ConnectionDeleted',
  ConnectionSamlCertificateRenewalRequired = 'ConnectionSamlCertificateRenewalRequired',
  ConnectionSamlCertificateRenewed = 'ConnectionSamlCertificateRenewed',
  DirectoryActivated = 'DirectoryActivated',
  DirectoryDeactivated = 'DirectoryDeactivated',
  DirectoryDeleted = 'DirectoryDeleted',
  EmailVerificationCreated = 'EmailVerificationCreated',
  FlagCreated = 'FlagCreated',
  FlagDeleted = 'FlagDeleted',
  FlagRuleUpdated = 'FlagRuleUpdated',
  FlagUpdated = 'FlagUpdated',
  GroupCreated = 'GroupCreated',
  GroupDeleted = 'GroupDeleted',
  GroupUpdated = 'GroupUpdated',
  InvitationAccepted = 'InvitationAccepted',
  InvitationCreated = 'InvitationCreated',
  InvitationRevoked = 'InvitationRevoked',
  MagicAuthCreated = 'MagicAuthCreated',
  OrganizationCreated = 'OrganizationCreated',
  OrganizationDeleted = 'OrganizationDeleted',
  OrganizationDomainCreated = 'OrganizationDomainCreated',
  OrganizationDomainDeleted = 'OrganizationDomainDeleted',
  OrganizationDomainUpdated = 'OrganizationDomainUpdated',
  OrganizationDomainVerificationFailed = 'OrganizationDomainVerificationFailed',
  OrganizationDomainVerified = 'OrganizationDomainVerified',
  OrganizationMembershipCreated = 'OrganizationMembershipCreated',
  OrganizationMembershipDeleted = 'OrganizationMembershipDeleted',
  OrganizationMembershipUpdated = 'OrganizationMembershipUpdated',
  OrganizationRoleCreated = 'OrganizationRoleCreated',
  OrganizationRoleDeleted = 'OrganizationRoleDeleted',
  OrganizationRoleUpdated = 'OrganizationRoleUpdated',
  OrganizationUpdated = 'OrganizationUpdated',
  PasswordResetCreated = 'PasswordResetCreated',
  PasswordResetSucceeded = 'PasswordResetSucceeded',
  PermissionCreated = 'PermissionCreated',
  PermissionDeleted = 'PermissionDeleted',
  PermissionUpdated = 'PermissionUpdated',
  RoleCreated = 'RoleCreated',
  RoleDeleted = 'RoleDeleted',
  RoleUpdated = 'RoleUpdated',
  SessionCreated = 'SessionCreated',
  SessionRevoked = 'SessionRevoked',
  UserAddedToGroup = 'UserAddedToGroup',
  UserCreated = 'UserCreated',
  UserDeleted = 'UserDeleted',
  UserManagementUserCreated = 'UserManagementUserCreated',
  UserManagementUserDeleted = 'UserManagementUserDeleted',
  UserManagementUserUpdated = 'UserManagementUserUpdated',
  UserRemovedFromGroup = 'UserRemovedFromGroup',
  UserUpdated = 'UserUpdated',
}

export type WebhookEventNotFound = {
  webhookId: Scalars['String'];
};

export type WebhookFixture = {
  name: Scalars['String'];
  payload: Scalars['String'];
};

export type WebhookList = {
  data: Array<Webhook>;
  listMetadata: ListMetadata;
};

/** Enum represents the state of the webhook. */
export enum WebhookState {
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Scheduled = 'Scheduled',
}

export type WildcardNotAllowedInEnvironment = {
  message: Scalars['String'];
  uri: Scalars['String'];
};

export type WorkOsAuthorizationCodeAlreadyExchangedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type WorkOsAuthorizationCodeExpiredError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type WorkOsSigninConsentDeniedError = {
  code: ConnectionSessionErrorCode;
  reason: Scalars['String'];
};

export type WorkdayDirectory = {
  groupEndpoint?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  userEndpoint?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type CurrentEnvironmentFragment = {
  id: string;
  project: {
    id: string;
    name: string;
    environments: Array<{
      id: string;
      clientId: string;
      name: string;
      customAuthDomain?: { domain: string } | null;
      preferredAuthkitDomain?: { domain: string } | null;
    }>;
  };
};

export type CurrentSessionFragment = {
  currentEnvironment: {
    id: string;
    project: {
      id: string;
      name: string;
      environments: Array<{
        id: string;
        clientId: string;
        name: string;
        customAuthDomain?: { domain: string } | null;
        preferredAuthkitDomain?: { domain: string } | null;
      }>;
    };
  };
};

export type CurrentUserFragment = {
  id: string;
  email: string;
  name?: string | null;
  teamMemberships: Array<{
    role: UsersOrganizationsRole;
    team: { id: string; name: string };
  }>;
};

export type KeyFragment = { id: string; displayValue: string };

export type CurrentSessionQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentSessionQuery = {
  session: {
    currentEnvironment: {
      id: string;
      project: {
        id: string;
        name: string;
        environments: Array<{
          id: string;
          clientId: string;
          name: string;
          customAuthDomain?: { domain: string } | null;
          preferredAuthkitDomain?: { domain: string } | null;
        }>;
      };
    };
  };
};

export type KeysQueryVariables = Exact<{
  environmentId: Scalars['String'];
}>;

export type KeysQuery = {
  keys: { data: Array<{ id: string; displayValue: string }> };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  me: {
    id: string;
    email: string;
    name?: string | null;
    teamMemberships: Array<{
      role: UsersOrganizationsRole;
      team: { id: string; name: string };
    }>;
  };
};

export const CurrentEnvironmentFragmentDoc = `
    fragment CurrentEnvironment on Environment {
  id
  project: projectV2 {
    id
    name
    environments(type: Sandbox) {
      id
      clientId
      customAuthDomain {
        domain
      }
      name
      preferredAuthkitDomain {
        domain
      }
    }
  }
}
    `;
export const CurrentSessionFragmentDoc = `
    fragment CurrentSession on Session {
  currentEnvironment {
    ...CurrentEnvironment
  }
}
    ${CurrentEnvironmentFragmentDoc}`;
export const CurrentUserFragmentDoc = `
    fragment CurrentUser on User {
  id
  email
  name
  teamMemberships: users_teams {
    role
    team {
      id
      name
    }
  }
}
    `;
export const KeyFragmentDoc = `
    fragment Key on Key {
  id
  displayValue
}
    `;
export const CurrentSessionDocument = `
    query currentSession {
  session {
    ...CurrentSession
  }
}
    ${CurrentSessionFragmentDoc}`;

export const useCurrentSessionQuery = <
  TData = CurrentSessionQuery,
  TError = ClientError,
>(
  variables?: CurrentSessionQueryVariables,
  options?: Omit<
    UseQueryOptions<CurrentSessionQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<CurrentSessionQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<CurrentSessionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['currentSession']
        : ['currentSession', variables],
    queryFn: sdk<CurrentSessionQuery, CurrentSessionQueryVariables>(
      CurrentSessionDocument,
      variables,
    ),
    ...options,
  });
};

useCurrentSessionQuery.getKey = (variables?: CurrentSessionQueryVariables) =>
  variables === undefined ? ['currentSession'] : ['currentSession', variables];

useCurrentSessionQuery.fetcher = (
  variables?: CurrentSessionQueryVariables,
  options?: RequestInit['headers'],
) =>
  sdk<CurrentSessionQuery, CurrentSessionQueryVariables>(
    CurrentSessionDocument,
    variables,
    options,
  );

export const KeysDocument = `
    query keys($environmentId: String!) {
  keys(environmentId: $environmentId, scope: Active) {
    data {
      ...Key
    }
  }
}
    ${KeyFragmentDoc}`;

export const useKeysQuery = <TData = KeysQuery, TError = ClientError>(
  variables: KeysQueryVariables,
  options?: Omit<UseQueryOptions<KeysQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<KeysQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<KeysQuery, TError, TData>({
    queryKey: ['keys', variables],
    queryFn: sdk<KeysQuery, KeysQueryVariables>(KeysDocument, variables),
    ...options,
  });
};

useKeysQuery.getKey = (variables: KeysQueryVariables) => ['keys', variables];

useKeysQuery.fetcher = (
  variables: KeysQueryVariables,
  options?: RequestInit['headers'],
) => sdk<KeysQuery, KeysQueryVariables>(KeysDocument, variables, options);

export const MeDocument = `
    query me {
  me {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

export const useMeQuery = <TData = MeQuery, TError = ClientError>(
  variables?: MeQueryVariables,
  options?: Omit<UseQueryOptions<MeQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<MeQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<MeQuery, TError, TData>({
    queryKey: variables === undefined ? ['me'] : ['me', variables],
    queryFn: sdk<MeQuery, MeQueryVariables>(MeDocument, variables),
    ...options,
  });
};

useMeQuery.getKey = (variables?: MeQueryVariables) =>
  variables === undefined ? ['me'] : ['me', variables];

useMeQuery.fetcher = (
  variables?: MeQueryVariables,
  options?: RequestInit['headers'],
) => sdk<MeQuery, MeQueryVariables>(MeDocument, variables, options);
